import { flexbox, layout, space, system, typography, color, grid } from 'styled-system';
import { Close, AlertFilled, ChevronDown, ChevronUp, ChevronLeft, ChevronRight, SuccessFilled, Star, Minus, Plus, ClearFieldFilled, CalendarOutlined, SearchOutlined } from '@ifood/pomodoro-icons';
import styled, { css, keyframes, ThemeContext, ThemeProvider, useTheme } from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { pick } from '@styled-system/props';
import PropTypes__default, { number, func, oneOf } from 'prop-types';
import React, { useReducer, useCallback, useEffect, useRef, createContext, useContext, useState, useMemo, Children, forwardRef, isValidElement, useLayoutEffect } from 'react';
import usePortal from 'react-useportal';
import isPropValid from '@emotion/is-prop-valid';
import mapValues from 'lodash.mapvalues';
import omit from 'lodash.omit';
import tokens from '@ifood/pomodoro-tokens';
import { usePopper } from 'react-popper';
import debounce from 'lodash.debounce';
import { useSelect, useCombobox, useMultipleSelection } from 'downshift';
import range from 'lodash.range';
import segmentize from 'segmentize';
import { ToastContainer, toast } from 'react-toastify';
import merge from 'deepmerge';
import DayPickerPackage__default, { DateUtils } from 'react-day-picker';
import { format, parse } from 'date-fns';
import Tabs$1, { TabPane } from 'rc-tabs';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { useDropzone } from 'react-dropzone';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var gap = /*#__PURE__*/system({
  gap: {
    property: 'gap',
    scale: 'space'
  }
});
var Centered = /*#__PURE__*/css( /*#__PURE__*/_templateObject());
var Flex = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2(), function (props) {
  return props.centered ? Centered : css(_templateObject3());
}, flexbox, layout, space, gap);

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: black;\n  overflow: hidden;\n  z-index: 1;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", ";\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: 2;\n  padding: ", ";\n  background: ", ";\n  ", "\n  ", "\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1(), function (props) {
  return props.zIndexCustom;
});
var Content = /*#__PURE__*/styled(motion.div)( /*#__PURE__*/_templateObject2$1(), function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.colors.white;
}, space, layout);
var Header = /*#__PURE__*/styled(Flex)( /*#__PURE__*/_templateObject3$1(), function (props) {
  return props.theme.space.regular;
});
var Icon = /*#__PURE__*/styled(Close)( /*#__PURE__*/_templateObject4(), function (props) {
  return props.theme.colors.primary;
});
var Background = /*#__PURE__*/styled(motion.div)( /*#__PURE__*/_templateObject5());

var stopBubbling = function stopBubbling(event) {
  event.stopPropagation();
  /* persisting the event is necessary to be compatible with React 16 or less */

  event.persist();
};

var getNativeEvent = function getNativeEvent(event) {
  return event.nativeEvent instanceof MouseEvent ? event.nativeEvent : event.nativeEvent.changedTouches[0];
};

var clampValue = function clampValue(value, range) {
  var min = range[0],
      max = range[1];
  if (value < min) return min;
  if (value > max) return max;
  return value;
};

var getPosition = function getPosition(event, clamped) {
  if (clamped === void 0) {
    clamped = true;
  }

  var nativeEvent = getNativeEvent(event);
  var target = nativeEvent.target;
  var parentNode = target.parentNode;

  var _parentNode$getBoundi = parentNode.getBoundingClientRect(),
      left = _parentNode$getBoundi.left,
      top = _parentNode$getBoundi.top,
      width = _parentNode$getBoundi.width,
      height = _parentNode$getBoundi.height;

  var clientX = nativeEvent.clientX,
      clientY = nativeEvent.clientY;
  var relativeX = clientX - left;
  var relativeY = clientY - top;

  if (clamped) {
    return {
      x: clampValue(relativeX, [0, width]),
      y: clampValue(relativeY, [0, height]),
      percentageX: clampValue(relativeX / width, [0, 1]),
      percentageY: clampValue(relativeY / height, [0, 1])
    };
  }

  return {
    x: relativeX,
    y: relativeY,
    percentageX: relativeX / width,
    percentageY: relativeY / height
  };
};

var DragReducer = function DragReducer(state, action) {
  switch (action.type) {
    case 'DRAG_START':
      return _extends({}, state, {
        isMousePressed: true,
        position: getPosition(action.event, action.clamped)
      });

    case 'DRAGGING':
      return _extends({}, state, {
        position: getPosition(action.event, action.clamped)
      });

    case 'DRAG_STOP':
      return _extends({}, state, {
        isMousePressed: false
      });

    default:
      return _extends({}, state);
  }
};

var useDrag = function useDrag(_temp) {
  var _ref = _temp === void 0 ? {
    clamped: false
  } : _temp,
      _ref$clamped = _ref.clamped,
      clamped = _ref$clamped === void 0 ? false : _ref$clamped;

  var _useReducer = useReducer(DragReducer, {
    isMousePressed: false,
    position: {
      x: 0,
      y: 0,
      percentageX: 0,
      percentageY: 0
    }
  }),
      _useReducer$ = _useReducer[0],
      isMousePressed = _useReducer$.isMousePressed,
      position = _useReducer$.position,
      dispatch = _useReducer[1];

  var dragStart = useCallback(function (event) {
    stopBubbling(event);
    dispatch({
      type: 'DRAG_START',
      event: event,
      clamped: clamped
    });
  }, [dispatch, clamped]);
  var dragging = useCallback(function (event) {
    if (isMousePressed) {
      stopBubbling(event);
      dispatch({
        type: 'DRAGGING',
        event: event,
        clamped: clamped
      });
    }
  }, [dispatch, isMousePressed, clamped]);
  var dragStop = useCallback(function (event) {
    stopBubbling(event);
    dispatch({
      type: 'DRAG_STOP',
      event: event
    });
  }, [dispatch]);
  return {
    isMousePressed: isMousePressed,
    position: position,
    binders: {
      onMouseDown: dragStart,
      onTouchStart: dragStart,
      onMouseMove: dragging,
      onTouchMove: dragging,
      onMouseUp: dragStop,
      onTouchEnd: dragStop
    }
  };
};

var useLockBody = function useLockBody(open) {
  if (open === void 0) {
    open = true;
  }

  useEffect(function () {
    if (document && document.body) {
      document.body.style.overflow = open ? 'hidden' : 'unset';
    }

    return function () {
      document.body.style.overflow = 'unset';
    };
  }, [open]);
};

var useEscapeToClose = function useEscapeToClose(open, onClose) {
  var elementToFocusRef = useRef(null);
  var previousFocusedElement = useRef(null);
  useEffect(function () {
    if (open) {
      var _elementToFocusRef$cu;

      previousFocusedElement.current = document.activeElement;
      (_elementToFocusRef$cu = elementToFocusRef.current) === null || _elementToFocusRef$cu === void 0 ? void 0 : _elementToFocusRef$cu.focus();
    } else {
      var _previousFocusedEleme;

      (_previousFocusedEleme = previousFocusedElement.current) === null || _previousFocusedEleme === void 0 ? void 0 : _previousFocusedEleme.focus();
    }
  }, [open]);

  var onKeyDown = function onKeyDown(e) {
    if (e.key === 'Escape' && onClose) {
      onClose(e);
    }
  };

  return {
    elementToFocusRef: elementToFocusRef,
    onKeyDown: onKeyDown
  };
};

var ICON_CLOSE = {
  'pt-br': {
    close: 'Fechar conteúdo'
  },
  'en-us': {
    close: 'Close content'
  },
  'es-mx': {
    close: 'Cerrar contenido'
  },
  'es-co': {
    close: 'Cerrar contenido'
  }
};

var PomodoroContext = /*#__PURE__*/createContext({
  locale: 'en-us'
});

function useShareForwardedRef(forwardedRef) {
  // Final ref that will share value with forward ref. this is the one we will attach to components
  var innerRef = useRef(null);
  useEffect(function () {
    // After every render - try to share current ref value with forwarded ref
    if (!forwardedRef) {
      return;
    }

    if (typeof forwardedRef === 'function') {
      forwardedRef(innerRef.current);
      return;
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      forwardedRef.current = innerRef.current;
    }
  }, [innerRef, forwardedRef]);
  return innerRef;
}

function getBackgroundImageUrl(svg) {
  return "url(data:image/svg+xml;utf8," + encodeURIComponent(svg) + ")";
}

function mountTransition(transitions) {
  var parsedTransitions = transitions.map(function (transition) {
    return transition.filter(Boolean).join(' ');
  }).join(',');
  return parsedTransitions;
}

var pickHTMLProps = function pickHTMLProps(props) {
  return Object.entries(props).filter(function (_ref) {
    var prop = _ref[0];
    return isPropValid(prop);
  }).reduce(function (prevHtmlProps, _ref2) {
    var key = _ref2[0],
        value = _ref2[1];
    var htmlProps = prevHtmlProps;
    htmlProps[key] = value;
    return htmlProps;
  }, {});
};

var DEFAULT_SCALE_DICTIONARY = {
  fontSize: 'fontSizes',
  lineHeight: 'lineHeights'
};

var removeVariantKey = function removeVariantKey(styleFn) {
  return function (props) {
    var output = styleFn(props);
    var removedValue = output.variant;
    var wrappedMediaQueries = omit(output, 'variant');
    var unwrappedMediaQueries = mapValues(wrappedMediaQueries, function (value) {
      if ('variant' in value) return value.variant;
      return value;
    });
    return _extends({}, unwrappedMediaQueries, removedValue);
  };
};

var buildThemeValueMapper = function buildThemeValueMapper(dictionary, theme) {
  return function (value, key) {
    var variantScale = dictionary[key];
    var themeScale = theme[variantScale];

    if (Array.isArray(themeScale)) {
      throw new Error('Scale must be an object');
    }

    return themeScale === null || themeScale === void 0 ? void 0 : themeScale[value];
  };
};

var buildThemeValueTransformer = function buildThemeValueTransformer(theme, variantDictionary, defaultVariantKey) {
  return function transform(value, variants) {
    var mapThemeValue = buildThemeValueMapper(variantDictionary, theme);
    var keys = typeof value === 'string' ? value : defaultVariantKey;
    var tokens = variants[keys];
    var dictionary = mapValues(tokens, mapThemeValue);
    return dictionary;
  };
};

var responsiveVariant = function responsiveVariant(variants, variantsDictionary, defaultVariant) {
  if (variantsDictionary === void 0) {
    variantsDictionary = DEFAULT_SCALE_DICTIONARY;
  }

  if (defaultVariant === void 0) {
    defaultVariant = 'medium';
  }

  var variant = function variant(props) {
    var transform = buildThemeValueTransformer(props.theme, variantsDictionary, defaultVariant);
    var configWithInnerCSSProperties = {
      variant: {
        property: 'variant',
        defaultScale: variants,
        transform: transform
      }
    };
    var apply = system(configWithInnerCSSProperties);
    return apply(props);
  };

  return removeVariantKey(variant);
};

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  color: ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var BaseHeading = /*#__PURE__*/styled.h1( /*#__PURE__*/_templateObject$2(), function (props) {
  return props.theme.font.family.ifood.headings;
}, function (props) {
  return props.theme.colors.black;
}, /*#__PURE__*/responsiveVariant({
  smallest: {
    fontSize: 's',
    lineHeight: 'm'
  },
  small: {
    fontSize: 'm',
    lineHeight: 'm'
  },
  medium: {
    fontSize: 'l',
    lineHeight: 'l'
  },
  large: {
    fontSize: 'xl',
    lineHeight: 'xl'
  },
  regular: {
    fontSize: 'txl',
    lineHeight: 'm'
  }
}), space, layout, typography, color);

var Heading = function Heading(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'large' : _ref$variant,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h1' : _ref$as,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["variant", "as"]);

  var htmlProps = pickHTMLProps(otherProps);
  var styledSystemProps = pick(otherProps);
  return React.createElement(BaseHeading, Object.assign({
    as: as,
    variant: variant
  }, htmlProps, styledSystemProps));
};
Heading.propTypes = {
  variant: /*#__PURE__*/PropTypes__default.oneOf(['large', 'medium', 'small', 'smallest', 'regular']),
  as: /*#__PURE__*/PropTypes__default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'])
};

var ActionSheet = function ActionSheet(_ref) {
  var children = _ref.children,
      closeAriaLabel = _ref.closeAriaLabel,
      _ref$closeDataTestId = _ref.closeDataTestId,
      closeDataTestId = _ref$closeDataTestId === void 0 ? 'pomodoro-action-sheet-close' : _ref$closeDataTestId,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'pomodoro-action-sheet-root' : _ref$id,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      title = _ref.title,
      _ref$zIndexCustom = _ref.zIndexCustom,
      zIndexCustom = _ref$zIndexCustom === void 0 ? 999999999 : _ref$zIndexCustom,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["children", "closeAriaLabel", "closeDataTestId", "id", "isOpen", "onClose", "title", "zIndexCustom"]);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var _useEscapeToClose = useEscapeToClose(isOpen, onClose),
      elementToFocusRef = _useEscapeToClose.elementToFocusRef,
      onKeyDown = _useEscapeToClose.onKeyDown;

  useLockBody(isOpen);

  var _usePortal = usePortal(),
      Portal = _usePortal.Portal;

  var styledSystemProps = pick(otherProps);
  var htmlProps = pickHTMLProps(otherProps);
  return React.createElement(Portal, {
    id: id
  }, React.createElement(AnimatePresence, null, isOpen ? React.createElement(Wrapper, {
    zIndexCustom: zIndexCustom
  }, React.createElement(Content, Object.assign({
    initial: {
      opacity: 0,
      y: '100%'
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: '100%'
    },
    transition: {
      duration: 0.25
    }
  }, htmlProps, styledSystemProps, {
    tabIndex: 0,
    onKeyDown: onKeyDown,
    ref: elementToFocusRef
  }), React.createElement(Header, {
    alignItems: "center",
    justifyContent: "space-between"
  }, React.createElement(Heading, {
    variant: "small",
    as: "h3",
    margin: "0"
  }, title), React.createElement(Icon, {
    role: "button",
    onClick: onClose,
    "aria-label": closeAriaLabel || ICON_CLOSE[locale].close,
    "data-testid": closeDataTestId
  })), children), React.createElement(Background, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 0.5
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.15
    }
  })) : null));
};
ActionSheet.propTypes = {
  closeAriaLabel: PropTypes__default.string,
  closeDataTestId: PropTypes__default.string,
  isOpen: PropTypes__default.bool.isRequired,
  onClose: PropTypes__default.func.isRequired,
  title: PropTypes__default.string.isRequired,
  zIndexCustom: PropTypes__default.number
};

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: 0 ", ";\n    background: ", ";\n    border-radius: ", ";\n    margin-bottom: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    line-height: ", ";\n\n    > svg {\n      margin-right: ", ";\n    }\n  "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 48px;\n  border: 0;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  ", "\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var BaseActionSheetButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject$3(), function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$2(), theme.space.regular, theme.colors.grayLight, theme.radii.s, theme.space.regular, theme.colors.black, theme.fonts.primary, theme.fontSizes.s, theme.lineHeights.m, theme.space.regular);
});

var ActionSheetButton = function ActionSheetButton(_ref) {
  var text = _ref.text,
      onClick = _ref.onClick,
      icon = _ref.icon,
      actionSheetButtonDataTestId = _ref.actionSheetButtonDataTestId,
      props = _objectWithoutPropertiesLoose(_ref, ["text", "onClick", "icon", "actionSheetButtonDataTestId"]);

  return React.createElement(BaseActionSheetButton, Object.assign({
    onClick: onClick,
    "data-testid": actionSheetButtonDataTestId || 'action-sheet-button',
    type: "button"
  }, props), icon && icon, text);
};
ActionSheetButton.propTypes = {
  actionSheetButtonDataTestId: PropTypes__default.string,
  icon: PropTypes__default.node,
  onClick: PropTypes__default.func.isRequired,
  text: PropTypes__default.string.isRequired
};

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var AttentionAlert = /*#__PURE__*/css( /*#__PURE__*/_templateObject$4(), function (props) {
  return props.theme.colors.attention;
}, function (props) {
  return props.theme.colors.attention;
});

var CLOSE = {
  'pt-br': {
    close: 'Fechar notificação'
  },
  'en-us': {
    close: 'Close notification'
  },
  'es-mx': {
    close: 'Cerrar notificación'
  },
  'es-co': {
    close: 'Cerrar notificación'
  }
};

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-style: normal;\n  color: ", ";\n  font-weight: normal;\n\n  margin-top: ", ";\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var Description = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$5(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.space.small;
});

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var ErrorAlert = /*#__PURE__*/css( /*#__PURE__*/_templateObject$6(), function (props) {
  return props.theme.colors.error;
}, function (props) {
  return props.theme.colors.error;
});

var IconSizeMap = {
  xs: '16px',
  s: '24px',
  m: '36px',
  l: '48px'
};

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  font-size: 0;\n  ", "\n  ", "\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var Container = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$7(), space, layout);
var Icon$1 = function Icon(_ref) {
  var Component = _ref.component,
      height = _ref.height,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      svgProps = _ref.svgProps,
      width = _ref.width,
      props = _objectWithoutPropertiesLoose(_ref, ["component", "height", "size", "svgProps", "width"]);

  return React.createElement(Container, Object.assign({}, props), React.createElement(Component, Object.assign({
    height: height || IconSizeMap[size],
    width: width || IconSizeMap[size]
  }, svgProps)));
};
Icon$1.propTypes = {
  component: PropTypes__default.func.isRequired,
  height: PropTypes__default.string,
  width: PropTypes__default.string,
  size: /*#__PURE__*/PropTypes__default.oneOf(['xs', 's', 'm', 'l']),
  svgProps: PropTypes__default.object
};

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}
var InfoAlert = /*#__PURE__*/css( /*#__PURE__*/_templateObject$8(), function (props) {
  return props.theme.colors.informative;
}, function (props) {
  return props.theme.colors.informative;
});

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var RequiredAlert = /*#__PURE__*/css( /*#__PURE__*/_templateObject$9(), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primaryDark;
}, function (props) {
  return props.theme.colors.white;
});

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
var SuccessAlert = /*#__PURE__*/css( /*#__PURE__*/_templateObject$a(), function (props) {
  return props.theme.colors.positive;
}, function (props) {
  return props.theme.colors.positive;
});

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-left: ", ";\n  padding-right: ", ";\n  pointer-events: all;\n  margin-left: auto;\n  color: ", ";\n\n  width: ", ";\n\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-left: ", ";\n  padding-right: ", ";\n\n  margin-top: 1px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border-width: 1px;\n  border-top-width: 4px;\n  border-style: solid;\n  border-radius: ", ";\n\n  font-family: ", ";\n  font-style: normal;\n  font-weight: bold;\n\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
var NeutralAlert = /*#__PURE__*/css( /*#__PURE__*/_templateObject$b(), function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.grayDarker;
});
var BaseAlert = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$3(), function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smaller;
}, NeutralAlert, function (props) {
  return props.variant === 'success' ? SuccessAlert : css(_templateObject3$2());
}, function (props) {
  return props.variant === 'required' ? RequiredAlert : css(_templateObject4$1());
}, function (props) {
  return props.variant === 'attention' ? AttentionAlert : css(_templateObject5$1());
}, function (props) {
  return props.variant === 'error' ? ErrorAlert : css(_templateObject6());
}, function (props) {
  return props.variant === 'informative' ? InfoAlert : css(_templateObject7());
}, space, layout);
var IconContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject8(), function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
});
var CloseIconContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject9(), function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.variant === 'required' ? RequiredAlert : css(_templateObject10());
});
var CloseIcon = /*#__PURE__*/styled(Icon$1)( /*#__PURE__*/_templateObject11());
/**
 * Alert Component
 */

var Alert = function Alert(_ref) {
  var allowClose = _ref.allowClose,
      children = _ref.children,
      closeAriaLabel = _ref.closeAriaLabel,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? AlertFilled : _ref$icon,
      onClose = _ref.onClose,
      title = _ref.title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'neutral' : _ref$variant,
      props = _objectWithoutPropertiesLoose(_ref, ["allowClose", "children", "closeAriaLabel", "icon", "onClose", "title", "variant"]);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var _useState = useState(true),
      shouldRender = _useState[0],
      setShouldRender = _useState[1];

  var handleClick = useCallback(function () {
    setShouldRender(false);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [onClose]);

  if (!shouldRender) {
    return null;
  }

  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);
  return React.createElement(BaseAlert, Object.assign({
    variant: variant
  }, htmlProps, styledSystemProps), React.createElement(IconContainer, null, React.createElement(Icon$1, {
    component: icon,
    size: "xs"
  })), React.createElement("div", null, title, children), React.createElement(CloseIconContainer, {
    variant: variant
  }, allowClose && React.createElement(CloseIcon, {
    role: "button",
    onClick: handleClick,
    component: Close,
    size: "xs",
    tabIndex: 0,
    "aria-label": closeAriaLabel || CLOSE[locale].close
  })));
};
Alert.Description = Description;
Alert.propTypes = {
  allowClose: PropTypes__default.bool,
  closeAriaLabel: PropTypes__default.string,
  onClose: PropTypes__default.func,
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  icon: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.node, PropTypes__default.func]),
  title: PropTypes__default.string.isRequired,
  variant: /*#__PURE__*/PropTypes__default.oneOf(['neutral', 'attention', 'informative', 'required', 'success', 'error'])
};

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n        padding: ", ";\n      "]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n        cursor: progress;\n        background-color: ", ";\n        &:hover:not(:active):not(:disabled) {\n          background-color: ", ";\n        }\n      "]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}
var getLoadingStyle = function getLoadingStyle(color) {
  return function (props) {
    return props.isLoading ? css(_templateObject$c(), props.theme.colors[color], props.theme.colors[color]) : css(_templateObject2$4());
  };
};
var getReducedStyle = function getReducedStyle(props) {
  return props.reduced ? css(_templateObject3$3(), props.theme.space.smaller) : css(_templateObject4$2());
};

function _templateObject3$4() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}
var PrimaryButton = /*#__PURE__*/css( /*#__PURE__*/_templateObject$d(), function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.fontSizes.m;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.shadows.focus;
}, function (props) {
  return props.theme.colors.primaryDark;
}, function (props) {
  return props.theme.colors.primaryLight;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
}, /*#__PURE__*/getLoadingStyle('primaryDark'), getReducedStyle);
var PrimaryInformationButton = /*#__PURE__*/css( /*#__PURE__*/_templateObject2$5(), function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.fontSizes.m;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.theme.colors.information;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.shadows.focus;
}, function (props) {
  return props.theme.colors.information;
}, function (props) {
  return props.theme.colors.informationLight;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
}, /*#__PURE__*/getLoadingStyle('information'), getReducedStyle);
var PrimaryInvertedButton = /*#__PURE__*/css( /*#__PURE__*/_templateObject3$4(), function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.fontSizes.m;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.shadows.focus;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.primaryLight;
}, function (props) {
  return props.theme.colors.primaryLightest;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
}, /*#__PURE__*/getLoadingStyle('primaryLight'), getReducedStyle);

function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: transparent;\n  font-family: ", ";\n  text-decoration: underline;\n  font-weight: normal;\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  padding: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: transparent;\n  font-family: ", ";\n  text-decoration: underline;\n  font-weight: normal;\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    color: ", ";\n    background-color: transparent;\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: transparent;\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: transparent;\n  }\n\n  ", "\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}
var TertiaryButton = /*#__PURE__*/css( /*#__PURE__*/_templateObject$e(), function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.fontSizes.m;
}, function (props) {
  return props.theme.lineHeights.l;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.shadows.focus;
}, function (props) {
  return props.theme.colors.primaryLight;
}, function (props) {
  return props.theme.colors.grayDarker;
}, getReducedStyle);
var TertiaryInvertedButton = /*#__PURE__*/css( /*#__PURE__*/_templateObject2$6(), function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.fontSizes.m;
}, function (props) {
  return props.theme.lineHeights.l;
}, function (props) {
  return props.theme.colors.primaryLightest;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.shadows.focus;
}, function (props) {
  return props.theme.colors.primaryLight;
}, function (props) {
  return props.theme.colors.grayDarker;
}, getReducedStyle);

function _templateObject$f() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n  font-family: ", ";\n  font-weight: bold;\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}
var CTAButton = /*#__PURE__*/css( /*#__PURE__*/_templateObject$f(), function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.larger;
}, function (props) {
  return props.theme.space.larger;
}, function (props) {
  return props.theme.fontSizes.l;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.shadows.focus;
}, function (props) {
  return props.theme.colors.primaryDark;
}, function (props) {
  return props.theme.colors.primaryLight;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
}, /*#__PURE__*/getLoadingStyle('primaryDark'));

var LOADING = {
  'pt-br': {
    label: 'Carregando'
  },
  'en-us': {
    label: 'Loading'
  },
  'es-mx': {
    label: 'Cargando'
  },
  'es-co': {
    label: 'Cargando'
  }
};

function _templateObject2$7() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: white;\n  animation: fade 0.8s ease-in-out alternate infinite;\n\n  &:nth-of-type(1) {\n    animation-delay: -0.4s;\n  }\n\n  &:nth-of-type(2) {\n    animation-delay: -0.2s;\n  }\n\n  &:not(:first-of-type) {\n    margin-left: 5px;\n  }\n\n  @keyframes fade {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$g() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$g());
var Dot = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$7());
var Loading = function Loading() {
  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  return React.createElement(Wrapper$1, {
    "aria-label": LOADING[locale].label
  }, React.createElement(Dot, null), React.createElement(Dot, null), React.createElement(Dot, null));
};

function _templateObject$h() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 24px;\n  height: 24px;\n  background-color: ", ";\n  color: ", ";\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  border-radius: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", ";\n  line-height: 6px;\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}
var Container$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$h(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radii.l;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.xs;
});

var Badge = function Badge(_ref) {
  var count = _ref.count;
  return React.createElement(Container$1, null, count);
};
Badge.propTypes = {
  count: number.isRequired
};

function _templateObject$i() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  border: solid 1px ", ";\n  padding-top: calc(", " - 1px);\n  padding-bottom: calc(", " - 1px);\n  padding-left: ", ";\n  padding-right: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  background-color: ", ";\n  color: ", ";\n  font-family: ", ";\n\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  &:active {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:hover:not(:active):not(:disabled) {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n    border: solid 1px ", ";\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject$i = function _templateObject() {
    return data;
  };

  return data;
}
var SecondaryButton = /*#__PURE__*/css( /*#__PURE__*/_templateObject$i(), function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.fontSizes.m;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.shadows.focus;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.primaryLight;
}, function (props) {
  return props.theme.colors.primaryLightest;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.grayLight;
}, function (props) {
  return props.theme.colors.gray;
}, /*#__PURE__*/getLoadingStyle('primaryLight'), getReducedStyle);

function _templateObject10$1() {
  var data = _taggedTemplateLiteralLoose(["\n  visibility: hidden;\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteralLoose(["\n          text-align: ", ";\n        "]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$j() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  cursor: pointer;\n  transition: ", ";\n\n  border: 0;\n  font-weight: normal;\n\n  ", "\n\n  ", "\n\n", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  &:disabled {\n    cursor: default;\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject$j = function _templateObject() {
    return data;
  };

  return data;
}
var BaseButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject$j(), function (_ref) {
  var _ref$theme = _ref.theme,
      durations = _ref$theme.durations,
      timingFunctions = _ref$theme.timingFunctions;
  return mountTransition([['background-color', durations.promptly, timingFunctions.easeInOut], ['box-shadow', durations.quickly, timingFunctions.easeInOut]]);
}, PrimaryButton, function (props) {
  return props.variant === 'primary-inverted' ? PrimaryInvertedButton : css(_templateObject2$8());
}, function (props) {
  return props.variant === 'primary-information' ? PrimaryInformationButton : css(_templateObject3$5());
}, function (props) {
  return props.variant === 'cta' ? CTAButton : css(_templateObject4$3());
}, function (props) {
  return props.variant === 'secondary' ? SecondaryButton : css(_templateObject5$2());
}, function (props) {
  return props.variant === 'tertiary' ? TertiaryButton : css(_templateObject6$1());
}, function (props) {
  return props.variant === 'tertiary-inverted' ? TertiaryInvertedButton : css(_templateObject7$1());
}, function (props) {
  return props.textAlign ? css(_templateObject8$1(), props.textAlign) : css(_templateObject9$1());
}, space, layout);
var HiddenContainer = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject10$1());
var Button = function Button(_ref2) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'primary' : _ref2$variant,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      children = _ref2.children,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      _ref2$reduced = _ref2.reduced,
      reduced = _ref2$reduced === void 0 ? false : _ref2$reduced,
      _ref2$badgeValue = _ref2.badgeValue,
      badgeValue = _ref2$badgeValue === void 0 ? null : _ref2$badgeValue,
      props = _objectWithoutPropertiesLoose(_ref2, ["variant", "className", "children", "isLoading", "reduced", "badgeValue"]);

  var isLoadingVisible = isLoading && variant !== 'tertiary' && variant !== 'tertiary-inverted';
  var showBadge = badgeValue && variant === 'secondary' ? badgeValue : null;
  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);
  return React.createElement(BaseButton, Object.assign({
    variant: variant,
    isLoading: isLoading,
    reduced: reduced,
    className: className
  }, htmlProps, styledSystemProps), isLoadingVisible ? React.createElement(React.Fragment, null, React.createElement(Loading, null), React.createElement(HiddenContainer, null, children)) : React.createElement(React.Fragment, null, showBadge && React.createElement(Badge, {
    count: showBadge
  }), children));
};
Button.propTypes = {
  isLoading: PropTypes__default.bool,
  variant: /*#__PURE__*/PropTypes__default.oneOf(['cta', 'primary', 'primary-inverted', 'primary-information', 'secondary', 'tertiary', 'tertiary-inverted']),
  reduced: PropTypes__default.bool,
  textAlign: /*#__PURE__*/PropTypes__default.oneOf(['left', 'center', 'right']),
  badgeValue: PropTypes__default.number
};

function _templateObject$k() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-color: ", ";\n"]);

  _templateObject$k = function _templateObject() {
    return data;
  };

  return data;
}
var PrimaryCard = /*#__PURE__*/css( /*#__PURE__*/_templateObject$k(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.grayLight;
});

function _templateObject$l() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"]);

  _templateObject$l = function _templateObject() {
    return data;
  };

  return data;
}
var SecondaryCard = /*#__PURE__*/css( /*#__PURE__*/_templateObject$l(), function (props) {
  return props.theme.colors.grayLight;
});

function _templateObject$m() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"]);

  _templateObject$m = function _templateObject() {
    return data;
  };

  return data;
}
var TertiaryCard = /*#__PURE__*/css( /*#__PURE__*/_templateObject$m(), function (props) {
  return props.theme.colors.gray;
});

function _templateObject6$2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  padding: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$n() {
  var data = _taggedTemplateLiteralLoose(["\n  box-shadow: ", ";\n"]);

  _templateObject$n = function _templateObject() {
    return data;
  };

  return data;
}
var ElevatedCard = /*#__PURE__*/css( /*#__PURE__*/_templateObject$n(), function (props) {
  return props.theme.shadows.elevate;
});
var BaseCard = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$9(), function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.space.regular;
}, PrimaryCard, function (props) {
  return props.variant === 'primary' ? PrimaryCard : css(_templateObject3$6());
}, function (props) {
  return props.variant === 'secondary' ? SecondaryCard : css(_templateObject4$4());
}, function (props) {
  return props.variant === 'tertiary' ? TertiaryCard : css(_templateObject5$3());
}, function (props) {
  return props.elevated ? ElevatedCard : css(_templateObject6$2());
}, space, layout);
/**
 * Card component
 */

var Card = function Card(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$elevated = _ref.elevated,
      elevated = _ref$elevated === void 0 ? false : _ref$elevated,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "elevated", "children"]);

  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);
  return React.createElement(BaseCard, Object.assign({
    variant: variant,
    elevated: elevated
  }, htmlProps, styledSystemProps), children);
};
Card.propTypes = {
  elevated: PropTypes__default.bool,
  variant: /*#__PURE__*/PropTypes__default.oneOf(['primary', 'secondary', 'tertiary'])
};

function _templateObject3$7() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  height: auto;\n  margin: ", ";\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$o() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  border: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  width: 100%;\n\n  display: flex;\n  align-items: center;\n\n  ", "\n  ", "\n"]);

  _templateObject$o = function _templateObject() {
    return data;
  };

  return data;
}
var Container$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$o(), function (props) {
  return "solid 1px " + props.theme.colors.gray;
}, function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.space.regular;
}, space, layout);
var AlertImage = /*#__PURE__*/styled.img( /*#__PURE__*/_templateObject2$a(), function (props) {
  return props.theme.space.regular;
});
var InnerContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$7());

var ContextualAlert = function ContextualAlert(_ref) {
  var children = _ref.children,
      imgSrc = _ref.imgSrc,
      imgAlt = _ref.imgAlt,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "imgSrc", "imgAlt"]);

  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);
  return React.createElement(Container$2, Object.assign({}, htmlProps, styledSystemProps), imgSrc && React.createElement(AlertImage, {
    src: imgSrc,
    alt: imgAlt
  }), React.createElement(InnerContainer, null, children));
};
ContextualAlert.propTypes = {
  imgSrc: PropTypes__default.string,
  imgAlt: PropTypes__default.string
};

function _templateObject3$8() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$p() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n  border-bottom: ", ";\n"]);

  _templateObject$p = function _templateObject() {
    return data;
  };

  return data;
}
var BaseCollapse = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$p(), function (props) {
  return props.theme.space.larger + " 0 " + props.theme.space.regular;
}, function (props) {
  return "" + ("1px solid " + props.theme.colors.gray);
});
var ChevronIconDown = /*#__PURE__*/styled(ChevronDown)( /*#__PURE__*/_templateObject2$b());
var ChevronIconUp = /*#__PURE__*/styled(ChevronUp)( /*#__PURE__*/_templateObject3$8());

var CONTENT = {
  'pt-br': {
    content: 'Abrir conteúdo'
  },
  'en-us': {
    content: 'Open content'
  },
  'es-mx': {
    content: 'Contenido abierto'
  },
  'es-co': {
    content: 'Contenido abierto'
  }
};

function _templateObject$q() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  color: ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject$q = function _templateObject() {
    return data;
  };

  return data;
}
var BaseText = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject$q(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.colors.black;
}, /*#__PURE__*/responsiveVariant({
  small: {
    fontSize: 'xs',
    lineHeight: 's'
  },
  medium: {
    fontSize: 's',
    lineHeight: 'm'
  },
  large: {
    fontSize: 'm',
    lineHeight: 'm'
  },
  regular: {
    fontSize: 'tsm',
    lineHeight: 's'
  }
}), space, layout, typography, color);

var Text = function Text(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'medium' : _ref$variant,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'span' : _ref$as,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["variant", "as"]);

  var styledSystemProps = pick(otherProps);
  var htmlProps = pickHTMLProps(otherProps);
  return React.createElement(BaseText, Object.assign({
    as: as,
    variant: variant
  }, htmlProps, styledSystemProps));
};
Text.propTypes = {
  variant: /*#__PURE__*/PropTypes__default.oneOf(['large', 'medium', 'small', 'regular']),
  as: /*#__PURE__*/PropTypes__default.oneOf(['p', 'span'])
};

var Collapse = function Collapse(_ref) {
  var title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      chevronDataTestId = _ref.chevronDataTestId,
      className = _ref.className,
      contentAriaLabel = _ref.contentAriaLabel,
      onChange = _ref.onChange,
      controlledIsExpanded = _ref.isExpanded,
      _ref$initializeExpand = _ref.initializeExpanded,
      initializeExpanded = _ref$initializeExpand === void 0 ? false : _ref$initializeExpand;

  var _React$useState = React.useState(initializeExpanded),
      showContent = _React$useState[0],
      setShowContent = _React$useState[1];

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var isControlled = controlledIsExpanded !== undefined;
  var isExpanded = isControlled ? controlledIsExpanded : showContent;
  var Chevron = isExpanded ? ChevronIconUp : ChevronIconDown;

  var handleChevronClick = function handleChevronClick() {
    if (!isControlled) {
      setShowContent(!isExpanded);
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(!isExpanded);
  };

  return React.createElement(BaseCollapse, {
    className: className
  }, description && React.createElement(Heading, {
    as: "h3",
    variant: "small",
    fontWeight: 500
  }, title), React.createElement(Flex, {
    justifyContent: "space-between"
  }, description ? React.createElement(Text, {
    color: tokens.colors.grayDarkest,
    fontFamily: tokens.fonts.primary,
    fontWeight: 300
  }, description) : React.createElement(Heading, {
    as: "h3",
    variant: "small",
    fontWeight: 500
  }, title), React.createElement(Chevron, {
    "data-testid": chevronDataTestId,
    color: tokens.colors.primary,
    fontSize: tokens.fontSizes.xl,
    onClick: handleChevronClick,
    "aria-label": contentAriaLabel || CONTENT[locale].content,
    role: "button",
    tabIndex: 0
  })), isExpanded && children);
};

var sizeMap = {
  s: '300px',
  m: '500px',
  l: '800px',
  xl: '60%'
};

function _templateObject6$3() {
  var data = _taggedTemplateLiteralLoose(["\n    ", " {\n      top: ", ";\n      right: ", ";\n    }\n  "]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  color: ", ";\n  z-index: 1;\n\n  ", "\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: black;\n  overflow: hidden;\n  z-index: 1;\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteralLoose(["\n    ", " {\n      width: 100%;\n      max-width: 100%;\n      max-height: 100%;\n      height: 100%;\n      border-radius: unset;\n    }\n  "]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$c() {
  var data = _taggedTemplateLiteralLoose(["\n  min-width: ", ";\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-height: 80%;\n  z-index: 2;\n  background: white;\n  border-radius: 6px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);\n  max-width: ", ";\n\n  ", "\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$r() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  z-index: ", ";\n"]);

  _templateObject$r = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$r(), function (_ref) {
  var zIndexCustom = _ref.zIndexCustom;
  return zIndexCustom;
});
var Container$3 = /*#__PURE__*/styled(motion.div)( /*#__PURE__*/_templateObject2$c(), sizeMap.s, function (props) {
  return sizeMap[props.size];
}, function (_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject3$9(), theme.mediaQueries.s);
});
var Background$1 = /*#__PURE__*/styled(motion.div)( /*#__PURE__*/_templateObject4$5());
var CloseIcon$1 = /*#__PURE__*/styled(Icon$1)( /*#__PURE__*/_templateObject5$4(), function (props) {
  return props.theme.space.larger;
}, function (props) {
  return props.theme.space.larger;
}, function (props) {
  return props.theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject6$3(), theme.mediaQueries.s, function (props) {
    return props.theme.space.regular;
  }, function (props) {
    return props.theme.space.large;
  });
});

function _templateObject2$d() {
  var data = _taggedTemplateLiteralLoose(["\n    ", " {\n      padding: 0 ", ";\n    }\n  "]);

  _templateObject2$d = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$s() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding: 0 ", ";\n  box-sizing: border-box;\n  max-height: 100%;\n  overflow: auto;\n\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject$s = function _templateObject() {
    return data;
  };

  return data;
}
var Body = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$s(), function (props) {
  return props.theme.space.larger;
}, function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$d(), theme.mediaQueries.s, function (props) {
    return props.theme.space.large;
  });
}, space, layout);

function _templateObject2$e() {
  var data = _taggedTemplateLiteralLoose(["\n    ", " {\n      padding: ", ";\n    }\n  "]);

  _templateObject2$e = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$t() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: auto;\n  padding: ", ";\n\n  display: flex;\n  justify-content: flex-end;\n\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject$t = function _templateObject() {
    return data;
  };

  return data;
}
var Footer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$t(), function (props) {
  return props.theme.space.larger;
}, function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$e(), theme.mediaQueries.s, function (props) {
    return props.theme.space.regular + " " + props.theme.space.large;
  });
}, space, layout);

function _templateObject2$f() {
  var data = _taggedTemplateLiteralLoose(["\n    ", " {\n      padding: ", ";\n    }\n  "]);

  _templateObject2$f = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$u() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n  padding-right: ", ";\n  box-sizing: border-box;\n  max-height: 100%;\n\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject$u = function _templateObject() {
    return data;
  };

  return data;
}
var Header$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$u(), function (props) {
  return props.theme.space.larger;
}, function (props) {
  return props.theme.space.loosest;
}, function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$f(), theme.mediaQueries.s, function (props) {
    return props.theme.space.regular + " " + props.theme.space.large;
  });
}, space, layout);

var CLOSE$1 = {
  'pt-br': {
    close: 'Fechar notificação'
  },
  'en-us': {
    close: 'Close notification'
  },
  'es-mx': {
    close: 'Cerrar notificación'
  },
  'es-co': {
    close: 'Cerrar notificación'
  }
};

var Dialog = function Dialog(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      closeAriaLabel = _ref.closeAriaLabel,
      open = _ref.open,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'pomodoro-modal-root' : _ref$id,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      _ref$zIndexCustom = _ref.zIndexCustom,
      zIndexCustom = _ref$zIndexCustom === void 0 ? 1000 : _ref$zIndexCustom,
      _ref$closeOnOverlayCl = _ref.closeOnOverlayClick,
      closeOnOverlayClick = _ref$closeOnOverlayCl === void 0 ? true : _ref$closeOnOverlayCl,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["children", "onClose", "closeAriaLabel", "open", "id", "size", "zIndexCustom", "closeOnOverlayClick"]);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var _useEscapeToClose = useEscapeToClose(open, onClose),
      elementToFocusRef = _useEscapeToClose.elementToFocusRef,
      onKeyDown = _useEscapeToClose.onKeyDown;

  useLockBody(open);

  var _usePortal = usePortal(),
      Portal = _usePortal.Portal;

  var styledSystemProps = pick(otherProps);
  var htmlProps = pickHTMLProps(otherProps);

  var handleOverlayClick = function handleOverlayClick() {
    if (closeOnOverlayClick) {
      onClose === null || onClose === void 0 ? void 0 : onClose();
    }
  };

  return React.createElement(Portal, {
    id: id
  }, React.createElement(AnimatePresence, null, open && React.createElement(Wrapper$2, {
    zIndexCustom: zIndexCustom,
    tabIndex: 0,
    onKeyDown: onKeyDown,
    ref: elementToFocusRef
  }, React.createElement(Container$3, Object.assign({
    initial: {
      opacity: 0,
      y: 100
    },
    animate: {
      opacity: 1,
      y: 0
    },
    exit: {
      opacity: 0,
      y: 100
    },
    transition: {
      duration: 0.25
    },
    size: size
  }, htmlProps, styledSystemProps), onClose ? React.createElement(CloseIcon$1, {
    role: "button",
    onClick: onClose,
    component: Close,
    size: "s",
    "aria-label": closeAriaLabel || CLOSE$1[locale].close
  }) : null, children), React.createElement(Background$1, {
    onClick: handleOverlayClick,
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 0.5
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.15
    }
  }))));
};
Dialog.Header = Header$1;
Dialog.Body = Body;
Dialog.Footer = Footer;
Dialog.propTypes = {
  onClose: PropTypes__default.func,
  closeAriaLabel: PropTypes__default.string,
  open: PropTypes__default.bool.isRequired,
  id: PropTypes__default.string
};

var useControlledVisibility = function useControlledVisibility(visible, setIsVisible) {
  useEffect(function () {
    setIsVisible(visible);
  }, [visible, setIsVisible]);
};

var useOneClickOutside = function useOneClickOutside(autoclose, referenceElement, isVisible, setIsVisible) {
  var handleClickOutside = useCallback(function (e) {
    if (referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.contains(e.target)) {
      return;
    }

    setIsVisible(false);
  }, [referenceElement, setIsVisible]);
  useEffect(function () {
    if (autoclose) {
      if (isVisible) {
        document.addEventListener('mousedown', handleClickOutside);
      } else {
        document.removeEventListener('mousedown', handleClickOutside);
      }
    }

    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [autoclose, isVisible, handleClickOutside]);
};

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n    &[data-popper-placement='right-start'],\n    &[data-popper-placement='left-start'] {\n      ", " {\n        &::before {\n          top: ", ";\n        }\n      }\n    }\n\n    &[data-popper-placement='right-end'],\n    &[data-popper-placement='left-end'] {\n      ", " {\n        &::before {\n          top: -", ";\n        }\n      }\n    }\n  "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 10;\n  opacity: ", ";\n  visibility: ", ";\n  transition: ", ";\n\n  ", "\n\n  ", ";\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: ", " ", ";\n    border-radius: ", ";\n    font-size: ", ";\n    box-shadow: ", ";\n    color: ", ";\n    background-color: ", ";\n\n    ", " {\n      &::before {\n        border-bottom: ", " solid\n          ", ";\n        background: transparent;\n      }\n    }\n  "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: ", " ", ";\n    border-radius: ", ";\n    font-size: ", ";\n    box-shadow: ", ";\n    color: ", ";\n    background-color: ", ";\n\n    ", " {\n      &::before {\n        border-bottom: ", " solid ", ";\n        background: transparent;\n      }\n    }\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$1() {
  var data = _taggedTemplateLiteralLoose(["\n    &[data-popper-placement^='left'] {\n      ", " {\n        right: -", ";\n\n        &::before {\n          transform: rotate(90deg);\n        }\n      }\n    }\n  "]);

  _templateObject11$1 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject10$2 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$2() {
  var data = _taggedTemplateLiteralLoose(["\n    &[data-popper-placement^='bottom'] {\n      ", " {\n        top: -", ";\n\n        &::before {\n          right: 50%;\n          left: 50%;\n          transform: translateX(-50%);\n        }\n      }\n    }\n  "]);

  _templateObject9$2 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteralLoose(["\n    &[data-popper-placement^='right'] {\n      ", " {\n        left: -", ";\n\n        &::before {\n          transform: rotate(-90deg);\n        }\n      }\n    }\n  "]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$5() {
  var data = _taggedTemplateLiteralLoose(["\n    &[data-popper-placement^='top'] {\n      ", " {\n        bottom: -", ";\n\n        &::before {\n          right: 50%;\n          left: 50%;\n          transform: translateX(-50%) rotate(180deg);\n        }\n      }\n    }\n  "]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$a() {
  var data = _taggedTemplateLiteralLoose(["\n    width: ", ";\n    height: ", ";\n\n    &::before {\n      display: inline-block;\n      position: absolute;\n      content: '';\n      width: 0;\n      height: 0;\n      top: 0;\n      border-left: ", " solid transparent;\n      border-right: ", " solid transparent;\n    }\n  "]);

  _templateObject3$a = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$g() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 10;\n\n  ", ";\n"]);

  _templateObject2$g = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$v() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  display: inline-block;\n\n  *:disabled {\n    pointer-events: none;\n  }\n"]);

  _templateObject$v = function _templateObject() {
    return data;
  };

  return data;
}
var TooltipReference = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$v());
var TooltipArrow = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$g(), function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject3$a(), theme.space.smaller, theme.space.smaller, theme.space.smaller, theme.space.smaller);
});
var ArrowTop = /*#__PURE__*/css( /*#__PURE__*/_templateObject4$6(), function (_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject5$5(), TooltipArrow, theme.space.smaller);
});
var ArrowRight = /*#__PURE__*/css( /*#__PURE__*/_templateObject6$4(), function (_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject7$2(), TooltipArrow, theme.space.small);
});
var ArrowBottom = /*#__PURE__*/css( /*#__PURE__*/_templateObject8$2(), function (_ref4) {
  var theme = _ref4.theme;
  return css(_templateObject9$2(), TooltipArrow, theme.space.smaller);
});
var ArrowLeft = /*#__PURE__*/css( /*#__PURE__*/_templateObject10$2(), function (_ref5) {
  var theme = _ref5.theme;
  return css(_templateObject11$1(), TooltipArrow, theme.space.smallest);
});
var NeutralVariant = /*#__PURE__*/css( /*#__PURE__*/_templateObject12(), function (_ref6) {
  var theme = _ref6.theme;
  return css(_templateObject13(), theme.space.smaller, theme.space.regular, theme.radii.m, theme.fontSizes.s, theme.shadows.elevate, theme.colors.white, theme.colors.black, TooltipArrow, theme.space.smaller, theme.colors.black);
});
var InformationVariant = /*#__PURE__*/css( /*#__PURE__*/_templateObject14(), function (_ref7) {
  var theme = _ref7.theme;
  return css(_templateObject15(), theme.space.regular, theme.space.large, theme.radii.m, theme.fontSizes.s, theme.shadows.elevate, theme.colors.black, theme.colors.informationLightest, TooltipArrow, theme.space.smaller, theme.colors.informationLightest);
});
var TooltipContent = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject16(), function (props) {
  return props.visible ? 1 : 0;
}, function (props) {
  return props.visible ? 'visible' : 'hidden';
}, function (_ref8) {
  var durations = _ref8.theme.durations;
  return mountTransition([['opacity', durations.immediately], ['visibility', durations.immediately]]);
}, function (_ref9) {
  var variant = _ref9.variant;

  switch (variant) {
    case 'neutral':
      return NeutralVariant;

    case 'information':
      return InformationVariant;

    case 'none':
    default:
      return null;
  }
}, function (_ref10) {
  var theme = _ref10.theme;
  return css(_templateObject17(), TooltipArrow, theme.space.smallest, TooltipArrow, theme.space.smaller);
}, ArrowTop, ArrowRight, ArrowBottom, ArrowLeft);

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      content = _ref.content,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'neutral' : _ref$variant,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _ref$autoclose = _ref.autoclose,
      autoclose = _ref$autoclose === void 0 ? false : _ref$autoclose,
      _ref$withArrow = _ref.withArrow,
      withArrow = _ref$withArrow === void 0 ? true : _ref$withArrow,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? [0, 12] : _ref$offset,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "content", "placement", "variant", "trigger", "visible", "autoclose", "withArrow", "offset"]);

  var _pickHTMLProps = pickHTMLProps(props),
      dataTestId = _pickHTMLProps['data-testid'],
      htmlProps = _objectWithoutPropertiesLoose(_pickHTMLProps, ["data-testid"]);

  var _useState = useState(visible),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useState2 = useState(null),
      referenceElement = _useState2[0],
      setReferenceElement = _useState2[1];

  var _useState3 = useState(null),
      popperElement = _useState3[0],
      setPopperElement = _useState3[1];

  var _useState4 = useState(null),
      arrowRef = _useState4[0],
      setArrowRef = _useState4[1];

  var modifiers = useMemo(function () {
    return [{
      name: 'arrow',
      options: {
        element: arrowRef
      }
    }, {
      name: 'flip',
      enabled: true,
      options: {
        allowedAutoPlacements: ['top', 'bottom']
      }
    }, {
      name: 'offset',
      options: {
        offset: offset
      }
    }];
  }, [arrowRef, offset]);

  var _usePopper = usePopper(referenceElement, popperElement, {
    placement: placement,
    modifiers: modifiers
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      update = _usePopper.update;

  var handleToggleVisibility = useCallback(function () {
    setIsVisible(function (state) {
      if (state) update === null || update === void 0 ? void 0 : update();
      return !state;
    });
  }, [update, setIsVisible]);
  var handleOnVisibility = useCallback(function () {
    update === null || update === void 0 ? void 0 : update();
    setIsVisible(true);
  }, [update, setIsVisible]);
  var handleOffVisibility = useCallback(function () {
    setIsVisible(false);
  }, [setIsVisible]);
  var triggers = useMemo(function () {
    switch (trigger) {
      case 'click':
        return {
          onClick: function onClick() {
            return handleToggleVisibility();
          }
        };

      case 'hover':
        return {
          onMouseEnter: function onMouseEnter() {
            return handleOnVisibility();
          },
          onMouseLeave: function onMouseLeave() {
            return handleOffVisibility();
          }
        };

      case 'none':
      default:
        return {};
    }
  }, [handleOffVisibility, handleOnVisibility, handleToggleVisibility, trigger]);
  useControlledVisibility(visible, setIsVisible);
  useOneClickOutside(autoclose, referenceElement, isVisible, setIsVisible);
  return React.createElement(React.Fragment, null, React.createElement(TooltipReference, Object.assign({
    ref: setReferenceElement
  }, triggers, htmlProps), children), React.createElement(TooltipContent, Object.assign({
    "data-testid": dataTestId,
    ref: setPopperElement,
    visible: isVisible,
    variant: variant,
    style: styles.popper
  }, attributes.popper), content, withArrow && React.createElement(TooltipArrow, {
    ref: setArrowRef,
    style: styles.arrow
  })));
};
Tooltip.propTypes = {
  content: /*#__PURE__*/PropTypes__default.oneOfType([/*#__PURE__*/PropTypes__default.arrayOf(PropTypes__default.node), PropTypes__default.node, PropTypes__default.string.isRequired]).isRequired,
  placement: /*#__PURE__*/PropTypes__default.oneOf(['auto', 'auto-start', 'auto-end', 'top', 'bottom', 'right', 'left', 'top-start', 'top-end', 'bottom-start', 'bottom-end', 'right-start', 'right-end', 'left-start', 'left-end']),
  variant: /*#__PURE__*/PropTypes__default.oneOf(['none', 'neutral', 'information']),
  trigger: /*#__PURE__*/PropTypes__default.oneOf(['none', 'hover', 'click']),
  visible: PropTypes__default.bool,
  autoclose: PropTypes__default.bool,
  withArrow: PropTypes__default.bool,
  offset: /*#__PURE__*/PropTypes__default.arrayOf(function (props) {
    return props.length > 2 ? new Error('offset must be an array with the settings: [X-axis, Y-axis]') : null;
  })
};

function _templateObject$w() {
  var data = _taggedTemplateLiteralLoose(["\n  border-width: 0 0 1px 0;\n  border-bottom-style: solid;\n  border-bottom-color: ", ";\n  ", "\n  ", "\n"]);

  _templateObject$w = function _templateObject() {
    return data;
  };

  return data;
}
var Divider = /*#__PURE__*/styled.hr( /*#__PURE__*/_templateObject$w(), function (props) {
  return props.theme.colors.gray;
}, space, layout);

function _templateObject8$3() {
  var data = _taggedTemplateLiteralLoose(["\n    ", " {\n      top: ", ";\n      right: ", ";\n    }\n  "]);

  _templateObject8$3 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$3() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  position: absolute;\n  top: ", ";\n  right: ", ";\n  color: ", ";\n\n  ", "\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$5() {
  var data = _taggedTemplateLiteralLoose(["\n      z-index: ", ";\n    "]);

  _templateObject6$5 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$6() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: black;\n  overflow: hidden;\n  opacity: 0.5;\n\n  ", ";\n"]);

  _templateObject5$6 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$7() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  z-index: 110;\n  background: white;\n\n  ", "\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$b() {
  var data = _taggedTemplateLiteralLoose(["\n        height: 100%;\n\n        @media (min-width: ", ") {\n          max-width: ", ";\n        }\n      "]);

  _templateObject3$b = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$h() {
  var data = _taggedTemplateLiteralLoose(["\n        @media (max-width: ", ") {\n          height: 100%;\n        }\n\n        @media (min-width: ", ") {\n          max-height: ", ";\n        }\n      "]);

  _templateObject2$h = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$x() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  z-index: ", ";\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: ", ";\n  align-items: ", ";\n  overflow: hidden;\n"]);

  _templateObject$x = function _templateObject() {
    return data;
  };

  return data;
}
var sizeMap$1 = {
  xs: '280px',
  s: '380px',
  m: '506px',
  l: '672px',
  xl: '768px'
};
var placementMap = {
  top: 'flex-start',
  left: 'flex-start',
  bottom: 'flex-end',
  right: 'flex-end'
};
var Wrapper$3 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$x(), function (_ref) {
  var zIndex = _ref.zIndex;
  return zIndex;
}, function (props) {
  return placementMap[props.placement];
}, function (props) {
  return placementMap[props.placement];
});

var getSizeStyle = function getSizeStyle(size, placement) {
  return ['top', 'bottom'].includes(placement) ? css(_templateObject2$h(), function (_ref2) {
    var theme = _ref2.theme;
    return theme.screens.s.max;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.screens.m.min;
  }, sizeMap$1[size]) : css(_templateObject3$b(), function (_ref4) {
    var theme = _ref4.theme;
    return theme.screens.m.min;
  }, sizeMap$1[size]);
};

var Container$4 = /*#__PURE__*/styled(motion.div)( /*#__PURE__*/_templateObject4$7(), function (props) {
  return getSizeStyle(props.size, props.placement);
});
var Background$2 = /*#__PURE__*/styled(motion.div)( /*#__PURE__*/_templateObject5$6(), function (props) {
  return css(_templateObject6$5(), props.parentZIndex && typeof props.parentZIndex === 'number' ? props.parentZIndex - 1 : 100);
});
var CloseIcon$2 = /*#__PURE__*/styled(Icon$1)( /*#__PURE__*/_templateObject7$3(), function (props) {
  return props.theme.space.larger;
}, function (props) {
  return props.theme.space.larger;
}, function (props) {
  return props.theme.colors.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return css(_templateObject8$3(), theme.mediaQueries.s, function (props) {
    return props.theme.space.regular;
  }, function (props) {
    return props.theme.space.large;
  });
});

function _templateObject2$i() {
  var data = _taggedTemplateLiteralLoose(["\n    ", " {\n      padding: 0 ", ";\n    }\n  "]);

  _templateObject2$i = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$y() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding: 0 ", ";\n  box-sizing: border-box;\n  max-height: 100%;\n  overflow: auto;\n\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject$y = function _templateObject() {
    return data;
  };

  return data;
}
var Body$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$y(), function (props) {
  return props.theme.space.larger;
}, function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$i(), theme.mediaQueries.s, function (props) {
    return props.theme.space.large;
  });
}, space, layout);

function _templateObject2$j() {
  var data = _taggedTemplateLiteralLoose(["\n    ", " {\n      padding: ", ";\n    }\n  "]);

  _templateObject2$j = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$z() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: auto;\n  padding: ", ";\n  display: flex;\n  justify-content: flex-end;\n\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject$z = function _templateObject() {
    return data;
  };

  return data;
}
var Footer$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$z(), function (props) {
  return props.theme.space.larger;
}, function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$j(), theme.mediaQueries.s, function (props) {
    return props.theme.space.regular + " " + props.theme.space.large;
  });
}, space, layout);

function _templateObject2$k() {
  var data = _taggedTemplateLiteralLoose(["\n    ", " {\n      padding: ", ";\n    }\n  "]);

  _templateObject2$k = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$A() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n  box-sizing: border-box;\n  max-height: 100%;\n\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject$A = function _templateObject() {
    return data;
  };

  return data;
}
var Header$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$A(), function (props) {
  return props.theme.space.larger;
}, function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$k(), theme.mediaQueries.s, function (props) {
    return props.theme.space.regular + " " + props.theme.space.large;
  });
}, space, layout);

var CLOSE$2 = {
  'pt-br': {
    close: 'Fechar notificação'
  },
  'en-us': {
    close: 'Close notification'
  },
  'es-mx': {
    close: 'Cerrar notificación'
  },
  'es-co': {
    close: 'Cerrar notificación'
  }
};

var animationsMap = {
  top: {
    y: '-100%'
  },
  left: {
    x: '-100%'
  },
  bottom: {
    y: '100%'
  },
  right: {
    x: '100%'
  }
};
var Drawer = function Drawer(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      closeAriaLabel = _ref.closeAriaLabel,
      open = _ref.open,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? 'pomodoro-modal-root' : _ref$id,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'xs' : _ref$size,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'right' : _ref$placement,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 1000 : _ref$zIndex,
      _ref$closeOnOverlayCl = _ref.closeOnOverlayClick,
      closeOnOverlayClick = _ref$closeOnOverlayCl === void 0 ? true : _ref$closeOnOverlayCl,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["children", "onClose", "closeAriaLabel", "open", "id", "size", "placement", "zIndex", "closeOnOverlayClick"]);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var _useEscapeToClose = useEscapeToClose(open, onClose),
      elementToFocusRef = _useEscapeToClose.elementToFocusRef,
      onKeyDown = _useEscapeToClose.onKeyDown;

  var wrapperRef = useRef(null);
  useLockBody(open);

  var _usePortal = usePortal({
    onPortalClick: function onPortalClick(_ref2) {
      var target = _ref2.target;
      var isClickingOutsideDrawer = target === wrapperRef.current;
      var shouldCloseDrawer = isClickingOutsideDrawer && closeOnOverlayClick;

      if (shouldCloseDrawer) {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    }
  }),
      Portal = _usePortal.Portal;

  var styledSystemProps = pick(otherProps);
  var htmlProps = pickHTMLProps(otherProps);
  return React.createElement(Portal, {
    id: id
  }, React.createElement(AnimatePresence, null, open && React.createElement(React.Fragment, null, React.createElement(Wrapper$3, {
    ref: wrapperRef,
    placement: placement,
    zIndex: zIndex
  }, React.createElement(Container$4, Object.assign({
    size: size,
    initial: _extends({
      opacity: 0
    }, animationsMap[placement]),
    animate: {
      opacity: 1,
      x: 0,
      y: 0
    },
    exit: _extends({
      opacity: 0
    }, animationsMap[placement]),
    transition: {
      duration: 0.25
    },
    placement: placement
  }, htmlProps, styledSystemProps, {
    tabIndex: 0,
    onKeyDown: onKeyDown,
    ref: elementToFocusRef
  }), onClose ? React.createElement(CloseIcon$2, {
    role: "button",
    onClick: onClose,
    component: Close,
    size: "s",
    "aria-label": closeAriaLabel || CLOSE$2[locale].close
  }) : null, children)), React.createElement(Background$2, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 0.5
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.15
    },
    parentZIndex: zIndex
  }))));
};
Drawer.Header = Header$2;
Drawer.Body = Body$1;
Drawer.Footer = Footer$1;
Drawer.propTypes = {
  onClose: PropTypes__default.func,
  closeAriaLabel: PropTypes__default.string,
  open: PropTypes__default.bool.isRequired,
  id: PropTypes__default.string,
  size: /*#__PURE__*/PropTypes__default.oneOf(['xs', 's', 'm', 'l', 'xl']),
  zIndex: /*#__PURE__*/PropTypes__default.oneOfType([/*#__PURE__*/PropTypes__default.oneOf(['-moz-initial', 'inherit', 'initial', 'revert', 'unset', 'auto']), PropTypes__default.number])
};

function _templateObject4$8() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  display: block;\n  margin-bottom: ", ";\n  text-align: center;\n  max-width: 370px;\n"]);

  _templateObject4$8 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$c() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: bold;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin: 0;\n  margin-bottom: ", ";\n"]);

  _templateObject3$c = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$l() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 120px;\n  height: auto;\n  font-weight: bold;\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  margin: ", ";\n"]);

  _templateObject2$l = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$B() {
  var data = _taggedTemplateLiteralLoose(["\n  display: grid;\n  align-items: center;\n  justify-items: center;\n  font-family: ", ";\n\n  ", "\n  ", "\n"]);

  _templateObject$B = function _templateObject() {
    return data;
  };

  return data;
}
var Container$5 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$B(), function (props) {
  return props.theme.fonts.primary;
}, space, layout);
var Image = /*#__PURE__*/styled.img( /*#__PURE__*/_templateObject2$l(), function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.space.regular;
});
var Title = /*#__PURE__*/styled.p( /*#__PURE__*/_templateObject3$c(), function (props) {
  return props.theme.fontSizes.l;
}, function (props) {
  return props.theme.lineHeights.l;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.space.regular;
});
var Description$1 = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject4$8(), function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.grayDarkest;
}, function (props) {
  return props.theme.space.larger;
});

function isValidString(prop) {
  return !!prop && typeof prop === 'string';
}

function hasValidImageProps(imgSrc, imgAlt) {
  var isImageSrcValid = isValidString(imgSrc);
  var isAltValid = isValidString(imgAlt);
  return isImageSrcValid && isAltValid;
}

var EmptyState = function EmptyState(_ref) {
  var title = _ref.title,
      description = _ref.description,
      imgSrc = _ref.imgSrc,
      imgAlt = _ref.imgAlt,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "description", "imgSrc", "imgAlt", "children"]);

  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);
  return React.createElement(Container$5, Object.assign({}, styledSystemProps, htmlProps), hasValidImageProps(imgSrc, imgAlt) && React.createElement(Image, {
    src: imgSrc,
    alt: imgAlt
  }), React.createElement(Title, null, title), React.createElement(Description$1, null, description), children);
};
EmptyState.propTypes = {
  title: PropTypes__default.string.isRequired,
  description: PropTypes__default.string.isRequired,
  imgSrc: PropTypes__default.string,
  imgAlt: PropTypes__default.string
};

function _templateObject7$4() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject7$4 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$6() {
  var data = _taggedTemplateLiteralLoose(["\n  animation: 1.4s ease-in-out infinite both ", ";\n  fill: transparent;\n  stroke-dasharray: 285;\n  stroke-linecap: round;\n  stroke-width: ", ";\n  ", "\n  transform-origin: 50% 50%;\n"]);

  _templateObject6$6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$7() {
  var data = _taggedTemplateLiteralLoose(["\n  animation: 2s linear infinite both ", ";\n"]);

  _templateObject5$7 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$9() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject4$9 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$d() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  padding: ", ";\n  height: ", ";\n  width: ", ";\n  margin: auto;\n"]);

  _templateObject3$d = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$m() {
  var data = _taggedTemplateLiteralLoose(["\n   0%, 25% {\n    stroke-dashoffset: 280;\n    transform: rotate(0);\n  }\n  50%, 75% {\n    stroke-dashoffset: 75;\n    transform: rotate(45deg);\n  }\n  100% {\n    stroke-dashoffset: 280;\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject2$m = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$C() {
  var data = _taggedTemplateLiteralLoose(["\n  0% { transform: rotateZ(0deg); }\n  100% { transform: rotateZ(360deg) }\n"]);

  _templateObject$C = function _templateObject() {
    return data;
  };

  return data;
}
var size = {
  large: '48px',
  medium: '32px',
  small: '24px',
  xsmall: '16px'
};
var padding = {
  large: '4px',
  medium: '2.67px',
  small: '2px',
  xsmall: '1.33px'
};
var thickness = {
  large: '6px',
  medium: '4px',
  small: '3px',
  xsmall: '2px'
};
var outterCircle = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject$C());
var innerCircle = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject2$m());
var stroke = /*#__PURE__*/system({
  color: {
    property: 'stroke',
    scale: 'colors'
  }
});
var Frame = /*#__PURE__*/styled.div.attrs({
  role: 'progressbar',
  'aria-label': 'Loading'
})( /*#__PURE__*/_templateObject3$d(), function (_ref) {
  var variant = _ref.variant;
  return padding[variant];
}, function (_ref2) {
  var variant = _ref2.variant;
  return size[variant];
}, function (_ref3) {
  var variant = _ref3.variant;
  return size[variant];
});
var Wrapper$4 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$9());
var OutterCircle = /*#__PURE__*/styled.svg.attrs({
  viewBox: "0 0 100 100"
})( /*#__PURE__*/_templateObject5$7(), outterCircle);
var InnerCircle = /*#__PURE__*/styled.circle.attrs({
  cx: '50',
  cy: '50',
  r: '45'
})( /*#__PURE__*/_templateObject6$6(), innerCircle, function (_ref4) {
  var variant = _ref4.variant;
  return thickness[variant];
}, stroke);
var Text$1 = /*#__PURE__*/styled(Text).attrs({
  display: 'block',
  textAlign: 'center',
  fontFamily: 'primary',
  fontSize: '14px',
  marginTop: 'regular',
  'aria-hidden': true
})( /*#__PURE__*/_templateObject7$4());

var Spinner = function Spinner(props) {
  return React.createElement(Spinner.Frame, {
    variant: props.variant
  }, React.createElement(Spinner.OutterCircle, null, React.createElement(Spinner.InnerCircle, {
    variant: props.variant,
    color: props.color
  })));
};
Spinner.Frame = Frame;
Spinner.OutterCircle = OutterCircle;
Spinner.InnerCircle = InnerCircle;

var defaultProps = {
  variant: 'large',
  color: 'primary'
};
var Loading$1 = function Loading(_ref) {
  var color = _ref.color,
      variant = _ref.variant,
      props = _objectWithoutPropertiesLoose(_ref, ["color", "variant"]);

  return React.createElement(Loading.Wrapper, Object.assign({}, props), React.createElement(Loading.Spinner, {
    color: color,
    variant: variant
  }), React.createElement(Loading.Text, null, props.children));
};
Loading$1.defaultProps = defaultProps;
Loading$1.Wrapper = Wrapper$4;
Loading$1.Text = Text$1;
Loading$1.Spinner = Spinner;

var PaginationPositionOptions;

(function (PaginationPositionOptions) {
  PaginationPositionOptions["left"] = "left";
  PaginationPositionOptions["center"] = "center";
  PaginationPositionOptions["right"] = "right";
})(PaginationPositionOptions || (PaginationPositionOptions = {}));

function _templateObject3$e() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject3$e = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$n() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n"]);

  _templateObject2$n = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$D() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: ", ";\n  ", "\n  ", "\n"]);

  _templateObject$D = function _templateObject() {
    return data;
  };

  return data;
}
var PaginationContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$D(), function (_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? PaginationPositionOptions.left : _ref$position;

  if (position === PaginationPositionOptions.right) {
    return 'flex-end';
  }

  if (position === PaginationPositionOptions.center) {
    return 'center';
  }

  return 'flex-start';
}, space, layout);
var PaginationButtons = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$n());
var PaginationButton = /*#__PURE__*/styled(Button).attrs(function () {
  return {
    variant: 'tertiary',
    type: 'button'
  };
})( /*#__PURE__*/_templateObject3$e());

var PAGINATION_LOCALES = {
  'pt-br': {
    of: 'de',
    showing: 'Exibindo',
    next: 'Próximo',
    previous: 'Anterior',
    perPage: 'Itens por página'
  },
  'en-us': {
    of: 'of',
    showing: 'Showing',
    next: 'Next',
    previous: 'Previous',
    perPage: 'Items per page'
  },
  'es-mx': {
    of: 'de',
    showing: 'Exibindo',
    next: 'Próxima',
    previous: 'Previa',
    perPage: 'Itens por página'
  },
  'es-co': {
    of: 'de',
    showing: 'Exibindo',
    next: 'Próxima',
    previous: 'Previa',
    perPage: 'Artículos por página'
  }
};

function _templateObject5$8() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"]);

  _templateObject5$8 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$a() {
  var data = _taggedTemplateLiteralLoose(["\n  border: ", ";\n  color: ", ";\n  background-color: ", ";\n"]);

  _templateObject4$a = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$f() {
  var data = _taggedTemplateLiteralLoose(["\n  border: solid 1px ", ";\n"]);

  _templateObject3$f = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$o() {
  var data = _taggedTemplateLiteralLoose(["\n  border: none;\n  height: auto;\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  flex-grow: 1;\n\n  &:focus {\n    outline: none;\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &[disabled] {\n    background-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"]);

  _templateObject2$o = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$E() {
  var data = _taggedTemplateLiteralLoose(["\n  border: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n\n  transition: ", ";\n\n  &:focus-within {\n    outline: none;\n    border: ", ";\n    box-shadow: 0 0 0 1px ", ";\n  }\n"]);

  _templateObject$E = function _templateObject() {
    return data;
  };

  return data;
}
var TextInputStyle = /*#__PURE__*/css( /*#__PURE__*/_templateObject$E(), function (props) {
  return "solid 1px " + props.theme.colors.gray;
}, function (props) {
  return props.theme.radii.m;
}, function (_ref) {
  var _ref$theme = _ref.theme,
      durations = _ref$theme.durations,
      timingFunctions = _ref$theme.timingFunctions;
  return mountTransition([['box-shadow', durations.quickly, timingFunctions['easeInOut']]]);
}, function (props) {
  return "solid 1px " + props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});
var TextInputResetStyle = /*#__PURE__*/css( /*#__PURE__*/_templateObject2$o(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.m;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.grayDarker;
});
var ErrorStyle = /*#__PURE__*/css( /*#__PURE__*/_templateObject3$f(), function (props) {
  return props.theme.colors.error;
});
var DisabledStyle = /*#__PURE__*/css( /*#__PURE__*/_templateObject4$a(), function (props) {
  return "solid 1px " + props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
});
var DisabledText = /*#__PURE__*/css( /*#__PURE__*/_templateObject5$8(), function (props) {
  return props.theme.colors.grayDarkest;
});

function _templateObject2$p() {
  var data = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  max-height: 150px;\n  overflow-y: auto;\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject2$p = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$F() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  box-sizing: border-box;\n\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  &.selected {\n    background-color: ", ";\n  }\n\n  &[disabled] {\n    color: ", ";\n    background-color: ", ";\n    cursor: pointer;\n  }\n"]);

  _templateObject$F = function _templateObject() {
    return data;
  };

  return data;
}
var ListboxOption = /*#__PURE__*/styled.li.attrs(function () {
  return {
    role: 'option',
    'aria-selected': false
  };
})( /*#__PURE__*/_templateObject$F(), function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.colors.grayLight;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
});
var Listbox = /*#__PURE__*/styled.ul.attrs({
  role: 'listbox'
})( /*#__PURE__*/_templateObject2$p(), layout, space);

function _templateObject$G() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: normal;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  margin-bottom: ", ";\n\n  ", "\n  ", "\n"]);

  _templateObject$G = function _templateObject() {
    return data;
  };

  return data;
}
var Label = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject$G(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.space.smallest;
}, space, layout);

function _templateObject$H() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  margin-top: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n"]);

  _templateObject$H = function _templateObject() {
    return data;
  };

  return data;
}
var ErrorLabel = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject$H(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.xs;
}, function (props) {
  return props.theme.lineHeights.s;
}, function (props) {
  return props.theme.colors.error;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smaller;
});

function _templateObject3$g() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3$g = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$q() {
  var data = _taggedTemplateLiteralLoose(["\n          color: ", ";\n        "]);

  _templateObject2$q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$I() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  line-height: ", ";\n\n  ", "\n\n  margin-top: 2px;\n  margin-left: auto;\n  padding-left: ", ";\n  padding-right: ", ";\n\n  border-radius: ", ";\n"]);

  _templateObject$I = function _templateObject() {
    return data;
  };

  return data;
}
var Counter = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$I(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.disabled ? css(_templateObject2$q(), props.theme.colors.grayDarker) : css(_templateObject3$g());
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.radii.m;
});
var CharCounter = function CharCounter(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled;
  return React.createElement(Counter, {
    disabled: disabled
  }, children);
};

var getRefLength = function getRefLength(ref) {
  var _ref$current, _ref$current$value;

  return (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$value = _ref$current.value) === null || _ref$current$value === void 0 ? void 0 : _ref$current$value.length) || 0;
};

function useCharCounter(ref) {
  var _useState = useState(getRefLength(ref)),
      count = _useState[0],
      setCount = _useState[1];

  useEffect(function () {
    setCount(getRefLength(ref));
    var node = ref === null || ref === void 0 ? void 0 : ref.current;
    var inputListener = debounce(function () {
      setCount(getRefLength(ref));
    });
    var observer = new MutationObserver(inputListener);

    if (node) {
      observer.observe(node, {
        childList: true,
        attributes: true
      });
      node.addEventListener('input', inputListener);
    }

    return function () {
      observer.disconnect();
      node === null || node === void 0 ? void 0 : node.removeEventListener('input', inputListener);
    };
  }, [ref]);
  return count;
}

function getTestOnlyId(testId) {
  if (process.env.NODE_ENV !== 'test') {
    return {};
  }

  return {
    'data-testid': testId
  };
}

function _templateObject3$h() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n"]);

  _templateObject3$h = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$r() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: ", ";\n  margin-left: ", ";\n"]);

  _templateObject2$r = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$J() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  ", "\n  ", "\n"]);

  _templateObject$J = function _templateObject() {
    return data;
  };

  return data;
}
var CONTAINER_TEST_ID = 'form-element-test-id';
var Container$6 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$J(), layout, space);
var ErrorIcon = /*#__PURE__*/styled(Icon$1).attrs(function (props) {
  return {
    component: AlertFilled,
    size: 'xs',
    svgProps: {
      color: props.theme.colors.error
    }
  };
})( /*#__PURE__*/_templateObject2$r(), function (props) {
  return "" + props.theme.space.none;
}, function (props) {
  return "" + props.theme.space.smaller;
});
var Footer$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$h());
var FormElement = function FormElement(_ref) {
  var children = _ref.children,
      error = _ref.error,
      label = _ref.label,
      id = _ref.id,
      disabled = _ref.disabled,
      showCounter = _ref.showCounter,
      elementRef = _ref.elementRef,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["children", "error", "label", "id", "disabled", "showCounter", "elementRef"]);

  var count = useCharCounter(elementRef);
  return React.createElement(Container$6, Object.assign({}, getTestOnlyId(CONTAINER_TEST_ID), otherProps), label && React.createElement(Label, {
    htmlFor: id
  }, label), children, React.createElement(Footer$2, null, error && React.createElement(Flex, {
    centered: true
  }, React.createElement(ErrorIcon, null), React.createElement(ErrorLabel, {
    role: "alert"
  }, error)), showCounter && React.createElement(CharCounter, {
    disabled: disabled
  }, count)));
};
FormElement.propTypes = {
  error: PropTypes__default.string,
  label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  id: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  showCounter: PropTypes__default.bool
};

function _templateObject2$s() {
  var data = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  line-height: 0;\n"]);

  _templateObject2$s = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$K() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"]);

  _templateObject$K = function _templateObject() {
    return data;
  };

  return data;
}
var Error$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$K(), function (props) {
  return props.theme.colors.error;
});
var Container$7 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$s(), function (_ref) {
  var size = _ref.size;
  return size + "px";
});
var FormElementIcons = function FormElementIcons(_ref2) {
  var error = _ref2.error,
      children = _ref2.children,
      className = _ref2.className;
  var theme = useContext(ThemeContext);
  var hasError = Boolean(error);
  var childrenCount = Children.count(children);
  var IconWidth = parseInt(theme.space.large);
  var IconPadding = parseInt(theme.space.smallest);
  var IconSize = IconWidth + IconPadding;
  var size = IconSize * (childrenCount + 1);
  return React.createElement(Container$7, {
    size: size,
    className: className
  }, children, hasError && React.createElement(Error$1, null, React.createElement(Icon$1, {
    component: AlertFilled,
    size: "s"
  })));
};
FormElementIcons.propTypes = {
  error: PropTypes__default.string,
  className: PropTypes__default.string
};

function _templateObject$L() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  visibility: ", ";\n  background-color: ", ";\n  z-index: 99;\n\n  &:focus-within {\n    outline: none;\n    border: ", ";\n    box-shadow: ", ";\n  }\n"]);

  _templateObject$L = function _templateObject() {
    return data;
  };

  return data;
}
var PopoverStyled = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$L(), TextInputStyle, function (props) {
  return props.visible ? 'visible' : 'hidden';
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return "solid 1px " + props.theme.colors.gray;
}, function (props) {
  return props.theme.shadows.none;
});
var Popover = function Popover(_ref) {
  var visible = _ref.visible,
      referenceElement = _ref.referenceElement,
      children = _ref.children;

  var _useState = useState(null),
      popperElement = _useState[0],
      setPopperElement = _useState[1];

  var modifiers = useMemo(function () {
    return [{
      name: 'sameWidth',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;
        state.styles.popper.width = state.rects.reference.width + "px";
      }
    }];
  }, []);

  var _usePopper = usePopper(referenceElement, popperElement, {
    placement: 'bottom-start',
    modifiers: modifiers
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      forceUpdate = _usePopper.forceUpdate;

  useEffect(function () {
    if (visible && forceUpdate) {
      forceUpdate();
    }
  }, [visible, forceUpdate]);
  return React.createElement(PopoverStyled, Object.assign({
    ref: setPopperElement,
    style: styles.popper,
    visible: visible
  }, attributes.popper), children);
};

function _templateObject5$9() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"]);

  _templateObject5$9 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$b() {
  var data = _taggedTemplateLiteralLoose(["\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"]);

  _templateObject4$b = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$i() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3$i = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$t() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2$t = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$M() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  cursor: pointer;\n  display: inline-flex;\n  width: 100%;\n  justify-content: space-between;\n  box-sizing: border-box;\n  background-color: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  ", ";\n\n  ", "\n"]);

  _templateObject$M = function _templateObject() {
    return data;
  };

  return data;
}
var SelectButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject$M(), TextInputStyle, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.grayDarkest;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.disabled ? DisabledStyle : css(_templateObject2$t());
}, function (props) {
  return props.error ? ErrorStyle : css(_templateObject3$i());
});
var SelectButtonText = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject4$b());
var DropdownIcon = /*#__PURE__*/styled(Icon$1)( /*#__PURE__*/_templateObject5$9(), function (props) {
  return "" + props.theme.colors.primary;
});

var itemToString = function itemToString(item) {
  return (item === null || item === void 0 ? void 0 : item.name) ? item.name : '';
};

var itemToValue = function itemToValue(item) {
  return (item === null || item === void 0 ? void 0 : item.value) ? item.value : '';
};

var itemToNode = function itemToNode(item) {
  return (item === null || item === void 0 ? void 0 : item.node) ? item.node(item.name) : itemToString(item);
};

var Select = /*#__PURE__*/forwardRef(function (props, ref) {
  var label = props.label,
      error = props.error,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      onChange = props.onChange,
      placeholder = props.placeholder,
      onBlur = props.onBlur,
      value = props.value,
      name = props.name,
      disabled = props.disabled,
      itemListStyleProps = props.itemListStyleProps,
      otherProps = _objectWithoutPropertiesLoose(props, ["label", "error", "items", "onChange", "placeholder", "onBlur", "value", "name", "disabled", "itemListStyleProps"]);

  var styledSystemProps = pick(otherProps);
  var htmlProps = pickHTMLProps(otherProps);
  var innerRef = useShareForwardedRef(ref);
  var onSelectedItemChange = useCallback(function (_ref) {
    var selectedItem = _ref.selectedItem;
    var newValue = itemToValue(selectedItem);

    if ((innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) && innerRef.current.value !== newValue) {
      innerRef.current.value = newValue;
      innerRef.current.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }, [innerRef]);

  var _useSelect = useSelect({
    items: items,
    itemToString: itemToString,
    onSelectedItemChange: onSelectedItemChange
  }),
      isSelectOpen = _useSelect.isOpen,
      selectedItem = _useSelect.selectedItem,
      selectItem = _useSelect.selectItem,
      getToggleButtonProps = _useSelect.getToggleButtonProps,
      getLabelProps = _useSelect.getLabelProps,
      getMenuProps = _useSelect.getMenuProps,
      highlightedIndex = _useSelect.highlightedIndex,
      getItemProps = _useSelect.getItemProps,
      reset = _useSelect.reset;

  var isOpen = isSelectOpen && !disabled;
  useEffect(function () {
    if (value) {
      selectItem(value);
    } else {
      reset();
    }
  }, [selectItem, value, reset]);

  var _useState = useState(null),
      referenceElement = _useState[0],
      setReferenceElement = _useState[1];

  var handleOnInput = useCallback(function (event) {
    var foundOption = items.find(function (option) {
      return option.value === event.target.value;
    });
    if (foundOption) selectItem(foundOption);
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
  }, [onChange, selectItem, items]);
  var labelProps = getLabelProps();
  return React.createElement(FormElement, Object.assign({
    error: error
  }, styledSystemProps, htmlProps, {
    disabled: disabled
  }), label && React.createElement(Label, Object.assign({}, labelProps), label), React.createElement("div", {
    ref: setReferenceElement
  }, React.createElement(SelectButton, Object.assign({
    error: error
  }, getToggleButtonProps({
    type: 'button',
    disabled: disabled,
    onBlur: function onBlur() {
      var _innerRef$current;

      innerRef === null || innerRef === void 0 ? void 0 : (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.dispatchEvent(new Event('blur', {
        bubbles: true
      }));
    }
  }), {
    tabIndex: htmlProps.tabIndex
  }), React.createElement(SelectButtonText, null, selectedItem ? itemToString(selectedItem) : placeholder), React.createElement(FormElementIcons, {
    error: error
  }, React.createElement(DropdownIcon, {
    component: ChevronDown,
    size: "s"
  }))), React.createElement("input", {
    "aria-labelledby": labelProps.id,
    ref: innerRef,
    name: name,
    type: "hidden",
    onInput: handleOnInput,
    onBlur: onBlur,
    disabled: disabled
  }), React.createElement(Popover, {
    referenceElement: referenceElement,
    visible: isOpen
  }, React.createElement(Listbox, Object.assign({}, itemListStyleProps, getMenuProps()), isOpen ? items.map(function (item, index) {
    return React.createElement(ListboxOption, Object.assign({
      disabled: item.disabled,
      className: highlightedIndex === index ? 'selected' : '',
      key: "" + item + index
    }, getItemProps({
      item: item,
      index: index,
      disabled: Boolean(item.disabled)
    })), itemToNode(item));
  }) : null))));
});
var OptionShape = /*#__PURE__*/PropTypes__default.shape({
  value: PropTypes__default.string.isRequired,
  name: PropTypes__default.string.isRequired,
  node: PropTypes__default.func
});
Select.propTypes = {
  items: /*#__PURE__*/PropTypes__default.arrayOf(OptionShape.isRequired),
  value: OptionShape,
  error: PropTypes__default.string,
  name: PropTypes__default.string,
  label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  disabled: PropTypes__default.bool
};

function _templateObject9$3() {
  var data = _taggedTemplateLiteralLoose(["\n          color: ", ";\n        "]);

  _templateObject9$3 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$4() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n  letter-spacing: 1px;\n  color: ", ";\n\n  ", "\n"]);

  _templateObject8$4 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$5() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  justify-content: ", ";\n"]);

  _templateObject7$5 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$7() {
  var data = _taggedTemplateLiteralLoose(["\n  button {\n    padding: ", ";\n  }\n"]);

  _templateObject6$7 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$a() {
  var data = _taggedTemplateLiteralLoose(["\n          background-color: ", ";\n          color: ", ";\n        "]);

  _templateObject5$a = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$c() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  padding: ", ";\n  line-height: 1;\n  text-decoration: none;\n  color: ", ";\n  border-radius: ", ";\n\n  &:hover:not(:active):not(:disabled),\n  &:active {\n    cursor: pointer;\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ", "\n"]);

  _templateObject4$c = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$j() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0 2px;\n  ", "\n  ", "\n"]);

  _templateObject3$j = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$u() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  margin: 0;\n  list-style: none;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  ", "\n  ", "\n"]);

  _templateObject2$u = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$N() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  ", "\n  ", "\n"]);

  _templateObject$N = function _templateObject() {
    return data;
  };

  return data;
}
var PaginationNumberedContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$N(), space, layout);
var PaginationNumberedList = /*#__PURE__*/styled.ul( /*#__PURE__*/_templateObject2$u(), space, layout);
var PaginationNumberedItem = /*#__PURE__*/styled.li( /*#__PURE__*/_templateObject3$j(), space, layout);
var PaginationLink = /*#__PURE__*/styled(Button).attrs(function (_ref) {
  var active = _ref.active;
  return {
    type: 'button',
    variant: active ? 'primary' : 'tertiary'
  };
})( /*#__PURE__*/_templateObject4$c(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.smaller + " " + theme.space.small;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.radii.m;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primary;
}, function (_ref7) {
  var active = _ref7.active,
      theme = _ref7.theme;
  return active ? css(_templateObject5$a(), theme.colors.primary, theme.colors.white) : undefined;
});
var SelectPerPage = /*#__PURE__*/styled(Select).attrs(function () {
  return {
    style: {
      width: 'auto'
    }
  };
})( /*#__PURE__*/_templateObject6$7(), function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.smaller;
});
var PaginationNav = /*#__PURE__*/styled.nav( /*#__PURE__*/_templateObject7$5(), function (_ref9) {
  var _ref9$position = _ref9.position,
      position = _ref9$position === void 0 ? PaginationPositionOptions.left : _ref9$position;

  if (position === PaginationPositionOptions.right) {
    return 'flex-end';
  }

  if (position === PaginationPositionOptions.center) {
    return 'center';
  }

  return 'flex-start';
});
var PaginationEllipsis = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject8$4(), function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.small + " " + theme.space.smallest;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primary;
}, function (_ref12) {
  var disabled = _ref12.disabled,
      theme = _ref12.theme;
  return disabled ? css(_templateObject9$3(), theme.colors.grayDarker) : undefined;
});

var getNextOffset = function getNextOffset(currentPage, totalCount, pageSize) {
  var computedOffset = currentPage * pageSize;

  if (computedOffset >= totalCount) {
    return totalCount;
  }

  return computedOffset;
};

var getPreviousOffset = function getPreviousOffset(currentPage, pageSize) {
  var computedOffset = currentPage * pageSize;

  if (computedOffset < 0) {
    return 0;
  }

  return computedOffset;
};

var getTotalPages = function getTotalPages(totalCount, pageSize) {
  return Math.ceil(totalCount / pageSize);
};

var getCurrentPage = function getCurrentPage(currentPage, totalCount, pageSize) {
  if (currentPage * pageSize >= totalCount) {
    return Math.ceil(totalCount / pageSize);
  }

  if (currentPage <= 0) {
    return 1;
  }

  return currentPage;
};

var hasNext = function hasNext(currentPage, pageSize, totalCount) {
  if (currentPage * pageSize >= totalCount || totalCount < pageSize) {
    return false;
  }

  return true;
};

var hasPrevious = function hasPrevious(currentPage) {
  return currentPage > 1;
};

var usePagination = function usePagination(currentPage, pageSize, totalCount) {
  var current = useMemo(function () {
    return getCurrentPage(currentPage, totalCount, pageSize);
  }, [currentPage, totalCount, pageSize]);
  var previousOffset = useMemo(function () {
    return getPreviousOffset(currentPage, pageSize);
  }, [currentPage, pageSize]);
  var nextOffset = useMemo(function () {
    return getNextOffset(currentPage, totalCount, pageSize);
  }, [currentPage, totalCount, pageSize]);
  var canGoBack = useMemo(function () {
    return hasPrevious(currentPage);
  }, [currentPage]);
  var canGoNext = useMemo(function () {
    return hasNext(currentPage, pageSize, totalCount);
  }, [currentPage, pageSize, totalCount]);
  var totalPages = useMemo(function () {
    return getTotalPages(totalCount, pageSize);
  }, [totalCount, pageSize]);
  return {
    currentPage: current,
    totalPages: totalPages,
    previousOffset: previousOffset,
    nextOffset: nextOffset,
    canGoBack: canGoBack,
    canGoNext: canGoNext
  };
};

var formatPerPageOption = function formatPerPageOption(value) {
  return {
    name: String(value),
    value: String(value)
  };
};

var Ellipsis = function Ellipsis(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  return React.createElement(PaginationNumberedItem, null, React.createElement(PaginationEllipsis, {
    disabled: disabled
  }, "..."));
};

var PaginationNumbered = function PaginationNumbered(_ref2) {
  var disabled = _ref2.disabled,
      current = _ref2.current,
      nextLabel = _ref2.nextLabel,
      onChange = _ref2.onChange,
      _ref2$pageSize = _ref2.pageSize,
      pageSize = _ref2$pageSize === void 0 ? 12 : _ref2$pageSize,
      _ref2$pageSizes = _ref2.pageSizes,
      pageSizes = _ref2$pageSizes === void 0 ? [] : _ref2$pageSizes,
      perPageLabel = _ref2.perPageLabel,
      _ref2$position = _ref2.position,
      position = _ref2$position === void 0 ? PaginationPositionOptions.center : _ref2$position,
      previousLabel = _ref2.previousLabel,
      _ref2$showArrowLabel = _ref2.showArrowLabel,
      showArrowLabel = _ref2$showArrowLabel === void 0 ? false : _ref2$showArrowLabel,
      _ref2$sidePages = _ref2.sidePages,
      sidePages = _ref2$sidePages === void 0 ? 3 : _ref2$sidePages,
      totalItems = _ref2.totalItems,
      props = _objectWithoutPropertiesLoose(_ref2, ["disabled", "current", "nextLabel", "onChange", "pageSize", "pageSizes", "perPageLabel", "position", "previousLabel", "showArrowLabel", "sidePages", "totalItems"]);

  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var previousLabelText = previousLabel || PAGINATION_LOCALES[locale].previous;
  var nextLabelText = nextLabel || PAGINATION_LOCALES[locale].next;
  var perPageLabelText = perPageLabel || PAGINATION_LOCALES[locale].perPage;

  var _usePagination = usePagination(current, pageSize, totalItems),
      currentPage = _usePagination.currentPage,
      previousOffset = _usePagination.previousOffset,
      nextOffset = _usePagination.nextOffset,
      totalPages = _usePagination.totalPages,
      canGoBack = _usePagination.canGoBack,
      canGoNext = _usePagination.canGoNext;

  var handleChange = useCallback(function (data) {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      currentPage: data.currentPage,
      pageSize: data.pageSize,
      previousOffset: previousOffset,
      nextOffset: nextOffset
    });
  }, [nextOffset, onChange, previousOffset]);
  var segmentedPages = useMemo(function () {
    return segmentize({
      page: currentPage,
      pages: totalPages,
      beginPages: 3,
      endPages: 1,
      sidePages: sidePages
    });
  }, [currentPage, sidePages, totalPages]);
  var firstPage = 1;
  var hasMultiplePages = totalPages > 1;
  var hasHiddenPrevPages = currentPage - sidePages - 1 >= 1;
  var hasHiddenNextPages = currentPage + sidePages + 1 < totalPages;
  var handleChangePage = useCallback(function (page) {
    return function () {
      return handleChange === null || handleChange === void 0 ? void 0 : handleChange({
        currentPage: page,
        pageSize: pageSize
      });
    };
  }, [handleChange, pageSize]);
  var handleChangePageSize = useCallback(function (e) {
    handleChange === null || handleChange === void 0 ? void 0 : handleChange({
      currentPage: currentPage,
      pageSize: +e.target.value
    });
  }, [currentPage, handleChange]);
  var perPageOptions = useMemo(function () {
    return pageSizes.map(formatPerPageOption);
  }, [pageSizes]);
  var selectedPageSize = useMemo(function () {
    return formatPerPageOption(pageSize);
  }, [pageSize]);
  var pageRange = useMemo(function () {
    var prevPages = segmentedPages.previousPages.length ? segmentedPages.previousPages[0] : 2;
    var nextPages = segmentedPages.nextPages.length ? segmentedPages.nextPages[segmentedPages.nextPages.length - 1] + 1 : totalPages;
    return range(prevPages, nextPages);
  }, [segmentedPages.nextPages, segmentedPages.previousPages, totalPages]);
  return React.createElement(PaginationNumberedContainer, Object.assign({}, htmlProps, styledSystemProps), pageSizes.length > 0 && React.createElement(Flex, {
    centered: true,
    mr: "regular"
  }, React.createElement(SelectPerPage, {
    mr: "regular",
    name: "perPage",
    disabled: disabled,
    value: selectedPageSize,
    items: perPageOptions,
    onChange: handleChangePageSize
  }), React.createElement(Text, null, perPageLabelText)), React.createElement(PaginationNav, {
    role: "navigation",
    position: position
  }, React.createElement(PaginationNumberedList, null, canGoBack && React.createElement(PaginationNumberedItem, null, React.createElement(PaginationButton, {
    disabled: disabled,
    "data-testid": "page-previous",
    onClick: handleChangePage(currentPage - 1),
    "aria-label": previousLabelText
  }, React.createElement(Icon$1, {
    component: ChevronLeft,
    size: "s",
    mr: "smaller"
  }), showArrowLabel && previousLabelText)), React.createElement(PaginationNumberedItem, null, React.createElement(PaginationLink, {
    active: !canGoBack,
    disabled: disabled,
    onClick: handleChangePage(firstPage)
  }, firstPage)), hasHiddenPrevPages && React.createElement(Ellipsis, {
    disabled: disabled
  }), hasMultiplePages && pageRange.map(function (page) {
    return React.createElement(PaginationNumberedItem, {
      key: page
    }, React.createElement(PaginationLink, {
      active: currentPage === page,
      disabled: disabled,
      "data-testid": "page-" + page,
      onClick: handleChangePage(page)
    }, page));
  }), hasHiddenNextPages && React.createElement(Ellipsis, {
    disabled: disabled
  }), hasMultiplePages && React.createElement(PaginationNumberedItem, {
    key: totalPages
  }, React.createElement(PaginationLink, {
    active: !canGoNext,
    disabled: disabled,
    "data-testid": "page-" + totalPages,
    onClick: handleChangePage(totalPages)
  }, totalPages)), canGoNext && React.createElement(PaginationNumberedItem, null, React.createElement(PaginationButton, {
    "data-testid": "page-next",
    disabled: disabled,
    onClick: handleChangePage(currentPage + 1),
    "aria-label": nextLabelText
  }, showArrowLabel && nextLabelText, React.createElement(Icon$1, {
    component: ChevronRight,
    size: "s",
    ml: "smaller"
  }))))));
};
PaginationNumbered.propTypes = {
  current: PropTypes__default.number.isRequired,
  disabled: PropTypes__default.bool,
  nextLabel: PropTypes__default.string,
  onChange: PropTypes__default.func,
  pageSize: PropTypes__default.number,
  pageSizes: PropTypes__default.array,
  perPageLabel: PropTypes__default.string,
  position: /*#__PURE__*/PropTypes__default.oneOf(['left', 'center', 'right']),
  previousLabel: PropTypes__default.string,
  sidePages: PropTypes__default.number,
  totalItems: PropTypes__default.number.isRequired
};

function _templateObject$O() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  color: ", ";\n  margin-right: ", ";\n  ", "\n  ", ";\n"]);

  _templateObject$O = function _templateObject() {
    return data;
  };

  return data;
}
var SummaryContainer = /*#__PURE__*/styled(Text)( /*#__PURE__*/_templateObject$O(), function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.colors.grayDarkest;
}, function (props) {
  return props.theme.space.largest;
}, space, layout);

var PaginationSummary = function PaginationSummary(_ref) {
  var currentPage = _ref.currentPage,
      ofLabel = _ref.ofLabel,
      pageSize = _ref.pageSize,
      showingLabel = _ref.showingLabel,
      totalItems = _ref.totalItems,
      props = _objectWithoutPropertiesLoose(_ref, ["currentPage", "ofLabel", "pageSize", "showingLabel", "totalItems"]);

  var currentAmount = currentPage * pageSize || 0;
  var isLastPage = currentAmount >= totalItems;
  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);
  return React.createElement(SummaryContainer, Object.assign({}, htmlProps, styledSystemProps), showingLabel, ' ', React.createElement("strong", null, (isLastPage ? totalItems : currentAmount) + " " + ofLabel + " " + totalItems));
};
PaginationSummary.propTypes = {
  currentPage: PropTypes__default.number.isRequired,
  ofLabel: PropTypes__default.string.isRequired,
  pageSize: PropTypes__default.number.isRequired,
  showingLabel: PropTypes__default.string.isRequired,
  totalItems: PropTypes__default.number.isRequired
};

var Pagination = function Pagination(_ref) {
  var _ref$current = _ref.current,
      current = _ref$current === void 0 ? 1 : _ref$current,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$pageSize = _ref.pageSize,
      pageSize = _ref$pageSize === void 0 ? 1 : _ref$pageSize,
      totalItems = _ref.totalItems,
      nextLabel = _ref.nextLabel,
      ofLabel = _ref.ofLabel,
      previousLabel = _ref.previousLabel,
      showingLabel = _ref.showingLabel,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["current", "disabled", "pageSize", "totalItems", "nextLabel", "ofLabel", "previousLabel", "showingLabel", "onChange"]);

  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var ofLabelText = ofLabel || PAGINATION_LOCALES[locale].of;
  var showingLabelText = showingLabel || PAGINATION_LOCALES[locale].showing;
  var previousLabelText = previousLabel || PAGINATION_LOCALES[locale].previous;
  var nextLabelText = nextLabel || PAGINATION_LOCALES[locale].next;

  var _usePagination = usePagination(current, pageSize, totalItems),
      currentPage = _usePagination.currentPage,
      previousOffset = _usePagination.previousOffset,
      nextOffset = _usePagination.nextOffset,
      canGoBack = _usePagination.canGoBack,
      canGoNext = _usePagination.canGoNext;

  var handleChange = useCallback(function (delta) {
    onChange === null || onChange === void 0 ? void 0 : onChange({
      currentPage: currentPage + delta,
      previousOffset: previousOffset,
      nextOffset: nextOffset,
      pageSize: pageSize
    });
  }, [onChange, currentPage, previousOffset, nextOffset, pageSize]);
  var handlePrevious = useCallback(function () {
    handleChange(-1);
  }, [handleChange]);
  var handleNext = useCallback(function () {
    handleChange(1);
  }, [handleChange]);
  return React.createElement(PaginationContainer, Object.assign({}, htmlProps, styledSystemProps), React.createElement(PaginationSummary, {
    currentPage: currentPage,
    totalItems: totalItems,
    pageSize: pageSize,
    ofLabel: ofLabelText,
    showingLabel: showingLabelText
  }), React.createElement(PaginationButtons, null, React.createElement(PaginationButton, {
    mr: "regular",
    disabled: !canGoBack || disabled,
    onClick: handlePrevious
  }, React.createElement(Icon$1, {
    component: ChevronLeft,
    size: "s",
    mr: "smaller"
  }), previousLabelText), React.createElement(PaginationButton, {
    ml: "regular",
    disabled: !canGoNext || disabled,
    onClick: handleNext
  }, nextLabelText, React.createElement(Icon$1, {
    component: ChevronRight,
    size: "s",
    ml: "smaller"
  }))));
};
Pagination.Numbered = PaginationNumbered;
Pagination.propTypes = {
  current: PropTypes__default.number.isRequired,
  disabled: PropTypes__default.bool,
  nextLabel: PropTypes__default.string,
  ofLabel: PropTypes__default.string,
  onChange: PropTypes__default.func,
  pageSize: PropTypes__default.number,
  position: /*#__PURE__*/PropTypes__default.oneOf(['left', 'center', 'right']),
  previousLabel: PropTypes__default.string,
  showingLabel: PropTypes__default.string,
  totalItems: PropTypes__default.number.isRequired
};

function _templateObject$P() {
  var data = _taggedTemplateLiteralLoose(["\n  &.Toastify__toast-container {\n    z-index: 9999;\n    transform: translate3d(0, 0, 9999px);\n    position: fixed;\n    padding: 4px;\n    min-width: 320px;\n    box-sizing: border-box;\n  }\n  &.Toastify__toast-container--top-right {\n    top: 1em;\n    right: 1em;\n  }\n  &.Toastify__toast-container--bottom-center {\n    bottom: 1em;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  @media only screen and (max-width: 480px) {\n    &.Toastify__toast-container {\n      width: 100vw;\n      padding: 0;\n      left: 0;\n      margin: 0;\n    }\n    &.Toastify__toast-container--top-right {\n      top: 0;\n      transform: translateX(0);\n    }\n    &.Toastify__toast-container--bottom-center {\n      bottom: 0;\n      transform: translateX(0);\n    }\n  }\n  .Toastify__toast {\n    position: relative;\n    box-sizing: border-box;\n    padding: 8px;\n    display: flex;\n    justify-content: space-between;\n    max-height: 800px;\n    overflow: hidden;\n    font-family: sans-serif;\n    cursor: pointer;\n  }\n  .Toastify__toast-body {\n    margin: auto 0;\n    flex: 1 1 auto;\n  }\n  @media only screen and (max-width: 480px) {\n    .Toastify__toast {\n      margin-bottom: 0;\n    }\n  }\n  .Toastify__close-button {\n    display: none;\n  }\n  @keyframes Toastify__trackProgress {\n    0% {\n      transform: scaleX(1);\n    }\n    100% {\n      transform: scaleX(0);\n    }\n  }\n  .Toastify__progress-bar--animated {\n    animation: Toastify__trackProgress linear 1 forwards;\n  }\n  @keyframes Toastify__bounceInRight {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    from {\n      opacity: 0;\n      transform: translate3d(3000px, 0, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(-25px, 0, 0);\n    }\n    75% {\n      transform: translate3d(10px, 0, 0);\n    }\n    90% {\n      transform: translate3d(-5px, 0, 0);\n    }\n    to {\n      transform: none;\n    }\n  }\n  @keyframes Toastify__bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translate3d(-20px, 0, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(2000px, 0, 0);\n    }\n  }\n  @keyframes Toastify__bounceInUp {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    from {\n      opacity: 0;\n      transform: translate3d(0, 3000px, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    75% {\n      transform: translate3d(0, 10px, 0);\n    }\n    90% {\n      transform: translate3d(0, -5px, 0);\n    }\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes Toastify__bounceOutDown {\n    20% {\n      transform: translate3d(0, 10px, 0);\n    }\n    40%,\n    45% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(0, 2000px, 0);\n    }\n  }\n  .Toastify__bounce-enter--top-right {\n    animation-name: Toastify__bounceInRight;\n  }\n  .Toastify__bounce-exit--top-right {\n    animation-name: Toastify__bounceOutRight;\n  }\n  .Toastify__bounce-enter--bottom-center {\n    animation-name: Toastify__bounceInUp;\n  }\n  .Toastify__bounce-exit--bottom-center {\n    animation-name: Toastify__bounceOutDown;\n  }\n\n  @keyframes Toastify__slideInRight {\n    from {\n      transform: translate3d(110%, 0, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideOutRight {\n    from {\n      transform: translate3d(0, 0, 0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(110%, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideInUp {\n    from {\n      transform: translate3d(0, 110%, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideOutDown {\n    from {\n      transform: translate3d(0, 0, 0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(0, 500px, 0);\n    }\n  }\n  .Toastify__slide-enter--top-right {\n    animation-name: Toastify__slideInRight;\n  }\n  .Toastify__slide-exit--top-right {\n    animation-name: Toastify__slideOutRight;\n  }\n  .Toastify__slide-enter--bottom-center {\n    animation-name: Toastify__slideInUp;\n  }\n  .Toastify__slide-exit--bottom-center {\n    animation-name: Toastify__slideOutDown;\n  }\n"]);

  _templateObject$P = function _templateObject() {
    return data;
  };

  return data;
}
// that only works with this set of configs, this is a minimalist version of ReactToastify.css

var SnackbarContainer = /*#__PURE__*/styled(ToastContainer).attrs({
  autoClose: 4000,
  hideProgressBar: true,
  newestOnTop: false,
  closeOnClick: false,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true
})( /*#__PURE__*/_templateObject$P());

var PomodoroProvider = function PomodoroProvider(_ref) {
  var theme = _ref.theme,
      snackbarPosition = _ref.snackbarPosition,
      children = _ref.children,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-us' : _ref$locale;
  var currentTheme = useMemo(function () {
    return theme ? merge(tokens, theme) : tokens;
  }, [theme]);
  return React.createElement(ThemeProvider, {
    theme: currentTheme
  }, React.createElement(PomodoroContext.Provider, {
    value: {
      locale: locale
    }
  }, children, React.createElement(SnackbarContainer, {
    position: snackbarPosition
  })));
};
PomodoroProvider.propTypes = {
  theme: PropTypes__default.object,
  locale: /*#__PURE__*/PropTypes__default.oneOf(['pt-br', 'en-us', 'es-mx', 'es-co'])
};

var WEEKDAYS_SHORT = {
  'pt-br': /*#__PURE__*/'D_S_T_Q_Q_S_S'.split('_'),
  'en-us': /*#__PURE__*/'S_M_T_W_T_F_S'.split('_'),
  'es-mx': /*#__PURE__*/'D_L_M_M_J_V_S'.split('_'),
  'es-co': /*#__PURE__*/'D_L_M_M_J_V_S'.split('_')
};
var MONTHS = {
  'pt-br': /*#__PURE__*/'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
  'en-us': /*#__PURE__*/'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
  'es-mx': /*#__PURE__*/'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
  'es-co': /*#__PURE__*/'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_')
};
var WEEKDAYS_LONG = {
  'pt-br': /*#__PURE__*/'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
  'en-us': /*#__PURE__*/'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
  'es-mx': /*#__PURE__*/'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
  'es-co': /*#__PURE__*/'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_')
};
var FIRST_DAY_OF_WEEK = {
  'pt-br': 0,
  'en-us': 0,
  'es-mx': 0,
  'es-co': 0
};
var LABELS = {
  'pt-br': {
    nextMonth: 'Próximo mês',
    previousMonth: 'Mês anterior'
  },
  'en-us': {
    nextMonth: 'Next month',
    previousMonth: 'Previous month'
  },
  'es-mx': {
    nextMonth: 'Proximo mes',
    previousMonth: 'Mes anterior'
  },
  'es-co': {
    nextMonth: 'Proximo mes',
    previousMonth: 'Mes anterior'
  }
};

function _templateObject3$k() {
  var data = _taggedTemplateLiteralLoose(["\n          .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n            .DayPicker-inner-day,\n          .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)\n            .DayPicker-inner-day {\n            font-weight: bold;\n            position: relative;\n            background-color: ", ";\n            color: ", ";\n            border-radius: ", ";\n            padding-top: ", ";\n            padding-bottom: ", ";\n            margin-top: 0px;\n            margin-bottom: 0px;\n            z-index: 1;\n          }\n\n          .DayPicker-Week\n            .DayPicker-Day--selected:first-of-type\n            .DayPicker-inner-day {\n            border-radius: ", ";\n          }\n\n          .DayPicker-Week\n            .DayPicker-Day--selected:last-of-type\n            .DayPicker-inner-day {\n            border-radius: ", ";\n          }\n        "]);

  _templateObject3$k = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$v() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2$v = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$Q() {
  var data = _taggedTemplateLiteralLoose(["\n  .DayPicker {\n    box-shadow: ", ";\n    border-radius: ", ";\n    overflow: hidden;\n  }\n\n  .DayPicker-wrapper {\n    position: relative;\n    flex-direction: row;\n    padding-bottom: ", ";\n    user-select: none;\n  }\n\n  .DayPicker-Months {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .DayPicker-Month {\n    display: table;\n    margin: 0 ", ";\n    margin-top: ", ";\n    border-spacing: 0;\n    border-collapse: collapse;\n    user-select: none;\n  }\n\n  .DayPicker-NavBar {\n  }\n\n  .DayPicker-NavButton {\n    position: absolute;\n    display: inline-block;\n    width: ", ";\n    height: ", ";\n    cursor: pointer;\n  }\n\n  .DayPicker-NavButton:hover {\n    opacity: 0.8;\n  }\n\n  .DayPicker-NavButton--prev {\n    top: ", ";\n    left: ", ";\n    background-image: ", ";\n    transform: rotate(180deg);\n  }\n\n  .DayPicker-NavButton--next {\n    top: ", ";\n    right: ", ";\n    background-image: ", ";\n  }\n\n  .DayPicker-NavButton--interactionDisabled {\n    display: none;\n  }\n\n  .DayPicker-Caption {\n    font-family: ", ";\n    font-weight: bold;\n    color: ", ";\n    text-transform: capitalize;\n    display: table-caption;\n    margin-bottom: ", ";\n    padding: 0 ", ";\n    text-align: center;\n  }\n\n  .DayPicker-Weekdays {\n    display: table-header-group;\n    margin-top: ", ";\n  }\n\n  .DayPicker-WeekdaysRow {\n    font-family: ", ";\n    font-size: ", ";\n    display: table-row;\n  }\n\n  .DayPicker-Weekday {\n    display: table-cell;\n    color: ", ";\n    font-size: ", ";\n    font-weight: bold;\n    padding: ", ";\n    text-align: center;\n  }\n\n  .DayPicker-Weekday abbr[title] {\n    border-bottom: none;\n    text-decoration: none;\n  }\n\n  .DayPicker-Body {\n    font-family: ", ";\n    font-size: ", ";\n    color: ", ";\n    display: table-row-group;\n  }\n\n  .DayPicker-Week {\n    display: table-row;\n  }\n\n  .DayPicker-Day {\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n    cursor: pointer;\n  }\n\n  .DayPicker-inner-day {\n    margin-top: ", ";\n    margin-bottom: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    padding-right: ", ";\n    padding-left: ", ";\n    margin-left: -3px;\n    margin-right: -3px;\n  }\n\n  .DayPicker--interactionDisabled .DayPicker-Day {\n    cursor: default;\n  }\n\n  .DayPicker-Footer {\n    padding-top: ", ";\n  }\n\n  /* Default modifiers */\n  .DayPicker-Day--outside {\n    color: ", ";\n    cursor: default;\n  }\n\n  .DayPicker-Day--disabled {\n    color: ", ";\n    pointer-events: none;\n    cursor: default;\n  }\n\n  /* Selected day common */\n  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)\n    .DayPicker-inner-day {\n    position: relative;\n    background-color: ", ";\n    color: ", ";\n    z-index: 0;\n  }\n\n  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n    .DayPicker-inner-day {\n    background-color: ", ";\n  }\n\n  .DayPicker-Day:focus {\n    outline: none;\n  }\n\n  .DayPicker-Day:focus-within .DayPicker-inner-day {\n    outline: ", " auto 5px;\n  }\n\n  .DayPicker:focus,\n  .DayPicker-wrapper:focus,\n  .DayPicker-Months:focus {\n    outline: none;\n  }\n\n  /* Selected Start and End */\n  .DayPicker-Day--start:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n    .DayPicker-inner-day,\n  .DayPicker-Day--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n    .DayPicker-inner-day {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .DayPicker-Day--selected.DayPicker-Day--start:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)\n    .DayPicker-inner-day,\n  .DayPicker-Day--selected.DayPicker-Day--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside)\n    .DayPicker-inner-day {\n    font-weight: bold;\n    position: relative;\n    background-color: ", ";\n    color: ", ";\n    border-radius: ", ";\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: 0px;\n    margin-bottom: 0px;\n    z-index: 1;\n  }\n\n  .DayPicker-Day--selected.DayPicker-Day--end:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n    .DayPicker-inner-day,\n  .DayPicker-Day--selected.DayPicker-Day--start:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover\n    .DayPicker-inner-day {\n    background-color: ", ";\n  }\n\n  /* Single selection */\n\n  /* Disabled */\n  .DayPicker-Week .DayPicker-Day--selected:first-of-type .DayPicker-inner-day {\n    border-radius: 16px 0 0 16px;\n  }\n\n  .DayPicker-Week .DayPicker-Day--selected:last-of-type .DayPicker-inner-day {\n    border-radius: 0 16px 16px 0;\n  }\n\n  /* DayPickerInput */\n  .DayPickerInput {\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n  }\n\n  .DayPickerInput-OverlayWrapper {\n    position: relative;\n  }\n\n  .DayPickerInput-Overlay {\n    position: absolute;\n    left: 0;\n    z-index: 1;\n\n    background: white;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);\n  }\n\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject$Q = function _templateObject() {
    return data;
  };

  return data;
}
var arrowRightSvg = /*#__PURE__*/getBackgroundImageUrl("<svg viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.2704 8.83757C12.5955 8.51513 13.1198 8.5178 13.4416 8.84352L19.9343 15.4161C20.255 15.7407 20.2536 16.2638 19.9314 16.5868L13.4386 23.093C13.1152 23.4171 12.5908 23.4171 12.2674 23.093C11.944 22.7689 11.944 22.2435 12.2674 21.9194L18.1776 15.997L12.2645 10.0112C11.9427 9.68545 11.9454 9.16 12.2704 8.83757Z\" fill=\"currentColor\"/></svg>");
var DayPickerContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$Q(), function (props) {
  return props.theme.shadows.elevate;
}, function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.large;
}, arrowRightSvg, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.large;
}, arrowRightSvg, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.colors.grayLight;
}, function (props) {
  return props.theme.colors.focus;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.radii.l;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.colors.primaryLight;
}, function (props) {
  return props.rangeSelection ? css(_templateObject2$v()) : css(_templateObject3$k(), function (props) {
    return props.theme.colors.primary;
  }, function (props) {
    return props.theme.colors.white;
  }, function (props) {
    return props.theme.radii.l;
  }, function (props) {
    return props.theme.space.smaller;
  }, function (props) {
    return props.theme.space.smaller;
  }, function (props) {
    return props.theme.radii.l;
  }, function (props) {
    return props.theme.radii.l;
  });
}, layout, space);

// This fix the issue, but we could not find any better solutions using rollup

var DayPicker = DayPickerPackage__default;
var Calendar = function Calendar(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      modifiers = _ref.modifiers,
      selectedDays = _ref.selectedDays,
      _ref$rangeSelection = _ref.rangeSelection,
      rangeSelection = _ref$rangeSelection === void 0 ? false : _ref$rangeSelection,
      renderFooter = _ref.renderFooter,
      onDayClick = _ref.onDayClick,
      initialMonth = _ref.initialMonth,
      _ref$numberOfMonths = _ref.numberOfMonths,
      numberOfMonths = _ref$numberOfMonths === void 0 ? 1 : _ref$numberOfMonths,
      disabledDays = _ref.disabledDays,
      restProps = _objectWithoutPropertiesLoose(_ref, ["className", "modifiers", "selectedDays", "rangeSelection", "renderFooter", "onDayClick", "initialMonth", "numberOfMonths", "disabledDays"]);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var htmlProps = pickHTMLProps(restProps);
  return React.createElement(DayPickerContainer, {
    className: className,
    rangeSelection: rangeSelection
  }, React.createElement(DayPicker, Object.assign({
    locale: locale,
    months: MONTHS[locale],
    weekdaysLong: WEEKDAYS_LONG[locale],
    weekdaysShort: WEEKDAYS_SHORT[locale],
    firstDayOfWeek: FIRST_DAY_OF_WEEK[locale],
    labels: LABELS[locale],
    numberOfMonths: numberOfMonths,
    selectedDays: selectedDays,
    modifiers: modifiers,
    onDayClick: onDayClick,
    initialMonth: initialMonth,
    disabledDays: disabledDays,
    renderDay: function renderDay(day) {
      return React.createElement("div", {
        className: "DayPicker-inner-day"
      }, format(day, 'd'));
    }
  }, htmlProps)), renderFooter ? React.createElement("div", null, renderFooter()) : null);
};
Calendar.propTypes = {
  modifiers: PropTypes__default.object,
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  selectedDays: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.array]),
  rangeSelection: PropTypes__default.bool,
  renderFooter: PropTypes__default.func,
  onDayClick: PropTypes__default.func
};

var DayPicker$1 = DayPickerPackage__default;

var RangePicker = function RangePicker(_ref) {
  var modifiers = _ref.modifiers,
      _renderFooter = _ref.renderFooter,
      initialMonth = _ref.initialMonth,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$numberOfMonths = _ref.numberOfMonths,
      numberOfMonths = _ref$numberOfMonths === void 0 ? 1 : _ref$numberOfMonths,
      onChange = _ref.onChange,
      _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === void 0 ? {} : _ref$initialValue,
      disabledDays = _ref.disabledDays,
      restProps = _objectWithoutPropertiesLoose(_ref, ["modifiers", "renderFooter", "initialMonth", "className", "numberOfMonths", "onChange", "initialValue", "disabledDays"]);

  var _useState = useState(initialValue),
      selectedRange = _useState[0],
      setSelectedRange = _useState[1];

  var handleDayClick = function handleDayClick(day) {
    var range = DayPicker$1.DateUtils.addDayToRange(day, selectedRange);
    setSelectedRange(range);
    onChange === null || onChange === void 0 ? void 0 : onChange(range);
  };

  var from = selectedRange.from,
      to = selectedRange.to;

  var currentModifiers = _extends({
    start: from,
    end: to
  }, modifiers);

  var htmlProps = pickHTMLProps(restProps);
  return React.createElement(Calendar, Object.assign({
    rangeSelection: true,
    className: className,
    selectedDays: [from, {
      from: from,
      to: to
    }],
    modifiers: currentModifiers,
    onDayClick: handleDayClick,
    renderFooter: function renderFooter() {
      return (_renderFooter === null || _renderFooter === void 0 ? void 0 : _renderFooter(selectedRange)) || null;
    },
    initialMonth: initialMonth,
    numberOfMonths: numberOfMonths,
    disabledDays: disabledDays
  }, htmlProps));
};

RangePicker.propTypes = {
  renderFooter: PropTypes__default.func
};

var CLOSE$3 = {
  'pt-br': {
    close: 'Fechar notificação'
  },
  'en-us': {
    close: 'Close notification'
  },
  'es-mx': {
    close: 'Cerrar notificación'
  },
  'es-co': {
    close: 'Cerrar notificación'
  }
};

function _templateObject$R() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: ", ";\n  background-color: ", ";\n"]);

  _templateObject$R = function _templateObject() {
    return data;
  };

  return data;
}
var ErrorAlert$1 = /*#__PURE__*/css( /*#__PURE__*/_templateObject$R(), function (props) {
  return props.theme.colors.error;
}, function (props) {
  return props.theme.colors.error;
});

function _templateObject$S() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  border-color: ", ";\n  background-color: ", ";\n"]);

  _templateObject$S = function _templateObject() {
    return data;
  };

  return data;
}
var WarningAlert = /*#__PURE__*/css( /*#__PURE__*/_templateObject$S(), function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.colors.attention;
}, function (props) {
  return props.theme.colors.attention;
});

function _templateObject$T() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: bold;\n"]);

  _templateObject$T = function _templateObject() {
    return data;
  };

  return data;
}
var ReducedSnackbar = /*#__PURE__*/css( /*#__PURE__*/_templateObject$T(), function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.fontSizes.xs;
}, function (props) {
  return props.theme.lineHeights.s;
});

function _templateObject$U() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  color: ", ";\n"]);

  _templateObject$U = function _templateObject() {
    return data;
  };

  return data;
}
var SucessAlert = /*#__PURE__*/css( /*#__PURE__*/_templateObject$U(), function (props) {
  return props.theme.colors.positive;
}, function (props) {
  return props.theme.colors.white;
});

function _templateObject$V() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: ", ";\n  background-color: ", ";\n"]);

  _templateObject$V = function _templateObject() {
    return data;
  };

  return data;
}
var NeutralAlert$1 = /*#__PURE__*/css( /*#__PURE__*/_templateObject$V(), function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.colors.black;
});

function _templateObject9$4() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n"]);

  _templateObject9$4 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$5() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 0px;\n  line-height: 0px;\n  margin-left: ", ";\n  pointer-events: all;\n  width: ", ";\n"]);

  _templateObject8$5 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$6() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n"]);

  _templateObject7$6 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$8() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: 0;\n  line-height: 0;\n  margin-right: ", ";\n"]);

  _templateObject6$8 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$b() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject5$b = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$d() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject4$d = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$l() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3$l = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$w() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2$w = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$W() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border-radius: ", ";\n  box-shadow: 0px 2px 2px rgba(62, 62, 62, 0.15);\n\n  font-family: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n\n  ", "\n"]);

  _templateObject$W = function _templateObject() {
    return data;
  };

  return data;
}
var Container$8 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$W(), function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.small;
}, SucessAlert, function (props) {
  return props.variant === 'error' ? ErrorAlert$1 : css(_templateObject2$w());
}, function (props) {
  return props.variant === 'warning' ? WarningAlert : css(_templateObject3$l());
}, function (props) {
  return props.variant === 'neutral' ? NeutralAlert$1 : css(_templateObject4$d());
}, function (props) {
  return props.reduced ? ReducedSnackbar : css(_templateObject5$b());
});
var IconContainer$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject6$8(), function (props) {
  return props.theme.space.smaller;
});
var MessageContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject7$6());
var CloseIconContainer$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject8$5(), function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
});
var CloseIcon$3 = /*#__PURE__*/styled(Icon$1)( /*#__PURE__*/_templateObject9$4());

var checkIconAcessibilityIssue = function checkIconAcessibilityIssue(variant, withoutIcon) {
  var hasAcessibilityIssue = withoutIcon && variant !== 'neutral';
  return hasAcessibilityIssue ? console.warn('Attention! For success, warning or error use the support icons. Colors should not be used as the only way to convey content or distinguish visual elements.') : false;
};

var Snackbar = function Snackbar(_ref) {
  var _ref$autoClose = _ref.autoClose,
      autoClose = _ref$autoClose === void 0 ? true : _ref$autoClose,
      message = _ref.message,
      closeAriaLabel = _ref.closeAriaLabel,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon,
      closeToast = _ref.closeToast,
      withoutDefaultIcon = _ref.withoutDefaultIcon,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'success' : _ref$variant,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["autoClose", "message", "closeAriaLabel", "icon", "closeToast", "withoutDefaultIcon", "variant", "children"]);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var defaultIcon = variant === 'success' ? SuccessFilled : AlertFilled;
  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);
  var shouldShowIconContainer = !!icon || !withoutDefaultIcon;
  useMemo(function () {
    return checkIconAcessibilityIssue(variant, !!withoutDefaultIcon);
  }, [variant, withoutDefaultIcon]);
  return React.createElement(Container$8, Object.assign({
    "data-testid": "snackbar",
    variant: variant
  }, htmlProps, styledSystemProps), shouldShowIconContainer && React.createElement(IconContainer$1, null, React.createElement(Icon$1, {
    component: icon || defaultIcon,
    size: "xs"
  })), React.createElement(MessageContainer, null, message, React.createElement("div", null, children)), React.createElement(CloseIconContainer$1, {
    variant: variant
  }, !autoClose && React.createElement(CloseIcon$3, {
    role: "button",
    onClick: closeToast,
    component: Close,
    size: "xs",
    tabIndex: 0,
    "aria-label": closeAriaLabel || CLOSE$3[locale].close
  })));
};
var snackbar = function snackbar(props) {
  var snackbarOptions = _extends({}, props.autoClose == false ? {
    autoClose: false
  } : {
    autoClose: props.timeout || 10000
  });

  toast(React.createElement(Snackbar, Object.assign({}, props)), snackbarOptions);
};
Snackbar.propTypes = {
  autoClose: PropTypes__default.bool,
  message: PropTypes__default.string.isRequired,
  closeAriaLabel: PropTypes__default.string,
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  icon: PropTypes__default.node,
  variant: /*#__PURE__*/PropTypes__default.oneOf(['success', 'error', 'warning', 'neutral']),
  closeToast: PropTypes__default.func,
  timeout: PropTypes__default.number,
  reduced: PropTypes__default.bool
};

var LOCALES = {
  'pt-br': {
    of: 'de',
    step: 'Passo'
  },
  'en-us': {
    of: 'of',
    step: 'Step'
  },
  'es-mx': {
    of: 'de',
    step: 'Paso'
  },
  'es-co': {
    of: 'de',
    step: 'Paso'
  }
};
var formatMessage = function formatMessage(locale) {
  return function (key) {
    var formattedMessage = LOCALES[locale][key];

    if (!formattedMessage) {
      // eslint-disable-next-line no-console
      console.warn("No message found in Stepper Locales with \"" + locale + "\" locale and \"" + key + "\" key");
      return '';
    }

    return formattedMessage;
  };
};

function _templateObject3$m() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  overflow: hidden;\n\n  ", " {\n    margin-left: ", ";\n    margin-right: ", ";\n\n    &:first-child {\n      margin-left: ", ";\n    }\n\n    &:last-child {\n      margin-right: ", ";\n    }\n  }\n"]);

  _templateObject3$m = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$x() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  border-radius: ", ";\n\n  flex-grow: 1;\n  transition: ", ";\n\n  background-color: ", ";\n"]);

  _templateObject2$x = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$X() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  margin-top: ", ";\n  margin-bottom: ", ";\n\n  ", " {\n    text-align: right;\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject$X = function _templateObject() {
    return data;
  };

  return data;
}
var Container$9 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$X(), function (props) {
  return props.theme.space.larger;
}, function (props) {
  return props.theme.space.larger;
}, BaseText, space, layout);
var Step = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$x(), function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.radii.m;
}, function (_ref) {
  var _ref$theme = _ref.theme,
      durations = _ref$theme.durations,
      timingFunctions = _ref$theme.timingFunctions;
  return mountTransition([['background-color', durations.slowly, timingFunctions.easeIn]]);
}, function (props) {
  return props.complete ? props.theme.colors.primary : props.theme.colors.gray;
});
var Steps = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$m(), Step, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.none;
}, function (props) {
  return props.theme.space.none;
});

function normalizeActiveIndex(activeIndex, steps) {
  var maxIndex = steps - 1;

  if (activeIndex > maxIndex) {
    console.warn("Active index must be lesser or equal than " + (maxIndex < 0 ? 0 : maxIndex));
    return maxIndex;
  }

  if (activeIndex < 0) {
    console.warn('Active index must be greater or equal than 0');
    return 0;
  }

  return activeIndex;
}
/**
 * Stepper component description
 */


var Stepper = function Stepper(props) {
  var className = props.className,
      steps = props.steps,
      activeIndex = props.activeIndex,
      otherProps = _objectWithoutPropertiesLoose(props, ["className", "steps", "activeIndex"]);

  var styledSystemProps = pick(otherProps);
  var htmlProps = pickHTMLProps(otherProps);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var formattedMessage = formatMessage(locale);
  var normalizedActiveIndex = normalizeActiveIndex(activeIndex, steps);
  var memoizedSteps = useMemo(function () {
    if (steps <= 0) {
      console.warn('Steps count must be greater than 0');
      return [];
    }

    return Array.from(new Array(steps), function (_, index) {
      return {
        complete: index <= normalizedActiveIndex
      };
    });
  }, [steps, normalizedActiveIndex]);

  if (memoizedSteps.length === 0) {
    return null;
  }

  var stepsText = formattedMessage('step') + " " + (normalizedActiveIndex + 1) + " " + formattedMessage('of') + " " + steps;
  return React.createElement(Container$9, Object.assign({
    className: className
  }, styledSystemProps, htmlProps), React.createElement(Steps, null, memoizedSteps.map(function (_ref2, index) {
    var complete = _ref2.complete;
    return React.createElement(Step, {
      key: index,
      complete: complete
    });
  })), React.createElement(Text, null, stepsText));
};
Stepper.propTypes = {
  activeIndex: PropTypes__default.number.isRequired,
  steps: PropTypes__default.number.isRequired,
  initialIndex: PropTypes__default.number
};

function _templateObject6$9() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n"]);

  _templateObject6$9 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$c() {
  var data = _taggedTemplateLiteralLoose(["\n  .rc-tabs-dropdown {\n    position: absolute;\n    background: #fefefe;\n    border: 1px solid black;\n    max-height: 200px;\n    overflow: auto;\n  }\n  .rc-tabs-dropdown-hidden {\n    display: none;\n  }\n  .rc-tabs-dropdown-menu {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n  }\n  .rc-tabs-dropdown-menu-item {\n    padding: 4px 8px;\n  }\n  .rc-tabs-dropdown-menu-item-selected {\n    background: red;\n  }\n  .rc-tabs-dropdown-menu-item-disabled {\n    opacity: 0.3;\n    cursor: not-allowed;\n  }\n  .rc-tabs-content {\n    display: flex;\n    width: 100%;\n  }\n  .rc-tabs-content-holder {\n    flex: auto;\n  }\n  .rc-tabs-content-animated {\n    transition: margin 0.3s;\n  }\n  .rc-tabs-tabpane {\n    width: 100%;\n    flex: none;\n  }\n  &.rc-tabs {\n    display: flex;\n  }\n  &.rc-tabs-top,\n  &.rc-tabs-bottom {\n    flex-direction: column;\n  }\n  .rc-tabs-top .rc-tabs-ink-bar,\n  .rc-tabs-bottom .rc-tabs-ink-bar {\n    height: 3px;\n  }\n  .rc-tabs-top .rc-tabs-ink-bar {\n    bottom: 0;\n  }\n  .rc-tabs-bottom .rc-tabs-nav {\n    order: 1;\n  }\n  .rc-tabs-bottom .rc-tabs-content {\n    order: 0;\n  }\n  .rc-tabs-bottom .rc-tabs-ink-bar {\n    top: 0;\n  }\n  .rc-tabs-left.rc-tabs-editable .rc-tabs-tab,\n  .rc-tabs-right.rc-tabs-editable .rc-tabs-tab {\n    padding-right: 32px;\n  }\n  .rc-tabs-left .rc-tabs-nav-wrap,\n  .rc-tabs-right .rc-tabs-nav-wrap {\n    flex-direction: column;\n  }\n  .rc-tabs-left .rc-tabs-ink-bar,\n  .rc-tabs-right .rc-tabs-ink-bar {\n    width: 3px;\n  }\n  &.rc-tabs-left .rc-tabs-nav,\n  &.rc-tabs-right .rc-tabs-nav {\n    flex-direction: column;\n    min-width: 50px;\n  }\n  &.rc-tabs-left .rc-tabs-nav-list,\n  &.rc-tabs-right .rc-tabs-nav-list,\n  &.rc-tabs-left .rc-tabs-nav-operations,\n  &.rc-tabs-right .rc-tabs-nav-operations {\n    flex: 1 0 auto;\n    flex-direction: column;\n  }\n  &.rc-tabs-left .rc-tabs-ink-bar {\n    right: 0;\n  }\n  &.rc-tabs-right .rc-tabs-nav {\n    order: 1;\n  }\n  &.rc-tabs-right .rc-tabs-content {\n    order: 0;\n  }\n  &.rc-tabs-right .rc-tabs-ink-bar {\n    left: 0;\n  }\n  .rc-tabs-rtl {\n    direction: rtl;\n  }\n  .rc-tabs-dropdown-rtl {\n    direction: rtl;\n  }\n  &.rc-tabs {\n    overflow: hidden;\n  }\n  .rc-tabs-nav {\n    display: flex;\n    flex: none;\n    position: relative;\n  }\n  .rc-tabs-nav-measure,\n  .rc-tabs-nav-wrap {\n    transform: translate(0);\n    position: relative;\n    display: inline-block;\n    flex: auto;\n    white-space: nowrap;\n    overflow: hidden;\n    display: flex;\n  }\n  .rc-tabs-nav-measure-ping-left::before,\n  .rc-tabs-nav-wrap-ping-left::before,\n  .rc-tabs-nav-measure-ping-right::after,\n  .rc-tabs-nav-wrap-ping-right::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n  }\n  .rc-tabs-nav-measure-ping-left::before,\n  .rc-tabs-nav-wrap-ping-left::before {\n    left: 0;\n    border-left: 1px solid red;\n  }\n  .rc-tabs-nav-measure-ping-right::after,\n  .rc-tabs-nav-wrap-ping-right::after {\n    right: 0;\n    border-right: 1px solid red;\n  }\n  .rc-tabs-nav-measure-ping-top::before,\n  .rc-tabs-nav-wrap-ping-top::before,\n  .rc-tabs-nav-measure-ping-bottom::after,\n  .rc-tabs-nav-wrap-ping-bottom::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n  }\n  .rc-tabs-nav-measure-ping-top::before,\n  .rc-tabs-nav-wrap-ping-top::before {\n    top: 0;\n    border-top: 1px solid red;\n  }\n  .rc-tabs-nav-measure-ping-bottom::after,\n  .rc-tabs-nav-wrap-ping-bottom::after {\n    bottom: 0;\n    border-top: 1px solid red;\n  }\n  .rc-tabs-nav-list {\n    display: flex;\n    position: relative;\n    transition: transform 0.3s;\n  }\n  .rc-tabs-nav-operations {\n    display: flex;\n  }\n  .rc-tabs-nav-operations-hidden {\n    position: absolute;\n    visibility: hidden;\n    pointer-events: none;\n  }\n  .rc-tabs-nav-more {\n    border: 1px solid blue;\n    background: rgba(255, 0, 0, 0.1);\n  }\n  .rc-tabs-nav-add {\n    border: 1px solid green;\n    background: rgba(0, 255, 0, 0.1);\n  }\n  .rc-tabs-tab {\n    border: 0;\n    font-size: 20px;\n    background: rgba(255, 255, 255, 0.5);\n    margin: 0;\n    display: flex;\n    outline: none;\n    cursor: pointer;\n    position: relative;\n    font-weight: lighter;\n    align-items: center;\n  }\n  .rc-tabs-tab-btn,\n  .rc-tabs-tab-remove {\n    border: 0;\n    background: transparent;\n  }\n  .rc-tabs-tab-btn {\n    font-weight: inherit;\n    line-height: 32px;\n  }\n  .rc-tabs-tab-remove:hover {\n    color: red;\n  }\n  .rc-tabs-tab-active {\n    font-weight: bolder;\n  }\n  .rc-tabs-ink-bar {\n    position: absolute;\n    background: red;\n    pointer-events: none;\n  }\n  .rc-tabs-ink-bar-animated {\n    transition: all 0.3s;\n  }\n  .rc-tabs-extra-content {\n    flex: none;\n  }\n"]);

  _templateObject5$c = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$e() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n  "]);

  _templateObject4$e = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$n() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  ", "\n"]);

  _templateObject3$n = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$y() {
  var data = _taggedTemplateLiteralLoose(["\n    margin-right: ", ";\n    border-right: 1px solid ", ";\n  "]);

  _templateObject2$y = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$Y() {
  var data = _taggedTemplateLiteralLoose(["\n    overflow-x: auto;\n    border-bottom: 1px solid ", ";\n  "]);

  _templateObject$Y = function _templateObject() {
    return data;
  };

  return data;
}
var headerModifiers = {
  top: function top() {
    return css(_templateObject$Y(), function (props) {
      return props.theme.colors.gray;
    });
  },
  left: function left() {
    return css(_templateObject2$y(), tokens.space.regular, function (props) {
      return props.theme.colors.gray;
    });
  }
};
var Header$3 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$n(), function (_ref) {
  var placement = _ref.placement;
  return css(_templateObject4$e(), headerModifiers[placement]);
}); // Be carefull changing this properties, the css here is a minimal version
// that only works with this set of configs, this is a minimalist version of "rc-tabs/assets/index.css"

var TabsContainer = /*#__PURE__*/styled(Tabs$1)( /*#__PURE__*/_templateObject5$c());
var CustomTabPane = /*#__PURE__*/styled(TabPane)( /*#__PURE__*/_templateObject6$9(), function (props) {
  return props.theme.fontSizes.s;
});

function _templateObject3$o() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-self: stretch;\n  justify-content: flex-start;\n  flex-shrink: 0;\n  height: 100%;\n  overflow: hidden;\n  outline: none;\n"]);

  _templateObject3$o = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$z() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-direction: row;\n  direction: ltr;\n  will-change: transform;\n  min-height: 0;\n  flex: 1;\n  display: flex;\n"]);

  _templateObject2$z = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$Z() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n  ", "\n  ", "\n"]);

  _templateObject$Z = function _templateObject() {
    return data;
  };

  return data;
}
var Container$a = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$Z(), space, layout);
var PagerAnimatedContainer = /*#__PURE__*/styled(motion.div)( /*#__PURE__*/_templateObject2$z());
var Page = /*#__PURE__*/styled(motion.div)( /*#__PURE__*/_templateObject3$o());
var Carousel = function Carousel(_ref) {
  var children = _ref.children,
      currentIndex = _ref.currentIndex;
  return React.createElement(Container$a, null, React.createElement(PagerAnimatedContainer, {
    transition: {
      tension: 190,
      friction: 70,
      mass: 0.4
    },
    initial: false,
    animate: {
      x: currentIndex * -100 + "%"
    }
  }, React.createElement(AnimatePresence, null, Children.map(children, function (child, i) {
    return React.createElement(Page, {
      key: i,
      "aria-hidden": currentIndex !== i,
      tabIndex: currentIndex === i ? 0 : -1,
      animate: {
        opacity: 1
      },
      exit: {
        opacity: 0
      }
    }, child);
  }))));
};
Carousel.propTypes = {
  currentIndex: PropTypes__default.number.isRequired
};

function _templateObject$_() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$_ = function _templateObject() {
    return data;
  };

  return data;
}
var PositiveTag = /*#__PURE__*/css( /*#__PURE__*/_templateObject$_(), function (props) {
  return props.theme.colors.positive;
}, function (props) {
  return props.theme.colors.positive;
});

function _templateObject$$() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$$ = function _templateObject() {
    return data;
  };

  return data;
}
var ErrorTag = /*#__PURE__*/css( /*#__PURE__*/_templateObject$$(), function (props) {
  return props.theme.colors.error;
}, function (props) {
  return props.theme.colors.error;
});

function _templateObject$10() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$10 = function _templateObject() {
    return data;
  };

  return data;
}
var AttentionTag = /*#__PURE__*/css( /*#__PURE__*/_templateObject$10(), function (props) {
  return props.theme.colors.attention;
}, function (props) {
  return props.theme.colors.attention;
});

function _templateObject$11() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$11 = function _templateObject() {
    return data;
  };

  return data;
}
var RequiredTag = /*#__PURE__*/css( /*#__PURE__*/_templateObject$11(), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.white;
});

function _templateObject$12() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$12 = function _templateObject() {
    return data;
  };

  return data;
}
var SecondaryTag = /*#__PURE__*/css( /*#__PURE__*/_templateObject$12(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});

function _templateObject$13() {
  var data = _taggedTemplateLiteralLoose(["\n  border-color: ", ";\n  color: ", ";\n"]);

  _templateObject$13 = function _templateObject() {
    return data;
  };

  return data;
}
var NeutralTag = /*#__PURE__*/css( /*#__PURE__*/_templateObject$13(), function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.grayDarker;
});

function _templateObject11$2() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject11$2 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$3() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject10$3 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$5() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject9$5 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$6() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject8$6 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$7() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject7$7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$a() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject6$a = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$d() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject5$d = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$f() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-top: calc(", " - 1px);\n  padding-bottom: calc(", " - 1px);\n  border-style: solid;\n  border-width: 1px;\n  font-weight: bold;\n  font-family: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject4$f = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$p() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  line-height: ", ";\n  padding: ", ";\n"]);

  _templateObject3$p = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$A() {
  var data = _taggedTemplateLiteralLoose(["\n  line-height: ", ";\n  font-size: ", ";\n  border-radius: 16px;\n"]);

  _templateObject2$A = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$14() {
  var data = _taggedTemplateLiteralLoose(["\n  line-height: ", ";\n  font-size: ", ";\n  border-radius: 24px;\n"]);

  _templateObject$14 = function _templateObject() {
    return data;
  };

  return data;
}
var MediumTag = /*#__PURE__*/css( /*#__PURE__*/_templateObject$14(), function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.fontSizes.m;
});
var SmallTag = /*#__PURE__*/css( /*#__PURE__*/_templateObject2$A(), function (props) {
  return props.theme.lineHeights.s;
}, function (props) {
  return props.theme.fontSizes.xs;
});
var ExtraSmallTag = /*#__PURE__*/css( /*#__PURE__*/_templateObject3$p(), SmallTag, function (props) {
  return props.theme.lineHeights.xs;
}, function (props) {
  return props.theme.space.smallest + " " + props.theme.space.smaller;
});
var BaseTag = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$f(), function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.fonts.primary;
}, NeutralTag, function (props) {
  return props.variant === 'secondary' ? SecondaryTag : css(_templateObject5$d());
}, function (props) {
  return props.variant === 'positive' ? PositiveTag : css(_templateObject6$a());
}, function (props) {
  return props.variant === 'error' ? ErrorTag : css(_templateObject7$7());
}, function (props) {
  return props.variant === 'attention' ? AttentionTag : css(_templateObject8$6());
}, function (props) {
  return props.variant === 'required' ? RequiredTag : css(_templateObject9$5());
}, MediumTag, function (props) {
  return props.size === 's' ? SmallTag : css(_templateObject10$3());
}, function (props) {
  return props.size === 'xs' ? ExtraSmallTag : css(_templateObject11$2());
}, space, layout);

var Tag = function Tag(_ref) {
  var variant = _ref.variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "size", "children"]);

  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);
  return React.createElement(BaseTag, Object.assign({
    variant: variant,
    size: size
  }, htmlProps, styledSystemProps), children);
};
Tag.propTypes = {
  variant: /*#__PURE__*/PropTypes__default.oneOf(['neutral', 'secondary', 'positive', 'error', 'attention', 'required']),
  size: /*#__PURE__*/PropTypes__default.oneOf(['m', 's', 'xs']),
  children: PropTypes__default.node
};

function _templateObject5$e() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n\n  ", ",\n  ", " {\n    align-self: flex-start;\n    margin-left: ", ";\n  }\n"]);

  _templateObject5$e = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$g() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n\n  width: ", ";\n  height: ", ";\n\n  background-color: ", ";\n  border-radius: ", ";\n\n  padding: 2px;\n"]);

  _templateObject4$g = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$q() {
  var data = _taggedTemplateLiteralLoose(["\n            color: ", ";\n          "]);

  _templateObject3$q = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$B() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2$B = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$15() {
  var data = _taggedTemplateLiteralLoose(["\n  border: none;\n  outline: none;\n  cursor: ", ";\n\n  box-sizing: border-box;\n  white-space: nowrap;\n  text-align: center;\n  text-overflow: ellipsis;\n  font-size: ", ";\n  font-family: ", ";\n  line-height: ", ";\n\n  color: ", ";\n\n  padding: ", ";\n  background-color: ", ";\n\n  :hover {\n    background-color: ", ";\n\n    ", "\n  }\n\n  margin: 2px;\n  margin-bottom: ", ";\n\n  &:focus {\n    outline: ", " auto 1px;\n    border-radius: ", ";\n  }\n"]);

  _templateObject$15 = function _templateObject() {
    return data;
  };

  return data;
}
var Button$1 = /*#__PURE__*/styled(motion.button)( /*#__PURE__*/_templateObject$15(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.theme.fontSizes.m;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.active ? props.theme.colors.primary : props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.space.smallest + " " + props.theme.space.regular;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.white;
}, function (_ref) {
  var theme = _ref.theme,
      active = _ref.active,
      disabled = _ref.disabled;
  return disabled ? css(_templateObject2$B()) : css(_templateObject3$q(), active ? theme.colors.primary : theme.colors.grayDarkest);
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.colors.focus;
}, function (props) {
  return props.theme.radii.m;
});
var Badge$1 = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject4$g(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.fontSizes.xs;
}, function (props) {
  return props.theme.lineHeights.s;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.radii.l;
});
var Container$b = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$e(), Badge$1, BaseTag, function (props) {
  return props.theme.space.smallest;
});

function isTagVariant(variant) {
  return variant === 'tag';
}

function isBadgeVariant(variant) {
  return variant === 'badge';
}

function isNotificationLabelValid(notification) {
  if (!notification) {
    return false;
  }

  var variant = notification.variant,
      label = notification.label;

  if (!isTagVariant(variant) && !isBadgeVariant(variant)) {
    console.warn("Pane notification variant: \"" + variant + "\" is not a \"tag\" nor \"badge\"");
    return false;
  }

  var expectedType = isTagVariant(variant) ? 'string' : 'number';
  var hasExpectedLabelType = typeof label === expectedType;
  var isValidLabel = typeof label === 'string' ? label.length > 0 : label !== undefined;

  if (!hasExpectedLabelType) {
    console.warn("Pane notification label: \"" + label + "\" does not have the expected type \"" + expectedType + "\"");
  }

  if (!isValidLabel) {
    console.warn("Pane notification label: \"" + label + "\" is not valid");
  }

  return isValidLabel && hasExpectedLabelType;
}

var Item = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      _ref2$active = _ref2.active,
      active = _ref2$active === void 0 ? false : _ref2$active,
      notification = _ref2.notification,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      onClick = _ref2.onClick;

  var _useState = useState(false),
      touch = _useState[0],
      setTouch = _useState[1];

  var isPersistent = notification === null || notification === void 0 ? void 0 : notification.isPersistent;
  useEffect(function () {
    if (touch && !active) {
      return;
    }

    setTouch(active);
  }, [active, touch]);

  var handleClick = function handleClick() {
    setTouch(true);
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };

  var hasNotification = isNotificationLabelValid(notification);
  var showNotification = isPersistent ? hasNotification && !active : hasNotification && !active && !touch;
  var NotificationNode = isTagVariant(notification === null || notification === void 0 ? void 0 : notification.variant) ? React.createElement(Tag, {
    variant: "secondary",
    size: "xs"
  }, notification === null || notification === void 0 ? void 0 : notification.label) : React.createElement(Badge$1, null, notification === null || notification === void 0 ? void 0 : notification.label);
  return React.createElement(Button$1, {
    active: !disabled && active,
    onClick: handleClick,
    ref: ref,
    disabled: disabled,
    type: "button"
  }, React.createElement(Container$b, null, children, showNotification && NotificationNode));
});

function _templateObject$16() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n"]);

  _templateObject$16 = function _templateObject() {
    return data;
  };

  return data;
}
var Pane = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$16());

function _templateObject4$h() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n  "]);

  _templateObject4$h = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$r() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: 2px;\n  margin-right: 2px;\n  position: absolute;\n  background: ", ";\n\n  ", "\n"]);

  _templateObject3$r = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$C() {
  var data = _taggedTemplateLiteralLoose(["\n    height: 2px;\n    bottom: 0;\n    transition: ", ";\n  "]);

  _templateObject2$C = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$17() {
  var data = _taggedTemplateLiteralLoose(["\n    width: 2px;\n    right: -2px;\n    transition: ", ";\n  "]);

  _templateObject$17 = function _templateObject() {
    return data;
  };

  return data;
}
var SliderModifiers = {
  left: function left() {
    return css(_templateObject$17(), function (_ref) {
      var _ref$theme = _ref.theme,
          durations = _ref$theme.durations,
          timingFunctions = _ref$theme.timingFunctions;
      return mountTransition([['top', durations.slowly, timingFunctions.easeInOut], ['height', durations.slowly, timingFunctions.easeInOut]]);
    });
  },
  top: function top() {
    return css(_templateObject2$C(), function (_ref2) {
      var _ref2$theme = _ref2.theme,
          durations = _ref2$theme.durations,
          timingFunctions = _ref2$theme.timingFunctions;
      return mountTransition([['left', durations.slowly, timingFunctions.easeInOut], ['width', durations.slowly, timingFunctions.easeInOut]]);
    });
  }
};
var Slider = /*#__PURE__*/styled(motion.div)( /*#__PURE__*/_templateObject3$r(), function (props) {
  return props.theme.colors.primary;
}, function (_ref3) {
  var placement = _ref3.placement;
  return css(_templateObject4$h(), SliderModifiers[placement]);
});

function _templateObject$18() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow-y: hidden;\n\n  ", "\n  ", "\n"]);

  _templateObject$18 = function _templateObject() {
    return data;
  };

  return data;
}
var Container$c = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$18(), space, layout);

function parseTabs(children) {
  return Children.toArray(children).map(function (node) {
    if (!isValidElement(node)) {
      return null;
    }

    var key = node.key !== undefined ? String(node.key) : undefined;
    return _extends({
      key: key
    }, node.props, {
      node: node
    });
  }).filter(Boolean);
}

function getInitialActiveIndex(props, tabs) {
  var _ref, _props$activeIndex;

  var initialIndex = (_ref = (_props$activeIndex = props === null || props === void 0 ? void 0 : props.activeIndex) !== null && _props$activeIndex !== void 0 ? _props$activeIndex : props === null || props === void 0 ? void 0 : props.initialIndex) !== null && _ref !== void 0 ? _ref : 0;
  return initialIndex > tabs.length ? tabs.length - 1 : initialIndex;
}

var Tabs = function Tabs(props) {
  var className = props.className,
      children = props.children,
      overrideIndex = props.activeIndex,
      onChange = props.onChange,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'top' : _props$placement,
      otherProps = _objectWithoutPropertiesLoose(props, ["className", "children", "activeIndex", "onChange", "placement"]);

  var styledSystemProps = pick(otherProps);
  var htmlProps = pickHTMLProps(otherProps);
  var tabs = useMemo(function () {
    return parseTabs(children);
  }, [children]);

  var _useState = useState(getInitialActiveIndex(props, tabs)),
      index = _useState[0],
      setIndex = _useState[1];

  var activeIndex = overrideIndex !== null && overrideIndex !== void 0 ? overrideIndex : index;
  useEffect(function () {
    if (overrideIndex === undefined) {
      return;
    }

    setIndex(overrideIndex);
    onChange === null || onChange === void 0 ? void 0 : onChange(overrideIndex, tabs);
  }, [overrideIndex, tabs, onChange]);
  var childRefs = useRef(new Map());
  var headerRef = useRef(null);

  var _useState2 = useState({
    visible: false
  }),
      slider = _useState2[0],
      setSlider = _useState2[1]; // Slider calculation


  useEffect(function () {
    var _setSlider;

    var MAP_PLACEMENT_TO_SLIDER = {
      left: {
        direction: 'top',
        dimension: 'height',
        scroll: 'scrollTop'
      },
      top: {
        direction: 'left',
        dimension: 'width',
        scroll: 'scrollLeft'
      }
    }[placement];
    var target = childRefs.current.get(activeIndex);
    var container = headerRef.current;

    if (!target || !container) {
      return;
    }

    var cRect = container.getBoundingClientRect();

    if (!cRect || cRect.width === 0 || cRect.height === 0) {
      return;
    }

    var tRect = target.getBoundingClientRect();
    var valueOfDirection = tRect[MAP_PLACEMENT_TO_SLIDER.direction] + container[MAP_PLACEMENT_TO_SLIDER.scroll] - cRect[MAP_PLACEMENT_TO_SLIDER.direction];
    var valueOfDimension = tRect[MAP_PLACEMENT_TO_SLIDER.dimension];
    setSlider((_setSlider = {
      visible: true
    }, _setSlider[MAP_PLACEMENT_TO_SLIDER.direction] = valueOfDirection, _setSlider[MAP_PLACEMENT_TO_SLIDER.dimension] = valueOfDimension, _setSlider));
  }, [activeIndex, placement]);

  var handleIndexChange = function handleIndexChange(newIndex) {
    return function () {
      setIndex(newIndex);
      onChange === null || onChange === void 0 ? void 0 : onChange(newIndex, tabs);
    };
  };

  var renderTabsWithHeader = function renderTabsWithHeader(DefaultTabBarProps, DefaultTabBar) {
    return React.createElement(Header$3, {
      placement: placement,
      ref: headerRef
    }, React.createElement(DefaultTabBar, Object.assign({}, DefaultTabBarProps)), slider.visible && React.createElement(Slider, {
      placement: placement,
      initial: false,
      style: _extends({}, slider)
    }));
  };

  useEffect(function () {
    var _document;

    var elements = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelectorAll('.rc-tabs-tab-btn');
    elements === null || elements === void 0 ? void 0 : elements.forEach(function (element) {
      return element.removeAttribute('tabindex');
    });
  }, []);
  return React.createElement(Container$c, Object.assign({
    className: className
  }, styledSystemProps, htmlProps), React.createElement(TabsContainer, {
    defaultActiveKey: activeIndex.toString(),
    tabPosition: placement,
    renderTabBar: renderTabsWithHeader
  }, tabs.map(function (tab, i) {
    return React.createElement(CustomTabPane, {
      key: tab.key,
      active: i === activeIndex,
      tab: React.createElement(Item, {
        key: tab.key,
        active: i === activeIndex,
        transition: {
          duration: 0.25
        },
        onClick: handleIndexChange(i),
        label: tab.label,
        notification: tab.notification,
        ref: function ref(el) {
          childRefs.current.set(i, el);
        },
        disabled: tab.disabled
      }, tab.label),
      disabled: tab.disabled,
      forceRender: true
    }, React.createElement(Carousel, {
      currentIndex: activeIndex
    }, tabs.map(function (tab) {
      return tab.node;
    })));
  })));
};

Tabs.propTypes = {
  activeIndex: PropTypes__default.number,
  children: /*#__PURE__*/PropTypes__default.oneOfType([/*#__PURE__*/PropTypes__default.arrayOf(PropTypes__default.node), PropTypes__default.node]).isRequired,
  initialIndex: PropTypes__default.number,
  onChange: PropTypes__default.func,
  placement: /*#__PURE__*/PropTypes__default.oneOf(['top', 'left'])
};
Tabs.Pane = Pane; // We need to export first the default component to Styleguidist Docs

function _templateObject3$s() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  ", "\n  ", "\n"]);

  _templateObject3$s = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$D() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: inline-block;\n"]);

  _templateObject2$D = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$19() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: ", ";\n  clip-path: ", ";\n  position: ", ";\n  z-index: ", ";\n\n  svg {\n    transition: color 0.1s;\n  }\n"]);

  _templateObject$19 = function _templateObject() {
    return data;
  };

  return data;
}
var sizeMap$2 = {
  s: '16px',
  m: '24px',
  l: '32px',
  xl: '40px'
};
var StarIcon = /*#__PURE__*/styled(Icon$1).attrs(function (_ref) {
  var size = _ref.size;
  return {
    component: Star,
    width: sizeMap$2[size],
    height: sizeMap$2[size]
  };
})( /*#__PURE__*/_templateObject$19(), function (_ref2) {
  var readOnly = _ref2.readOnly;
  return readOnly ? 'default' : 'pointer';
}, function (_ref3) {
  var half = _ref3.half;
  return half ? 'polygon(0 0, 50% 0, 50% 100%, 0 100%)' : 'none';
}, function (_ref4) {
  var half = _ref4.half;
  return half ? 'absolute' : 'relative';
}, function (_ref5) {
  var half = _ref5.half;
  return half ? '9' : '0';
});
var StarWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$D());
var StarsContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$s(), space, layout);

var filledColor = '#FCBB00';
var StarRating = function StarRating(_ref) {
  var _ref$count = _ref.count,
      count = _ref$count === void 0 ? 5 : _ref$count,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 'half' : _ref$scale,
      rating = _ref.rating,
      onRating = _ref.onRating,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      restProps = _objectWithoutPropertiesLoose(_ref, ["count", "scale", "rating", "onRating", "size", "disabled"]);

  var _useState = useState(0),
      indexHoverRating = _useState[0],
      setIndexHoverRating = _useState[1];

  var _tokens$colors = tokens.colors,
      unfilledColor = _tokens$colors.gray,
      disabledColor = _tokens$colors.grayLight;
  var styledSystemProps = pick(restProps);
  var htmlProps = pickHTMLProps(restProps); //  Transform into boolean version

  var getColor = useCallback(function (index) {
    if (disabled) {
      return disabledColor;
    }

    var isRatingGreaterThanIndex = !indexHoverRating && rating >= index;

    if (!onRating) {
      if (!isRatingGreaterThanIndex) return unfilledColor;
      return filledColor;
    }

    var isHoverGreaterThanIndex = indexHoverRating >= index;
    if (isHoverGreaterThanIndex || isRatingGreaterThanIndex) return filledColor;
    return unfilledColor;
  }, [disabled, disabledColor, indexHoverRating, onRating, rating, unfilledColor]);
  var handleMouseHover = useCallback(function (index) {
    return function () {
      if (!disabled && onRating) {
        return setIndexHoverRating(index);
      }
    };
  }, [onRating, disabled]);
  var starGraduation = scale === 'full' ? 0 : 0.5;
  var handleClick = useCallback(function (index) {
    return function () {
      if (disabled || !onRating) {
        return;
      }

      return onRating(index);
    };
  }, [disabled, onRating]);
  var countStars = Array.from(Array(count), function (_, i) {
    return i + 1;
  });
  var commonStarIconProps = {
    component: Star,
    readOnly: !onRating,
    size: size,
    onMouseLeave: handleMouseHover(0),
    disabled: disabled
  };
  return React.createElement(StarsContainer, Object.assign({}, styledSystemProps, htmlProps), countStars.map(function (index) {
    return React.createElement(StarWrapper, {
      key: index
    }, React.createElement(StarIcon, Object.assign({
      "data-testid": "half-star-rating",
      onClick: handleClick(index - starGraduation),
      svgProps: {
        color: getColor(index - starGraduation)
      },
      onMouseEnter: handleMouseHover(index - starGraduation),
      title: index.toString(),
      half: true
    }, commonStarIconProps)), React.createElement(StarIcon, Object.assign({
      "data-testid": "star-rating",
      onClick: handleClick(index),
      svgProps: {
        color: getColor(index)
      },
      onMouseEnter: handleMouseHover(index),
      title: index.toString()
    }, commonStarIconProps)));
  }));
};
StarRating.propTypes = {
  count: number,
  rating: number.isRequired,
  onRating: func,
  size: /*#__PURE__*/oneOf(['s', 'm', 'l', 'xl'])
};

function _templateObject$1a() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  color: ", ";\n  text-decoration: underline;\n  cursor: pointer;\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject$1a = function _templateObject() {
    return data;
  };

  return data;
}
var BaseLinkText = /*#__PURE__*/styled.a( /*#__PURE__*/_templateObject$1a(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.colors.primary;
}, /*#__PURE__*/responsiveVariant({
  small: {
    fontSize: 'xs',
    lineHeight: 's'
  },
  medium: {
    fontSize: 's',
    lineHeight: 'm'
  },
  large: {
    fontSize: 'm',
    lineHeight: 'm'
  },
  regular: {
    fontSize: 'tsm',
    lineHeight: 's'
  }
}), space, layout, typography, color);

var LinkText = function LinkText(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'medium' : _ref$variant,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["variant"]);

  var htmlProps = pickHTMLProps(otherProps);
  var styledSystemProps = pick(otherProps);
  return React.createElement(BaseLinkText, Object.assign({
    variant: variant,
    tabIndex: otherProps.tabIndex || 0
  }, htmlProps, styledSystemProps));
};
LinkText.propTypes = {
  variant: /*#__PURE__*/PropTypes__default.oneOf(['large', 'medium', 'small', 'regular'])
};

function _templateObject$1b() {
  var data = _taggedTemplateLiteralLoose(["\n  border-bottom: solid 1px ", ";\n\n  ", "\n  ", "\n"]);

  _templateObject$1b = function _templateObject() {
    return data;
  };

  return data;
}
var RowStyle = /*#__PURE__*/css( /*#__PURE__*/_templateObject$1b(), function (props) {
  return props.theme.colors.gray;
}, space, layout);

function _templateObject$1c() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: bold;\n\n  padding-right: ", ";\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  text-align: right;\n\n  &:first-child {\n    text-align: left;\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject$1c = function _templateObject() {
    return data;
  };

  return data;
}
var HeaderStyle = /*#__PURE__*/css( /*#__PURE__*/_templateObject$1c(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.small;
}, space, layout);

function _templateObject$1d() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n\n  padding-right: ", ";\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  text-align: right;\n\n  ", "\n  ", "\n"]);

  _templateObject$1d = function _templateObject() {
    return data;
  };

  return data;
}
var DataStyle = /*#__PURE__*/css( /*#__PURE__*/_templateObject$1d(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.space.large;
}, space, layout);

function _templateObject8$7() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n\n  border-spacing: 0px;\n  border-collapse: collapse;\n\n  & tr:hover > td {\n    background-color: ", ";\n  }\n"]);

  _templateObject8$7 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$8() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow-x: auto;\n  ", "\n  ", "\n"]);

  _templateObject7$8 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$b() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  &:first-child {\n    font-weight: bold;\n    text-align: left;\n  }\n"]);

  _templateObject6$b = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$f() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject5$f = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$i() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject4$i = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$t() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3$t = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$E() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2$E = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1e() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject$1e = function _templateObject() {
    return data;
  };

  return data;
}
var Head = /*#__PURE__*/styled.thead( /*#__PURE__*/_templateObject$1e());
var Body$2 = /*#__PURE__*/styled.tbody( /*#__PURE__*/_templateObject2$E());
var Foot = /*#__PURE__*/styled.tfoot( /*#__PURE__*/_templateObject3$t());
var Row = /*#__PURE__*/styled.tr( /*#__PURE__*/_templateObject4$i(), RowStyle);
var Header$4 = /*#__PURE__*/styled.th( /*#__PURE__*/_templateObject5$f(), HeaderStyle);
var Data = /*#__PURE__*/styled.td( /*#__PURE__*/_templateObject6$b(), DataStyle);
var CONTAINER_TEST_ID$1 = 'table-styled-container';
var Container$d = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject7$8(), layout, space);
var CustomTable = /*#__PURE__*/styled.table( /*#__PURE__*/_templateObject8$7(), function (props) {
  return props.theme.colors.grayLight;
});
var Table = function Table(_ref) {
  var width = _ref.width,
      children = _ref.children,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["width", "children"]);

  var styledSystemProps = pick(otherProps);
  var htmlProps = pickHTMLProps(otherProps);
  return React.createElement(Container$d, Object.assign({
    width: width
  }, styledSystemProps, getTestOnlyId(CONTAINER_TEST_ID$1)), React.createElement(CustomTable, Object.assign({}, htmlProps), children));
};
Table.Head = Head;
Table.Body = Body$2;
Table.Foot = Foot;
Table.Data = Data;
Table.Header = Header$4;
Table.Row = Row;

function _templateObject4$j() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n\n  & li:hover {\n    background-color: ", ";\n  }\n\n  list-style: none;\n  padding-left: 0px;\n"]);

  _templateObject4$j = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$u() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject3$u = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$F() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2$F = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1f() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  text-align: left;\n"]);

  _templateObject$1f = function _templateObject() {
    return data;
  };

  return data;
}
var Item$1 = /*#__PURE__*/styled.li( /*#__PURE__*/_templateObject$1f(), RowStyle, DataStyle);
var Header$5 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$F(), HeaderStyle);
var Container$e = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$u(), layout, space);
var CONTAINER_TEST_ID$2 = 'list-styled-container';
var CustomList = /*#__PURE__*/styled.ul( /*#__PURE__*/_templateObject4$j(), function (props) {
  return props.theme.colors.grayLight;
});
var List = function List(_ref) {
  var children = _ref.children,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var styledSystemProps = pick(otherProps);
  var htmlProps = pickHTMLProps(otherProps);
  return React.createElement(Container$e, Object.assign({}, styledSystemProps, getTestOnlyId(CONTAINER_TEST_ID$2)), React.createElement(CustomList, Object.assign({}, htmlProps), children));
};
List.Item = Item$1;
List.Header = Header$5;

function _templateObject4$k() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  font-size: 0;\n  line-height: 0;\n"]);

  _templateObject4$k = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$v() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  text-align: center;\n\n  width: 100%;\n\n  color: ", ";\n\n  &[disabled] {\n    background-color: ", ";\n  }\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    appearance: none;\n    margin: 0;\n  }\n"]);

  _templateObject3$v = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$G() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  display: flex;\n  flex-direction: column;\n  ", "\n  ", ";\n"]);

  _templateObject2$G = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1g() {
  var data = _taggedTemplateLiteralLoose(["\n  min-width: 5rem;\n  display: inline-flex;\n  align-items: center;\n  padding: ", " 0;\n"]);

  _templateObject$1g = function _templateObject() {
    return data;
  };

  return data;
}
var Container$f = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1g(), function (props) {
  return props.theme.space.smallest;
});
var FormElementContainer = /*#__PURE__*/styled(FormElement)( /*#__PURE__*/_templateObject2$G(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.m;
}, function (props) {
  return props.theme.lineHeights.m;
}, space, layout);
var InvisibleInput = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject3$v(), TextInputResetStyle, function (props) {
  return props.disabled ? props.theme.colors.grayDarker : props.theme.colors.black;
}, function (props) {
  return props.theme.colors.white;
});
var ExtendedButton = /*#__PURE__*/styled(Button)( /*#__PURE__*/_templateObject4$k());

var COUNTER_LOCALES = {
  'pt-br': {
    increase: 'Aumentar valor',
    decrease: 'Diminuir valor'
  },
  'en-us': {
    increase: 'Increase value',
    decrease: 'Decrease value'
  },
  'es-mx': {
    increase: 'Aumentar valor',
    decrease: 'Disminuir valor'
  },
  'es-co': {
    increase: 'Aumentar valor',
    decrease: 'Disminuir valor'
  }
};

var Counter$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  var increaseAriaLabel = props.increaseAriaLabel,
      decreaseAriaLabel = props.decreaseAriaLabel,
      error = props.error,
      label = props.label,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      disabled = props.disabled,
      value = props.value,
      otherProps = _objectWithoutPropertiesLoose(props, ["increaseAriaLabel", "decreaseAriaLabel", "error", "label", "step", "disabled", "value"]);

  var styledSystemProps = pick(otherProps);

  var _pickHTMLProps = pickHTMLProps(otherProps),
      dataTestId = _pickHTMLProps['data-testid'],
      htmlProps = _objectWithoutPropertiesLoose(_pickHTMLProps, ["data-testid"]);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var innerRef = useShareForwardedRef(ref);
  useEffect(function () {
    if (innerRef.current) {
      var numberValue = value !== '' && value !== undefined && !isNaN(Number(value)) ? Number(value) : '';
      innerRef.current.value = "" + numberValue;
    }
  }, [innerRef, value]);
  var handleDecrement = useCallback(function () {
    if (innerRef.current && !disabled) {
      var decrementedValue = Number(innerRef.current.value) - step;

      if (!innerRef.current.min || decrementedValue >= Number(innerRef.current.min)) {
        innerRef.current.value = "" + decrementedValue;
        innerRef.current.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      }
    }
  }, [disabled, innerRef, step]);
  var handleIncrement = useCallback(function () {
    if (innerRef.current && !disabled) {
      var incrementedValue = Number(innerRef.current.value) + step;

      if (!innerRef.current.max || incrementedValue <= Number(innerRef.current.max)) {
        innerRef.current.value = "" + incrementedValue;
        innerRef.current.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      }
    }
  }, [disabled, innerRef, step]);
  var elementId = htmlProps.id ? htmlProps.id : htmlProps.name;
  return React.createElement(FormElementContainer, Object.assign({}, styledSystemProps, {
    id: elementId,
    "data-testid": dataTestId,
    error: error,
    label: label
  }), React.createElement(Container$f, null, React.createElement(ExtendedButton, {
    px: 0,
    onClick: handleDecrement,
    type: "button",
    variant: "tertiary",
    disabled: disabled,
    "aria-label": decreaseAriaLabel || COUNTER_LOCALES[locale].decrease
  }, React.createElement(Icon$1, {
    component: Minus,
    size: "s"
  })), React.createElement(InvisibleInput, Object.assign({}, htmlProps, {
    type: "number",
    ref: innerRef,
    step: "" + step,
    id: elementId,
    value: value,
    disabled: disabled,
    onInput: htmlProps.onChange
  })), React.createElement(ExtendedButton, {
    p: 0,
    onClick: handleIncrement,
    type: "button",
    variant: "tertiary",
    disabled: disabled,
    "aria-label": increaseAriaLabel || COUNTER_LOCALES[locale].increase
  }, React.createElement(Icon$1, {
    component: Plus,
    size: "s"
  }))));
});
Counter$1.propTypes = {
  step: PropTypes__default.number,
  value: PropTypes__default.number,
  id: PropTypes__default.string,
  error: PropTypes__default.string,
  label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  disabled: PropTypes__default.bool,
  onChange: PropTypes__default.func
};

function _templateObject11$3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 75px;\n  height: 75px;\n  border-radius: ", ";\n"]);

  _templateObject11$3 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$4() {
  var data = _taggedTemplateLiteralLoose(["\n          &:focus {\n            + ", " > ", " > ", " {\n              outline: none;\n              box-shadow: ", ";\n            }\n          }\n        "]);

  _templateObject10$4 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$6() {
  var data = _taggedTemplateLiteralLoose(["\n          + ", " {\n            box-shadow: 0px 2px 2px rgba(62, 62, 62, 0.15);\n          }\n\n          &:focus {\n            + ", " {\n              box-shadow: ", ";\n            }\n          }\n        "]);

  _templateObject9$6 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$8() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n  position: absolute;\n\n  &:checked {\n    + ", " {\n      border-color: ", ";\n    }\n\n    + ", " > ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n    }\n\n    + ", " > ", " > ", "::after {\n      background-color: ", ";\n      box-shadow: 0px 1px 1px\n        ", ";\n    }\n  }\n\n  ", "\n"]);

  _templateObject8$8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$9() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"]);

  _templateObject7$9 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$c() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: bold;\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  margin-bottom: ", ";\n"]);

  _templateObject6$c = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$g() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1;\n"]);

  _templateObject5$g = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$l() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: ", ";\n  height: ", ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  box-sizing: border-box;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: ", ";\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n\n  box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.15);\n\n  transition: ", ";\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &::after {\n    width: 6px;\n    height: 6px;\n    content: '';\n    background-color: transparent;\n    border-radius: ", ";\n    box-shadow: none;\n  }\n"]);

  _templateObject4$l = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$w() {
  var data = _taggedTemplateLiteralLoose(["\n  line-height: 0;\n  margin: 0;\n  margin-right: ", ";\n  border-radius: ", ";\n"]);

  _templateObject3$w = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$H() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: ", ";\n  padding: ", ";\n  cursor: pointer;\n  align-items: center;\n\n  transition: ", ";\n\n  &:hover {\n    background: ", ";\n  }\n"]);

  _templateObject2$H = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1h() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject$1h = function _templateObject() {
    return data;
  };

  return data;
}
var Container$g = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1h(), space, layout);
var Label$1 = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject2$H(), function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.space.large;
}, function (_ref) {
  var _ref$theme = _ref.theme,
      durations = _ref$theme.durations,
      timingFunctions = _ref$theme.timingFunctions;
  return mountTransition([['background', durations.promptly, timingFunctions['ease']], ['border-color', durations.promptly, timingFunctions['ease']], ['box-shadow', durations.promptly, timingFunctions['ease']]]);
}, function (props) {
  return props.theme.colors.grayLight;
});
var Detail = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$w(), function (props) {
  return props.icon || props.imgSrc ? props.theme.space.regular : props.theme.space.large;
}, function (props) {
  return props.imgSrc ? props.theme.radii.m : '1px';
});
var Radio = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$l(), function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.radii.l;
}, function (_ref2) {
  var _ref2$theme = _ref2.theme,
      durations = _ref2$theme.durations,
      timingFunctions = _ref2$theme.timingFunctions;
  return mountTransition([['background', durations.promptly, timingFunctions['ease']], ['border-color', durations.promptly, timingFunctions['ease']], ['box-shadow', durations.promptly, timingFunctions['ease']]]);
}, function (props) {
  return props.theme.radii.l;
});
var Content$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$g());
var Title$1 = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject6$c(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.m;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.space.smaller;
});
var Description$2 = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject7$9(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.black;
});
var Input = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject8$8(), Label$1, function (props) {
  return props.theme.colors.primary;
}, Label$1, Detail, Radio, function (props) {
  return props.theme.colors.grayDarkest;
}, function (props) {
  return props.theme.colors.primary;
}, Label$1, Detail, Radio, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.grayDarkest;
}, function (props) {
  return props.icon ? css(_templateObject9$6(), Label$1, Label$1, function (props) {
    return props.theme.shadows.focus;
  }) : css(_templateObject10$4(), Label$1, Detail, Radio, function (props) {
    return props.theme.shadows.focus;
  });
});
var Image$1 = /*#__PURE__*/styled.img( /*#__PURE__*/_templateObject11$3(), function (props) {
  return props.theme.radii.m;
});
var CardSelectOption = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var title = _ref3.title,
      description = _ref3.description,
      className = _ref3.className,
      icon = _ref3.icon,
      svgProps = _ref3.svgProps,
      id = _ref3.id,
      imgSrc = _ref3.imgSrc,
      imgAlt = _ref3.imgAlt,
      props = _objectWithoutPropertiesLoose(_ref3, ["title", "description", "className", "icon", "svgProps", "id", "imgSrc", "imgAlt"]);

  var styledSystemProps = pick(props);

  var _pickHTMLProps = pickHTMLProps(props),
      dataTestId = _pickHTMLProps['data-testid'],
      htmlProps = _objectWithoutPropertiesLoose(_pickHTMLProps, ["data-testid"]);

  var forwardedRef = useShareForwardedRef(ref);
  var onClickHandler = useCallback(function () {
    var _forwardedRef$current;

    forwardedRef === null || forwardedRef === void 0 ? void 0 : (_forwardedRef$current = forwardedRef.current) === null || _forwardedRef$current === void 0 ? void 0 : _forwardedRef$current.click();
  }, [forwardedRef]);
  return React.createElement(Container$g, Object.assign({
    className: className,
    "data-testid": dataTestId
  }, styledSystemProps), React.createElement(Input, Object.assign({
    id: id,
    ref: forwardedRef,
    type: "radio",
    icon: icon
  }, htmlProps)), React.createElement(Label$1, {
    htmlFor: id,
    onClick: onClickHandler
  }, React.createElement(Detail, {
    icon: icon,
    imgSrc: imgSrc
  }, icon && React.createElement(Icon$1, {
    size: "s",
    svgProps: svgProps,
    component: icon
  }), imgSrc && React.createElement(Image$1, {
    src: imgSrc,
    alt: imgAlt
  }), !icon && !imgSrc && React.createElement(Radio, null)), React.createElement(Content$1, null, React.createElement(Title$1, null, title), React.createElement(Description$2, null, description))));
});
CardSelectOption.propTypes = {
  title: PropTypes__default.string.isRequired,
  description: PropTypes__default.string.isRequired,
  imgSrc: PropTypes__default.string,
  imgAlt: PropTypes__default.string,
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  icon: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.node, PropTypes__default.func]),
  id: PropTypes__default.string,
  className: PropTypes__default.string
};

function _templateObject3$x() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: 0;\n  margin-right: 0;\n"]);

  _templateObject3$x = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$I() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2$I = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1i() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject$1i = function _templateObject() {
    return data;
  };

  return data;
}
var Container$h = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1i(), space, layout);
var InnerContainer$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$I());
var ErrorLabel$1 = /*#__PURE__*/styled(ErrorLabel)( /*#__PURE__*/_templateObject3$x());
var CardSelectGroup = function CardSelectGroup(_ref) {
  var className = _ref.className,
      children = _ref.children,
      error = _ref.error,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "children", "error"]);

  return React.createElement(Container$h, Object.assign({
    role: "radiogroup"
  }, otherProps), React.createElement(InnerContainer$1, {
    className: className
  }, children), error && React.createElement(ErrorLabel$1, {
    role: "alert"
  }, error));
};
CardSelectGroup.propTypes = {
  error: PropTypes__default.string,
  className: PropTypes__default.string
};

var CardSelect = {
  Group: CardSelectGroup,
  Option: CardSelectOption
};

// https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
// https://codepen.io/gunnarbittersmann/pen/BoovjR
function getBackgroundImage(color) {
  return "url(data:image/svg+xml;utf8," + encodeURIComponent("<svg width=\"10\" height=\"8\" viewBox=\"0 0 10 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.11092 4.36385C0.720391 3.97332 0.720391 3.34016 1.11092 2.94963C1.50144 2.55911 2.1346 2.55911 2.52513 2.94963L5.35356 5.77806L3.93934 7.19227L1.11092 4.36385Z\" fill=\"" + color + "\"/><path d=\"M2.5249 5.77783L7.47465 0.828085C7.86517 0.43756 8.49834 0.43756 8.88886 0.828085C9.27939 1.21861 9.27939 1.85177 8.88886 2.2423L3.93912 7.19205L2.5249 5.77783Z\" fill=\"" + color + "\"/></svg>") + ")";
}

function _templateObject3$y() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: 0;\n  margin-right: 0;\n"]);

  _templateObject3$y = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$J() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject2$J = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1j() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject$1j = function _templateObject() {
    return data;
  };

  return data;
}
var Container$i = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1j(), space, layout);
var InnerContainer$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$J());
var ErrorLabel$2 = /*#__PURE__*/styled(ErrorLabel)( /*#__PURE__*/_templateObject3$y());
var CheckboxGroup = function CheckboxGroup(_ref) {
  var className = _ref.className,
      children = _ref.children,
      error = _ref.error,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "children", "error"]);

  return React.createElement(Container$i, Object.assign({
    role: "group"
  }, otherProps), React.createElement(InnerContainer$2, {
    className: className
  }, children), error && React.createElement(ErrorLabel$2, {
    role: "alert"
  }, error));
};
CheckboxGroup.propTypes = {
  error: PropTypes__default.string
};

function _templateObject5$h() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n\n  &:checked {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n      background-image: ", ";\n    }\n  }\n\n  &:disabled {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n      background-image: unset;\n    }\n  }\n\n  &:checked:disabled {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n      background-image: ", ";\n    }\n  }\n\n  &:focus {\n    + ", " > ", " {\n      outline: none;\n      box-shadow: ", ";\n    }\n  }\n"]);

  _templateObject5$h = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$m() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 14px;\n  height: 14px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  box-sizing: border-box;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: 2px;\n  padding: 0;\n  margin: 0;\n  margin-right: ", ";\n  display: inline-block;\n  transition: ", ";\n  cursor: pointer;\n\n  &:hover {\n    border-color: ", ";\n    background-color: ", ";\n  }\n"]);

  _templateObject4$m = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$z() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: normal;\n  margin-bottom: 0px;\n"]);

  _templateObject3$z = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$K() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2$K = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1k() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n\n  ", "\n  ", "\n"]);

  _templateObject$1k = function _templateObject() {
    return data;
  };

  return data;
}
var Container$j = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1k(), space, layout);
var Check = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$K());
var Label$2 = /*#__PURE__*/styled(Label)( /*#__PURE__*/_templateObject3$z());
var Checkmark = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject4$m(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.space.smaller;
}, function (_ref) {
  var _ref$theme = _ref.theme,
      durations = _ref$theme.durations,
      timingFunctions = _ref$theme.timingFunctions;
  return mountTransition([['all', durations.quickly, timingFunctions.ease]]);
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primaryLightest;
});
var Input$1 = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject5$h(), Check, Checkmark, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return getBackgroundImage(props.theme.colors.white);
}, Check, Checkmark, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
}, Check, Checkmark, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return getBackgroundImage(props.theme.colors.grayDarker);
}, Check, Checkmark, function (props) {
  return props.theme.shadows.focus;
});
var Button$2 = /*#__PURE__*/forwardRef(function (props, ref) {
  var label = props.label,
      className = props.className,
      id = props.id,
      remainingProps = _objectWithoutPropertiesLoose(props, ["label", "className", "id"]);

  var styledSystemProps = pick(props);

  var _pickHTMLProps = pickHTMLProps(remainingProps),
      dataTestId = _pickHTMLProps['data-testid'],
      ariaLabel = _pickHTMLProps['aria-label'],
      htmlProps = _objectWithoutPropertiesLoose(_pickHTMLProps, ["data-testid", "aria-label"]);

  var forwardedRef = useShareForwardedRef(ref);
  var onClickHandler = useCallback(function () {
    if (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current) {
      forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current.click();
    }
  }, [forwardedRef]);
  return React.createElement(Container$j, Object.assign({
    className: className,
    "data-testid": dataTestId
  }, styledSystemProps), React.createElement(Input$1, Object.assign({
    id: id,
    ref: forwardedRef,
    type: "checkbox"
  }, htmlProps)), React.createElement(Check, null, React.createElement(Checkmark, {
    role: "checkbox",
    onClick: onClickHandler,
    "aria-label": ariaLabel
  }), React.createElement(Label$2, {
    htmlFor: id
  }, label)));
});
Button$2.propTypes = {
  label: PropTypes__default.string
};
var Checkbox = {
  Group: CheckboxGroup,
  Button: Button$2
};

var formatDate = function formatDate(date, formatString) {
  return format(date, formatString);
};
var parseDate = function parseDate(date, formatString) {
  if (date.length !== formatString.length) {
    return undefined;
  }

  var parsed = parse(date, formatString, new Date());

  if (!DateUtils.isDate(parsed)) {
    return undefined;
  }

  return parsed;
};

function _templateObject11$4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  padding-left: ", ";\n  margin-right: ", ";\n"]);

  _templateObject11$4 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  margin-left: ", ";\n  padding-right: ", ";\n"]);

  _templateObject10$5 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n"]);

  _templateObject9$7 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$9() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: ", ";\n  border: none;\n  padding: 0;\n  color: ", ";\n  background-color: transparent;\n  cursor: pointer;\n  font-size: 0;\n\n  &:focus-within {\n    outline: none;\n    border-radius: ", ";\n    box-shadow: ", ";\n  }\n"]);

  _templateObject8$9 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$a() {
  var data = _taggedTemplateLiteralLoose(["\n      ", " ", "\n    "]);

  _templateObject7$a = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$d() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  width: 100%;\n  padding: ", ";\n"]);

  _templateObject6$d = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$i() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject5$i = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$n() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject4$n = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$A() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3$A = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$L() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  display: flex;\n  align-items: center;\n\n  background-color: ", ";\n\n  ", "\n\n  ", ";\n\n  ", ";\n\n  ", "\n  ", "\n"]);

  _templateObject2$L = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1l() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  background-color: ", ";\n"]);

  _templateObject$1l = function _templateObject() {
    return data;
  };

  return data;
}
var ClearStyle = /*#__PURE__*/css( /*#__PURE__*/_templateObject$1l(), function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.colors.white;
});
var VisibleInput = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$L(), TextInputStyle, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.error ? ErrorStyle : css(_templateObject3$A());
}, function (props) {
  return props.disabled ? DisabledStyle : css(_templateObject4$n());
}, function (props) {
  return props.allowClear ? ClearStyle : css(_templateObject5$i());
}, space, layout);
var InvisibleInput$1 = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject6$d(), TextInputResetStyle, function (_ref) {
  var space = _ref.theme.space;
  return css(_templateObject7$a(), space.small, space.smaller);
});
var ClearButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject8$9(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.smaller;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.grayDarker;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.radii.l;
}, function (props) {
  return props.theme.shadows.focusLight;
});
var PrefixSuffixContainer = /*#__PURE__*/css( /*#__PURE__*/_templateObject9$7());
var PrefixContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject10$5(), PrefixSuffixContainer, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.smaller;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.smaller;
});
var SuffixContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject11$4(), PrefixSuffixContainer, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.smaller;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.smaller;
});

var CLEAR = {
  'pt-br': {
    clear: 'Limpar campo'
  },
  'en-us': {
    clear: 'Clear field'
  },
  'es-mx': {
    clear: 'Limpiar campo'
  },
  'es-co': {
    clear: 'Limpiar campo'
  }
};

var Input$2 = /*#__PURE__*/forwardRef(function (props, ref) {
  var styledSystemProps = pick(props);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var innerRef = useShareForwardedRef(ref);

  var _useState = useState(false),
      hasValue = _useState[0],
      setHasValue = _useState[1];

  var onChange = props.onChange,
      onInput = props.onInput,
      onClear = props.onClear;
  useEffect(function () {
    if (innerRef.current && innerRef.current.value) {
      setHasValue(true);
    }
  }, [innerRef]);
  var onClearClick = useCallback(function () {
    if (innerRef.current) {
      innerRef.current.value = '';
      innerRef.current.dispatchEvent(new Event('input', {
        bubbles: true
      }));
      setHasValue(false);
      onClear === null || onClear === void 0 ? void 0 : onClear();
    }
  }, [innerRef, onClear]);
  var handleOnChange = useCallback(function (e) {
    if (e && e.target.value) {
      setHasValue(true);
    } else {
      setHasValue(false);
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  }, [onChange]);
  var handleOnInput = useCallback(function (e) {
    if (e && e.target.value) {
      setHasValue(true);
    } else {
      setHasValue(false);
    }

    onInput === null || onInput === void 0 ? void 0 : onInput(e);
  }, [onInput]);
  var htmlProps = pickHTMLProps(props);
  var elementId = htmlProps.id ? htmlProps.id : htmlProps.name;
  var shouldShowClearButton = !props.disabled && props.allowClear && hasValue;
  var shouldShowSuffix = props.suffixComponent || shouldShowClearButton;
  return React.createElement(FormElement, Object.assign({
    id: elementId,
    error: props.error,
    label: props.label,
    disabled: props.disabled,
    elementRef: innerRef,
    showCounter: props.showCounter
  }, styledSystemProps), React.createElement(VisibleInput, {
    error: props.error,
    disabled: props.disabled
  }, props.prefixComponent && React.createElement(PrefixContainer, null, props.prefixComponent), React.createElement(InvisibleInput$1, Object.assign({}, htmlProps, {
    id: elementId,
    ref: innerRef,
    onChange: handleOnChange,
    onInput: handleOnInput,
    "aria-invalid": Boolean(props.error)
  })), shouldShowSuffix && React.createElement(SuffixContainer, null, shouldShowClearButton && React.createElement(ClearButton, {
    type: "button",
    "aria-label": props.clearAriaLabel || CLEAR[locale].clear,
    onClick: onClearClick
  }, React.createElement(Icon$1, {
    component: ClearFieldFilled,
    size: "s"
  })), props.suffixComponent)));
});
Input$2.propTypes = {
  allowClear: PropTypes__default.bool,
  clearAriaLabel: PropTypes__default.string,
  error: PropTypes__default.string,
  name: PropTypes__default.string,
  label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  disabled: PropTypes__default.bool,
  prefixComponent: PropTypes__default.node,
  suffixComponent: PropTypes__default.node
};

function _templateObject$1m() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  cursor: pointer;\n"]);

  _templateObject$1m = function _templateObject() {
    return data;
  };

  return data;
}
var CalendarIcon = /*#__PURE__*/styled(Icon$1)( /*#__PURE__*/_templateObject$1m(), function (props) {
  return "" + props.theme.colors.primary;
});
var DatePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      value = props.value,
      placeholder = props.placeholder,
      _props$format = props.format,
      format$1 = _props$format === void 0 ? 'dd/MM/yyyy' : _props$format,
      onBlur = props.onBlur,
      id = props.id,
      name = props.name,
      month = props.month,
      error = props.error,
      disabledDays = props.disabledDays,
      otherProps = _objectWithoutPropertiesLoose(props, ["className", "value", "placeholder", "format", "onBlur", "id", "name", "month", "error", "disabledDays"]);

  var styledSystemProps = pick(otherProps);

  var _pickHTMLProps = pickHTMLProps(otherProps),
      dataTestId = _pickHTMLProps['data-testid'],
      htmlProps = _objectWithoutPropertiesLoose(_pickHTMLProps, ["data-testid"]);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var innerRef = useShareForwardedRef(ref);
  var handleDayChange = useCallback(function (day) {
    if (innerRef.current && DateUtils.isDate(day)) {
      innerRef.current.value = formatDate(day, format$1);
      innerRef.current.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }, [format$1, innerRef]);

  var handleIconClick = function handleIconClick() {
    var _innerRef$current;

    return (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.focus();
  };

  return React.createElement(DayPickerContainer, Object.assign({}, styledSystemProps, {
    "data-testid": dataTestId,
    className: className,
    rangeSelection: false,
    style: {
      position: 'relative'
    }
  }), React.createElement(DayPickerInput, {
    format: format$1,
    formatDate: formatDate,
    parseDate: parseDate,
    onDayChange: handleDayChange,
    placeholder: placeholder || format$1,
    value: value,
    component: Input$2,
    inputProps: _extends({}, htmlProps, {
      showCounter: false,
      ref: innerRef,
      id: id,
      name: name,
      onBlur: onBlur,
      onInput: htmlProps.onChange,
      suffixComponent: React.createElement(CalendarIcon, {
        "data-testid": "calendar-icon",
        onClick: handleIconClick,
        component: CalendarOutlined,
        size: "s"
      }),
      error: error
    }),
    dayPickerProps: {
      disabledDays: disabledDays,
      locale: locale,
      month: month,
      months: MONTHS[locale],
      weekdaysLong: WEEKDAYS_LONG[locale],
      weekdaysShort: WEEKDAYS_SHORT[locale],
      firstDayOfWeek: FIRST_DAY_OF_WEEK[locale],
      labels: LABELS[locale],
      numberOfMonths: 1,
      renderDay: function renderDay(day) {
        return React.createElement("div", {
          className: "DayPicker-inner-day"
        }, format(day, 'd'));
      }
    }
  }));
});
DatePicker.propTypes = {
  value: PropTypes__default.string,
  format: PropTypes__default.string,
  error: PropTypes__default.string,
  name: PropTypes__default.string,
  label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  disabled: PropTypes__default.bool
};

function _templateObject6$e() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n\n  &:checked {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n    }\n\n    + ", " > ", "::after {\n      background-color: ", ";\n      box-shadow: 0px 1px 1px\n        ", ";\n    }\n  }\n\n  &:focus {\n    + ", " > ", " {\n      outline: none;\n      box-shadow: ", ";\n    }\n  }\n\n  &:disabled {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n      background-image: unset;\n    }\n  }\n\n  &:checked:disabled {\n    + ", " > ", " {\n      border-color: ", ";\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject6$e = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$j() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: ", ";\n  height: ", ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: ", ";\n  box-sizing: border-box;\n  border-style: solid;\n  border-width: 1px;\n  border-color: ", ";\n  border-radius: ", ";\n  padding: 0;\n  margin: 0;\n  margin-right: ", ";\n  display: inline-block;\n  transition: ", ";\n  cursor: pointer;\n\n  box-shadow: inset 0px 1px 2px rgba(0, 0, 0, 0.15);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &::after {\n    width: 6px;\n    height: 6px;\n    content: '';\n    background-color: transparent;\n    border-radius: ", ";\n    box-shadow: ", ";\n  }\n"]);

  _templateObject5$j = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$o() {
  var data = _taggedTemplateLiteralLoose(["\n  font-weight: normal;\n  margin-bottom: 0px;\n"]);

  _templateObject4$o = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$B() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject3$B = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$M() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n\n  ", "\n  ", "\n"]);

  _templateObject2$M = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1n() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-right: ", "; ;\n"]);

  _templateObject$1n = function _templateObject() {
    return data;
  };

  return data;
}
var RadioIcon = /*#__PURE__*/styled(Icon$1)( /*#__PURE__*/_templateObject$1n(), function (props) {
  return props.theme.space.smallest;
});
var Container$k = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$M(), space, layout);
var InnerContainer$3 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$B());
var Label$3 = /*#__PURE__*/styled(Label)( /*#__PURE__*/_templateObject4$o());
var Button$3 = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject5$j(), function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.radii.l;
}, function (props) {
  return props.theme.space.smaller;
}, function (_ref) {
  var _ref$theme = _ref.theme,
      durations = _ref$theme.durations,
      timingFunctions = _ref$theme.timingFunctions;
  return mountTransition([['all', durations.quickly, timingFunctions.ease]]);
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.radii.l;
}, function (props) {
  return props.theme.shadows.none;
});
var Input$3 = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject6$e(), InnerContainer$3, Button$3, function (props) {
  return props.theme.colors.grayDarkest;
}, function (props) {
  return props.theme.colors.primary;
}, InnerContainer$3, Button$3, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.grayDarker;
}, InnerContainer$3, Button$3, function (props) {
  return props.theme.shadows.focus;
}, InnerContainer$3, Button$3, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
}, InnerContainer$3, Button$3, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
});

var RadioButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var label = props.label,
      disabled = props.disabled,
      icon = props.icon,
      className = props.className,
      id = props.id,
      remainingProps = _objectWithoutPropertiesLoose(props, ["label", "disabled", "icon", "className", "id"]);

  var styledSystemProps = pick(props);

  var _pickHTMLProps = pickHTMLProps(remainingProps),
      dataTestid = _pickHTMLProps['data-testid'],
      ariaLabel = _pickHTMLProps['aria-label'],
      htmlProps = _objectWithoutPropertiesLoose(_pickHTMLProps, ["data-testid", "aria-label"]);

  var forwardedRef = useShareForwardedRef(ref);
  var onClickHandler = useCallback(function () {
    var _forwardedRef$current;

    forwardedRef === null || forwardedRef === void 0 ? void 0 : (_forwardedRef$current = forwardedRef.current) === null || _forwardedRef$current === void 0 ? void 0 : _forwardedRef$current.click();
  }, [forwardedRef]);
  return React.createElement(Container$k, Object.assign({
    className: className,
    "data-testid": dataTestid
  }, styledSystemProps), React.createElement(Input$3, Object.assign({
    disabled: disabled,
    id: id,
    ref: forwardedRef,
    type: "radio"
  }, htmlProps)), React.createElement(InnerContainer$3, null, React.createElement(Button$3, {
    role: "checkbox",
    "aria-label": ariaLabel,
    onClick: onClickHandler
  }), icon && React.createElement(RadioIcon, {
    component: icon,
    size: "xs"
  }), React.createElement(Label$3, {
    htmlFor: id
  }, label)));
});
RadioButton.propTypes = {
  label: PropTypes__default.string,
  disabled: PropTypes__default.bool
};

function _templateObject2$N() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject2$N = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1o() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject$1o = function _templateObject() {
    return data;
  };

  return data;
}
var Container$l = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1o(), space, layout);
var InnerContainer$4 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$N());
var RadioGroup = function RadioGroup(_ref) {
  var className = _ref.className,
      children = _ref.children,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "children"]);

  return React.createElement(Container$l, Object.assign({
    role: "radiogroup"
  }, otherProps), React.createElement(InnerContainer$4, {
    className: className
  }, children));
};

var Radio$1 = {
  Group: RadioGroup,
  Button: RadioButton
};

var SEARCH = {
  'pt-br': {
    search: 'Buscar'
  },
  'en-us': {
    search: 'Search'
  },
  'es-mx': {
    search: 'Buscar'
  },
  'es-co': {
    search: 'Buscar'
  }
};

function _templateObject$1p() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"]);

  _templateObject$1p = function _templateObject() {
    return data;
  };

  return data;
}
var RedIcon = /*#__PURE__*/styled(Icon$1)( /*#__PURE__*/_templateObject$1p(), function (props) {
  return props.theme.colors.primary;
});
var Search = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var label = props.label,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      value = props.value,
      onSearch = props.onSearch,
      onChange = props.onChange,
      onSelectOption = props.onSelectOption,
      allowClear = props.allowClear,
      error = props.error,
      suffixComponent = props.suffixComponent,
      otherProps = _objectWithoutPropertiesLoose(props, ["label", "options", "value", "onSearch", "onChange", "onSelectOption", "allowClear", "error", "suffixComponent"]);

  var innerRef = useShareForwardedRef(ref);
  var onSelectedItemChange = useCallback(function (_ref) {
    var selectedItem = _ref.selectedItem;

    if (innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) {
      innerRef.current.value = selectedItem;
      innerRef.current.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }

    onSelectOption === null || onSelectOption === void 0 ? void 0 : onSelectOption(selectedItem);
  }, [innerRef, onSelectOption]);
  var onInputValueChange = useCallback(function (_ref2) {
    var inputValue = _ref2.inputValue;
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(inputValue);
  }, [onSearch]);

  var _useCombobox = useCombobox({
    items: options,
    onInputValueChange: onInputValueChange,
    onSelectedItemChange: onSelectedItemChange,
    initialSelectedItem: value
  }),
      isOpen = _useCombobox.isOpen,
      reset = _useCombobox.reset,
      getInputProps = _useCombobox.getInputProps,
      getLabelProps = _useCombobox.getLabelProps,
      getMenuProps = _useCombobox.getMenuProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      highlightedIndex = _useCombobox.highlightedIndex,
      getItemProps = _useCombobox.getItemProps,
      selectItem = _useCombobox.selectItem;

  useEffect(function () {
    if (value && options.includes(value)) {
      selectItem(value);
    }
  }, [options, selectItem, value]);
  var handleOnInput = useCallback(function (e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);

    if (!e.target.value) {
      reset();
    }
  }, [onChange, reset]);

  var _useState = useState(null),
      referenceElement = _useState[0],
      setReferenceElement = _useState[1];

  var htmlProps = pickHTMLProps(otherProps);
  var styledSystemProps = pick(otherProps);
  return React.createElement(FormElement, Object.assign({}, styledSystemProps, {
    error: error
  }), label && React.createElement(Label, Object.assign({}, getLabelProps()), label), React.createElement("div", {
    ref: setReferenceElement
  }, React.createElement("div", Object.assign({}, getComboboxProps()), React.createElement(Input$2, Object.assign({}, getInputProps(_extends({}, htmlProps, {
    ref: innerRef
  })), {
    onInput: handleOnInput,
    allowClear: allowClear,
    suffixComponent: suffixComponent,
    prefixComponent: React.createElement(RedIcon, {
      component: SearchOutlined,
      size: "xs",
      svgProps: {
        'aria-label': props.searchIconLabel || SEARCH[locale].search
      }
    })
  }))), React.createElement(Popover, {
    referenceElement: referenceElement,
    visible: isOpen
  }, React.createElement(Listbox, Object.assign({}, getMenuProps()), isOpen ? options.map(function (item, index) {
    return React.createElement(ListboxOption, Object.assign({
      className: highlightedIndex === index ? 'selected' : '',
      key: "" + item + index
    }, getItemProps({
      item: item,
      index: index
    })), item);
  }) : null))));
});
Search.propTypes = {
  className: PropTypes__default.string,
  allowClear: PropTypes__default.bool,
  clearAriaLabel: PropTypes__default.string,
  options: /*#__PURE__*/PropTypes__default.arrayOf(PropTypes__default.string.isRequired),
  onSearch: PropTypes__default.func,
  onSelectOption: PropTypes__default.func,
  error: PropTypes__default.string,
  name: PropTypes__default.string,
  label: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  showCounter: PropTypes__default.bool,
  searchIconLabel: PropTypes__default.string
};

function _templateObject3$C() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 0;\n  height: 0;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n\n  &:checked {\n    + ", " {\n      color: ", ";\n      background-color: ", ";\n    }\n  }\n\n  &:disabled {\n    + ", " {\n      border-color: ", ";\n      background-color: ", ";\n      background-image: unset;\n    }\n  }\n\n  &:checked:disabled {\n    + ", " {\n      border-color: ", ";\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject3$C = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$O() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  margin: 0;\n\n  text-align: center;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  background-color: ", ";\n\n  transition: ", ";\n  cursor: pointer;\n"]);

  _templateObject2$O = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1q() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  overflow: hidden;\n  border: solid 1px ", ";\n  border-right: 0px;\n\n  &:first-child {\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n  }\n\n  &:last-child {\n    border-top-right-radius: ", ";\n    border-bottom-right-radius: ", ";\n    border-right: solid 1px ", ";\n  }\n\n  &:focus-within {\n    position: relative;\n    z-index: 1;\n    outline: none;\n    box-shadow: ", ";\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject$1q = function _templateObject() {
    return data;
  };

  return data;
}
var Container$m = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1q(), function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.radii.s;
}, function (props) {
  return props.theme.radii.s;
}, function (props) {
  return props.theme.radii.s;
}, function (props) {
  return props.theme.radii.s;
}, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.shadows.focusLight;
}, space, layout);
var ClickableLabel = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject2$O(), function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.xs;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.grayLight;
}, function (_ref) {
  var _ref$theme = _ref.theme,
      durations = _ref$theme.durations,
      timingFunctions = _ref$theme.timingFunctions;
  return mountTransition([['all', durations.quickly, timingFunctions.ease]]);
});
var Input$4 = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject3$C(), ClickableLabel, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.primary;
}, ClickableLabel, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
}, ClickableLabel, function (props) {
  return props.theme.colors.grayDarker;
}, function (props) {
  return props.theme.colors.gray;
});
/**
 * Segment Button component
 */

var SegmentButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var label = props.label,
      id = props.id,
      otherProps = _objectWithoutPropertiesLoose(props, ["label", "id"]);

  var forwardedRef = useShareForwardedRef(ref);
  var onClickHandler = useCallback(function () {
    var _forwardedRef$current;

    forwardedRef === null || forwardedRef === void 0 ? void 0 : (_forwardedRef$current = forwardedRef.current) === null || _forwardedRef$current === void 0 ? void 0 : _forwardedRef$current.click();
  }, [forwardedRef]);
  var styledSystemProps = pick(otherProps);

  var _pickHTMLProps = pickHTMLProps(otherProps),
      dataTestid = _pickHTMLProps['data-testid'],
      htmlProps = _objectWithoutPropertiesLoose(_pickHTMLProps, ["data-testid"]);

  return React.createElement(Container$m, Object.assign({
    role: "radio",
    "data-testid": dataTestid
  }, styledSystemProps), React.createElement(Input$4, Object.assign({
    id: id,
    ref: forwardedRef,
    type: "radio"
  }, htmlProps)), React.createElement(ClickableLabel, {
    htmlFor: id,
    onClick: onClickHandler
  }, label));
});
SegmentButton.propTypes = {
  label: PropTypes__default.string.isRequired
};

function _templateObject2$P() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: 0;\n  margin-right: 0;\n"]);

  _templateObject2$P = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1r() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject$1r = function _templateObject() {
    return data;
  };

  return data;
}
var Container$n = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1r(), space, layout);
var ErrorLabel$3 = /*#__PURE__*/styled(ErrorLabel)( /*#__PURE__*/_templateObject2$P());
/**
 * Segment Group component
 */

var SegmentGroup = function SegmentGroup(_ref) {
  var className = _ref.className,
      children = _ref.children,
      error = _ref.error,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "children", "error"]);

  var styledSystemProps = pick(otherProps);
  var htmlProps = pickHTMLProps(otherProps);
  return React.createElement(Container$n, Object.assign({
    role: "radiogroup"
  }, htmlProps, styledSystemProps), React.createElement("div", {
    className: className
  }, children), error && React.createElement(ErrorLabel$3, {
    role: "alert"
  }, error));
};

SegmentGroup.propTypes = {
  error: PropTypes__default.string
};

var Segment = {
  Group: SegmentGroup,
  Button: SegmentButton
};

function _templateObject$1s() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  border-radius: ", ";\n\n  background-color: ", ";\n  transition: ", ";\n"]);

  _templateObject$1s = function _templateObject() {
    return data;
  };

  return data;
}
var Track = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1s(), function (_ref) {
  var theme = _ref.theme;
  return theme.radii.m;
}, function (_ref2) {
  var disabled = _ref2.disabled,
      theme = _ref2.theme;
  return disabled ? theme.colors.grayDarker : theme.colors.primary;
}, function (_ref3) {
  var _ref3$theme = _ref3.theme,
      durations = _ref3$theme.durations,
      timingFunctions = _ref3$theme.timingFunctions;
  return mountTransition([['width', durations.quickly, timingFunctions.easeInOut]]);
});

function _templateObject2$Q() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n\n  background-color: ", ";\n  border: solid 2px\n    ", ";\n  box-sizing: border-box;\n  cursor: pointer;\n  pointer-events: none;\n  transition: ", ";\n"]);

  _templateObject2$Q = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1t() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: calc(100% - ", ");\n"]);

  _templateObject$1t = function _templateObject() {
    return data;
  };

  return data;
}
var CursorGutter = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1t(), function (_ref) {
  var theme = _ref.theme;
  return theme.space.large;
});
var Cursor = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$Q(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.large;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.large;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.radii.l;
}, function (_ref5) {
  var disabled = _ref5.disabled,
      theme = _ref5.theme;
  return disabled ? theme.colors.grayLight : theme.colors.secondary;
}, function (_ref6) {
  var disabled = _ref6.disabled,
      theme = _ref6.theme;
  return disabled ? theme.colors.gray : theme.colors.grayDarker;
}, function (_ref7) {
  var _ref7$theme = _ref7.theme,
      durations = _ref7$theme.durations,
      timingFunctions = _ref7$theme.timingFunctions;
  return mountTransition([['left', durations.quickly, timingFunctions.easeInOut], ['border-color', durations.quickly, timingFunctions.easeInOut]]);
});

function _templateObject2$R() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  position: absolute;\n  bottom: calc(100% + ", ");\n  z-index: 10;\n  transform: translateX(-50%);\n\n  white-space: nowrap;\n  user-select: none;\n  pointer-events: none;\n  opacity: 0;\n\n  transition: ", ";\n\n  &::after {\n    ", "\n  }\n"]);

  _templateObject2$R = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1u() {
  var data = _taggedTemplateLiteralLoose(["\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0px;\n  height: 0px;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: ", " solid\n    ", ";\n"]);

  _templateObject$1u = function _templateObject() {
    return data;
  };

  return data;
}
var ArrowBottom$1 = /*#__PURE__*/css( /*#__PURE__*/_templateObject$1u(), function (_ref) {
  var theme = _ref.theme;
  return theme.space.smaller;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.black;
});
var Tooltip$1 = /*#__PURE__*/styled(Text)( /*#__PURE__*/_templateObject2$R(), NeutralVariant, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.large;
}, function (_ref4) {
  var _ref4$theme = _ref4.theme,
      durations = _ref4$theme.durations,
      timingFunctions = _ref4$theme.timingFunctions;
  return mountTransition([['left', durations.quickly, timingFunctions.easeInOut], ['opacity', durations.quickly, timingFunctions.easeInOut]]);
}, ArrowBottom$1);

function _templateObject$1v() {
  var data = _taggedTemplateLiteralLoose(["\n  &:active {\n    ", ", ", ", ", " {\n      transition: none;\n    }\n  }\n\n  &&:active ", " {\n    opacity: 1;\n  }\n\n  ", "\n  ", "\n"]);

  _templateObject$1v = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$5 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1v(), Track, Cursor, Tooltip$1, Tooltip$1, layout, space);

function _templateObject2$S() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"]);

  _templateObject2$S = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1w() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 0;\n  font-weight: 300;\n"]);

  _templateObject$1w = function _templateObject() {
    return data;
  };

  return data;
}
var Label$4 = /*#__PURE__*/styled(Label)( /*#__PURE__*/_templateObject$1w());
var DisplayValue = /*#__PURE__*/styled(Text)( /*#__PURE__*/_templateObject2$S(), function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.s;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.lineHeights.s;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.grayDarkest;
});

function _templateObject8$a() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"]);

  _templateObject8$a = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$b() {
  var data = _taggedTemplateLiteralLoose(["\n  gap: ", ";\n  align-items: flex-start;\n"]);

  _templateObject7$b = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$f() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject6$f = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$k() {
  var data = _taggedTemplateLiteralLoose(["\n          background-color: ", ";\n          pointer-events: none;\n        "]);

  _templateObject5$k = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$p() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n\n  position: relative;\n  height: 4px;\n  width: 100%;\n  border-radius: ", ";\n  background-color: ", ";\n  cursor: pointer;\n\n  ", "\n\n  ", ";\n\n  &:focus {\n    ", "\n\n    ", " {\n      ", "\n    }\n\n    ", " {\n      opacity: 1;\n    }\n  }\n\n  &:active {\n    ", "\n\n    ", " {\n      background-color: ", ";\n    }\n  }\n\n  &:hover {\n    ", " {\n      border-color: ", ";\n    }\n  }\n"]);

  _templateObject4$p = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$D() {
  var data = _taggedTemplateLiteralLoose(["\n  outline: none;\n  box-shadow: ", ";\n"]);

  _templateObject3$D = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$T() {
  var data = _taggedTemplateLiteralLoose(["\n  &::after {\n    content: '';\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    z-index: 99;\n  }\n"]);

  _templateObject2$T = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1x() {
  var data = _taggedTemplateLiteralLoose(["\n  &::before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    width: calc(100% + ", ");\n    height: calc(100% + ", ");\n  }\n"]);

  _templateObject$1x = function _templateObject() {
    return data;
  };

  return data;
}
var increaseClickableArea = /*#__PURE__*/css( /*#__PURE__*/_templateObject$1x(), function (_ref) {
  var theme = _ref.theme;
  return theme.space.larger;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.larger;
});
var fullWindowClickableArea = /*#__PURE__*/css( /*#__PURE__*/_templateObject2$T());
var focusStyle = /*#__PURE__*/css( /*#__PURE__*/_templateObject3$D(), function (props) {
  return props.theme.shadows.focus;
});
var Rail = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$p(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.large;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.large;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.radii.m;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.gray;
}, increaseClickableArea, function (_ref7) {
  var disabled = _ref7.disabled,
      theme = _ref7.theme;
  return disabled ? css(_templateObject5$k(), theme.colors.gray) : css(_templateObject6$f());
}, focusStyle, Cursor, focusStyle, Tooltip$1, fullWindowClickableArea, Cursor, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.primaryLightest;
}, Cursor, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.primary;
});
var RailWrapper = /*#__PURE__*/styled(Flex)( /*#__PURE__*/_templateObject7$b(), function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.large;
});
var SliderWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject8$a());

function _templateObject2$U() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n\n  flex: none;\n  padding-left: ", ";\n  padding-right: ", ";\n  width: ", ";\n  height: ", ";\n  box-sizing: border-box;\n\n  font-size: ", ";\n  color: ", ";\n"]);

  _templateObject2$U = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1y() {
  var data = _taggedTemplateLiteralLoose(["\n  &::-webkit-inner-spin-button,\n  &::-webkit-outer-spin-button {\n    display: none;\n  }\n  -moz-appearance: textfield;\n"]);

  _templateObject$1y = function _templateObject() {
    return data;
  };

  return data;
}
var NumberInputReset = /*#__PURE__*/css( /*#__PURE__*/_templateObject$1y());
var Input$5 = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject2$U(), TextInputResetStyle, TextInputStyle, NumberInputReset, function (_ref) {
  var theme = _ref.theme;
  return theme.space.smaller;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.smaller;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.loose;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.largest;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.s;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.grayDarker;
});

function _templateObject2$V() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  transform: translateX(-50%);\n\n  font-size: ", ";\n  color: ", ";\n  white-space: nowrap;\n  cursor: pointer;\n"]);

  _templateObject2$V = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1z() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  width: calc(100% - ", ");\n  display: flex;\n  justify-content: space-between;\n  height: ", ";\n"]);

  _templateObject$1z = function _templateObject() {
    return data;
  };

  return data;
}
var MarkWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1z(), function (_ref) {
  var theme = _ref.theme;
  return theme.space.large;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.small;
});
var MarkLabel = /*#__PURE__*/styled(Text)( /*#__PURE__*/_templateObject2$V(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.xs;
}, function (_ref4) {
  var theme = _ref4.theme,
      highlighted = _ref4.highlighted;
  return highlighted ? theme.colors.primary : theme.colors.black;
});

var defaultTransform = function defaultTransform(value) {
  return value;
};
var clampValue$1 = function clampValue(value, _ref) {
  var min = _ref[0],
      max = _ref[1];
  if (value < min) return min;
  if (value > max) return max;
  return value;
};
var normalize = function normalize(value, _ref2) {
  var min = _ref2[0],
      max = _ref2[1];
  return (value - min) / (max - min);
};
var denormalize = function denormalize(value, _ref3) {
  var min = _ref3[0],
      max = _ref3[1];
  return (max - min) * value + min;
};

var closestDistance = function closestDistance(a, b) {
  if (Math.abs(a) < Math.abs(b)) return a;
  return b;
};

var countDecimals = function countDecimals(value) {
  var _decimals$length;

  var _value$toString$split = value.toString().split('.'),
      decimals = _value$toString$split[1];

  return (_decimals$length = decimals === null || decimals === void 0 ? void 0 : decimals.length) !== null && _decimals$length !== void 0 ? _decimals$length : 0;
};

var toFixedPrecision = function toFixedPrecision(value, step) {
  return parseFloat(value.toFixed(countDecimals(step)));
};
var calculateClosestStep = function calculateClosestStep(currentValue, step, _ref4) {
  var min = _ref4[0],
      max = _ref4[1];
  if (step === 1) return Math.round(currentValue);
  if (currentValue === max) return max;
  var adjustedValue = currentValue - min;
  var distanceFromPreviousStep = adjustedValue % step * -1;
  var distanceFromNextStep = step - adjustedValue % step;
  var closestStepDistance = closestDistance(distanceFromPreviousStep, distanceFromNextStep);
  var calculatedNewValue = adjustedValue + closestStepDistance + min;
  return toFixedPrecision(calculatedNewValue, step);
};
var getLeftOffset = function getLeftOffset(value, range) {
  return normalize(value, range) * 100 + "%";
};
var getKeyboardIncrement = function getKeyboardIncrement(event) {
  var sign = {
    ArrowUp: 1,
    ArrowRight: 1,
    ArrowDown: -1,
    ArrowLeft: -1
  }[event.key];
  if (sign === undefined) return 0;
  var ctrlKey = event.ctrlKey,
      shiftKey = event.shiftKey;
  return sign * (+!ctrlKey || 10) * (+!shiftKey || 100);
};
var isInRange = function isInRange(value, _ref5) {
  var min = _ref5[0],
      max = _ref5[1];
  return value >= min && value <= max;
};

var useControlledValue = function useControlledValue(_ref) {
  var initialValue = _ref.initialValue,
      controlledValue = _ref.controlledValue;

  var _useState = useState(initialValue),
      value = _useState[0],
      setValue = _useState[1];

  useEffect(function () {
    if (controlledValue !== undefined) {
      setValue(controlledValue);
    }
  }, [controlledValue]);
  return [value, setValue];
};

var generateAllMarks = function generateAllMarks(step, _ref, transformDisplayedValues) {
  var min = _ref[0],
      max = _ref[1];

  if (transformDisplayedValues === void 0) {
    transformDisplayedValues = function transformDisplayedValues(value) {
      return value;
    };
  }

  var marks = [];

  var pushMark = function pushMark(value) {
    marks.push({
      value: value,
      label: transformDisplayedValues(value),
      leftOffset: getLeftOffset(value, [min, max])
    });
  };

  for (var currentStep = min; currentStep < max; currentStep += step) {
    pushMark(currentStep);
  }

  pushMark(max);
  return marks;
};

var useCalculateMarks = function useCalculateMarks(_ref) {
  var _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      range = _ref.range,
      markProps = _ref.marks,
      _ref$transformDisplay = _ref.transformDisplayedValues,
      transformDisplayedValues = _ref$transformDisplay === void 0 ? defaultTransform : _ref$transformDisplay;
  var marks = useMemo(function () {
    if (!markProps) return [];

    if (markProps === true) {
      return generateAllMarks(step, range, transformDisplayedValues);
    }

    var calculatedMarks = markProps.map(function (mark) {
      return _extends({}, mark, {
        leftOffset: getLeftOffset(mark.value, range)
      });
    });
    return calculatedMarks;
  }, [markProps, step, range, transformDisplayedValues]);
  return marks;
};

var Slider$1 = /*#__PURE__*/forwardRef(function (props, ref) {
  var idProp = props.id,
      nameProp = props.name,
      min = props.min,
      max = props.max,
      valueProp = props.value,
      defaultValueProp = props.defaultValue,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      onChange = props.onChange,
      _props$displayValue = props.displayValue,
      displayValue = _props$displayValue === void 0 ? false : _props$displayValue,
      _props$showInput = props.showInput,
      showInput = _props$showInput === void 0 ? false : _props$showInput,
      _props$transformDispl = props.transformDisplayedValues,
      transformDisplayedValues = _props$transformDispl === void 0 ? defaultTransform : _props$transformDispl,
      marks = props.marks,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      label = props.label,
      otherProps = _objectWithoutPropertiesLoose(props, ["id", "name", "min", "max", "value", "defaultValue", "step", "onChange", "displayValue", "showInput", "transformDisplayedValues", "marks", "disabled", "label"]);

  var styledSystemProps = pick(otherProps);
  var htmlProps = pickHTMLProps(otherProps);
  var innerRef = useShareForwardedRef(ref);
  var controlledValue = valueProp ? +valueProp : undefined;
  var defaultValue = defaultValueProp ? +defaultValueProp : min;

  var _useControlledValue = useControlledValue({
    initialValue: controlledValue !== null && controlledValue !== void 0 ? controlledValue : defaultValue,
    controlledValue: controlledValue
  }),
      stateValue = _useControlledValue[0],
      setValue = _useControlledValue[1];

  var _useState = useState(controlledValue !== null && controlledValue !== void 0 ? controlledValue : defaultValue),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var range = useMemo(function () {
    return [min, max];
  }, [min, max]);
  var value = useMemo(function () {
    return clampValue$1(stateValue, range);
  }, [stateValue, range]);

  var _useDrag = useDrag({
    clamped: true
  }),
      binders = _useDrag.binders,
      position = _useDrag.position;

  var percentageX = position.percentageX;
  var calculatedMarks = useCalculateMarks({
    step: step,
    range: range,
    marks: marks,
    transformDisplayedValues: transformDisplayedValues
  });
  var isMounted = useRef(false);
  useLayoutEffect(function () {
    if (isMounted.current) {
      var denormalizedValue = denormalize(percentageX, range);
      var newValue = calculateClosestStep(denormalizedValue, step, range);
      setValue(newValue);
    }
  }, [percentageX, range, step, setValue]);

  var handleTrackKeyPress = function handleTrackKeyPress(event) {
    var keyboardIncrement = getKeyboardIncrement(event);

    if (keyboardIncrement !== 0) {
      event.nativeEvent.preventDefault();
      var newValue = value + step * keyboardIncrement;
      setValue(toFixedPrecision(newValue, step));
    }
  };

  var handleInput = useCallback(function (event) {
    var newValue = event.target.value;
    setInputValue(newValue);
    var numberValue = parseFloat(newValue);

    if (!Number.isNaN(numberValue) && isInRange(numberValue, range)) {
      setValue(numberValue);
    }
  }, [range, setValue]);
  useEffect(function () {
    if (isMounted.current) {
      var _innerRef$current, _innerRef$current$dis;

      var event = new Event('input', {
        bubbles: true
      });
      (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : (_innerRef$current$dis = _innerRef$current.dispatchEvent) === null || _innerRef$current$dis === void 0 ? void 0 : _innerRef$current$dis.call(_innerRef$current, event);
      setInputValue(value);
    } else {
      isMounted.current = true;
    }
  }, [innerRef, value]);
  var relativeCursorPosition = useMemo(function () {
    return getLeftOffset(value, range);
  }, [value, range]);
  var transformedText = useMemo(function () {
    return transformDisplayedValues(value);
  }, [transformDisplayedValues, value]);
  return React.createElement(Wrapper$5, Object.assign({}, htmlProps, styledSystemProps), React.createElement(Flex, {
    centered: true,
    justifyContent: "space-between"
  }, React.createElement(Label$4, {
    htmlFor: idProp !== null && idProp !== void 0 ? idProp : nameProp
  }, label), displayValue && React.createElement(DisplayValue, null, transformedText)), React.createElement(RailWrapper, {
    centered: true,
    justifyContent: "space-between"
  }, React.createElement(SliderWrapper, null, React.createElement(Rail, Object.assign({
    disabled: disabled,
    tabIndex: disabled ? -1 : 0,
    onKeyDown: disabled ? undefined : handleTrackKeyPress
  }, binders), React.createElement(Track, {
    disabled: disabled,
    style: {
      width: relativeCursorPosition
    }
  }), React.createElement(CursorGutter, null, React.createElement(Cursor, {
    title: typeof label === 'string' ? label : undefined,
    disabled: disabled,
    style: {
      left: relativeCursorPosition
    },
    role: "slider",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    "aria-valuetext": transformedText
  }), React.createElement(Tooltip$1, {
    style: {
      left: relativeCursorPosition
    }
  }, transformedText))), !!calculatedMarks.length && React.createElement(MarkWrapper, null, calculatedMarks.map(function (mark) {
    return React.createElement(MarkLabel, {
      key: mark.value,
      highlighted: mark.value <= value,
      style: {
        left: mark.leftOffset
      },
      onClick: function onClick() {
        return setValue(mark.value);
      }
    }, mark.label);
  }))), showInput && React.createElement(Input$5, {
    "aria-label": typeof label === 'string' ? label : undefined,
    type: "number",
    min: min,
    max: max,
    step: step,
    disabled: disabled,
    value: inputValue,
    onChange: handleInput,
    onBlur: function onBlur() {
      return setInputValue(value);
    }
  })), React.createElement("input", {
    hidden: true,
    ref: innerRef,
    id: idProp,
    name: nameProp,
    disabled: disabled,
    value: value,
    onInput: function onInput(event) {
      return onChange === null || onChange === void 0 ? void 0 : onChange(event);
    }
  }));
});
Slider$1.propTypes = {
  label: PropTypes__default.node.isRequired,
  min: PropTypes__default.number.isRequired,
  max: PropTypes__default.number.isRequired,
  step: PropTypes__default.number,
  displayValue: PropTypes__default.bool,
  showInput: PropTypes__default.bool,
  disabled: PropTypes__default.bool,
  transformDisplayedValues: PropTypes__default.func,
  marks: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.bool, /*#__PURE__*/PropTypes__default.arrayOf( /*#__PURE__*/PropTypes__default.shape({
    value: PropTypes__default.number.isRequired,
    label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired
  }).isRequired)])
};

function _templateObject15$1() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: auto;\n  text-align: center;\n  box-sizing: border-box;\n\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n\n  &.selected {\n    background-color: ", ";\n  }\n"]);

  _templateObject15$1 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$1() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: ", ";\n  border: none;\n  padding: 0;\n  color: ", ";\n  background-color: transparent;\n  cursor: pointer;\n  font-size: 0;\n\n  &:focus-within {\n    outline: none;\n    border-radius: ", ";\n    box-shadow: ", ";\n  }\n"]);

  _templateObject14$1 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$1() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-left: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n"]);

  _templateObject13$1 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: inline;\n  margin-left: ", ";\n  font-family: ", ";\n  white-space: nowrap;\n\n  ::after {\n    content: ',';\n  }\n\n  :last-child::after {\n    content: '';\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: none;\n    border: solid 1px ", ";\n    border-radius: ", ";\n    padding: ", ";\n  }\n"]);

  _templateObject12$1 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$5() {
  var data = _taggedTemplateLiteralLoose(["\n      li:last-child::after {\n        content: ',';\n      }\n    "]);

  _templateObject11$5 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$6() {
  var data = _taggedTemplateLiteralLoose(["\n    ", ";\n  "]);

  _templateObject10$6 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$8() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n  list-style: none;\n  margin: 0;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  padding-top: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  display: block;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n\n  ", "\n\n  ", " {\n    li {\n      display: none;\n\n      &:first-child {\n        display: inline;\n\n        &::after {\n          content: '...';\n        }\n      }\n    }\n  }\n"]);

  _templateObject9$8 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$b() {
  var data = _taggedTemplateLiteralLoose(["\n    cursor: pointer;\n    margin-left: ", ";\n    margin-right: ", ";\n    line-height: normal;\n    border-bottom: ", ";\n\n    label {\n      cursor: pointer;\n    }\n\n    &[disabled] {\n      background-color: ", ";\n\n      label {\n        color: ", ";\n      }\n    }\n  "]);

  _templateObject8$b = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$c() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject7$c = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$g() {
  var data = _taggedTemplateLiteralLoose(["\n  max-height: 300px;\n"]);

  _templateObject6$g = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$l() {
  var data = _taggedTemplateLiteralLoose(["\n      transform: rotate(180deg);\n    "]);

  _templateObject5$l = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$q() {
  var data = _taggedTemplateLiteralLoose(["\n    cursor: pointer;\n    color: ", ";\n    transition: ", ";\n    ", ";\n  "]);

  _templateObject4$q = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$E() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject3$E = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$W() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n"]);

  _templateObject2$W = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1A() {
  var data = _taggedTemplateLiteralLoose(["\n  ", " {\n    max-width: 55%;\n  }\n"]);

  _templateObject$1A = function _templateObject() {
    return data;
  };

  return data;
}
var InputContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1A(), PrefixContainer);
var RedIcon$1 = /*#__PURE__*/styled(Icon$1)( /*#__PURE__*/_templateObject2$W(), function (props) {
  return props.theme.colors.primary;
});
var DropdownIcon$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$E(), function (_ref) {
  var theme = _ref.theme,
      isOpen = _ref.isOpen;
  return css(_templateObject4$q(), theme.colors.primary, function (_ref2) {
    var _ref2$theme = _ref2.theme,
        durations = _ref2$theme.durations,
        timingFunctions = _ref2$theme.timingFunctions;
    return mountTransition([['transform', durations.promptly, timingFunctions.easeInOut]]);
  }, isOpen && css(_templateObject5$l()));
});
var MultiSelectListbox = /*#__PURE__*/styled(Listbox)( /*#__PURE__*/_templateObject6$g());
var MultiSelectListboxOption = /*#__PURE__*/styled(ListboxOption)( /*#__PURE__*/_templateObject7$c(), function (_ref3) {
  var borderBottom = _ref3.borderBottom,
      theme = _ref3.theme;
  return css(_templateObject8$b(), function (props) {
    return props.theme.space.smallest;
  }, function (props) {
    return props.theme.space.smallest;
  }, borderBottom ? "solid 1px " + theme.colors.gray : '', theme.colors.grayLight, theme.colors.grayDarker);
});
var SelectionList = /*#__PURE__*/styled.ul( /*#__PURE__*/_templateObject9$8(), function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.m;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.none;
}, function (props) {
  return props.theme.space.smallest;
}, function (_ref4) {
  var isUserTyping = _ref4.isUserTyping;
  return css(_templateObject10$6(), isUserTyping && css(_templateObject11$5()));
}, function (props) {
  return props.theme.mediaQueries.s;
});
var SelectionListItem = /*#__PURE__*/styled.li( /*#__PURE__*/_templateObject12$1(), function (props) {
  return props.theme.space.smallest;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.radii.m;
}, function (props) {
  return props.theme.space.smallest;
});
var GroupLabelWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject13$1(), function (props) {
  return props.theme.space.regular;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.space.small;
});
var ClearButton$1 = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject14$1(), function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.smaller;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.grayDarker;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.radii.l;
}, function (props) {
  return props.theme.shadows.focusLight;
});
var ListboxNotFoundMessage = /*#__PURE__*/styled.div.attrs({
  role: 'alert'
})( /*#__PURE__*/_templateObject15$1(), function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.fonts.primary;
}, function (props) {
  return props.theme.fontSizes.s;
}, function (props) {
  return props.theme.lineHeights.m;
}, function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.colors.grayLight;
});

var getIsOptionsGroupArray = function getIsOptionsGroupArray(optionsGroups) {
  var optionsGroup = optionsGroups[0];
  return typeof optionsGroup === 'object' && optionsGroup.hasOwnProperty('options');
};
var getItemSelected = function getItemSelected(item, selectedItems) {
  return selectedItems.find(function (selectedItem) {
    return selectedItem.value === item.value;
  });
};
var isItemSelected = function isItemSelected(item, selectedItems) {
  return selectedItems.some(function (selectedItem) {
    return selectedItem.value === item.value;
  });
};
var getEnabledItems = function getEnabledItems(items) {
  return items.filter(function (item) {
    return !item.disabled;
  });
};
var getAllOptionsSelected = function getAllOptionsSelected(items, selectedItems) {
  return !items.some(function (item) {
    return !isItemSelected(item, selectedItems);
  }) && items.length === selectedItems.length;
};
var arraysHasSameElements = function arraysHasSameElements(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  var sortedA = a.sort();
  var sortedB = b.sort();

  for (var i = 0; i < sortedA.length; i++) {
    if (sortedA[i] !== sortedB[i]) {
      return false;
    }
  }

  return true;
};

var MULTISELECT = {
  'pt-br': {
    search: 'Buscar',
    clear: 'Limpar campo'
  },
  'en-us': {
    search: 'Search',
    clear: 'Clear field'
  },
  'es-mx': {
    search: 'Buscar',
    clear: 'Limpiar campo'
  },
  'es-co': {
    search: 'Buscar',
    clear: 'Limpiar campo'
  }
};

var MultiSelectOptionsList = function MultiSelectOptionsList(props) {
  var options = props.options,
      onlySelectedVisible = props.onlySelectedVisible,
      selectedItems = props.selectedItems,
      highlightedIndex = props.highlightedIndex,
      getItemProps = props.getItemProps,
      getItemIndex = props.getItemIndex;
  return React.createElement(Checkbox.Group, {
    role: "group"
  }, options.map(function (item) {
    if (onlySelectedVisible && !selectedItems.some(function (option) {
      return option.value === item.value;
    })) {
      return null;
    }

    var index = getItemIndex(item);
    return React.createElement(MultiSelectListboxOption, Object.assign({
      className: highlightedIndex === index ? 'selected' : '',
      key: "" + item + index
    }, getItemProps({
      item: item,
      index: index,
      disabled: Boolean(item.disabled)
    })), React.createElement(Checkbox.Button, {
      checked: isItemSelected(item, selectedItems),
      readOnly: true,
      label: item.name,
      disabled: item.disabled
    }));
  }));
};

var MULTISELECT_POPOVER = {
  'pt-br': {
    selectAll: 'Selecionar todas ({counter})',
    showOnlySelected: 'Mostrar apenas selecionadas ({counter})',
    resultsNotFound: 'Nenhum resultado encontrado.'
  },
  'en-us': {
    selectAll: 'Select all ({counter})',
    showOnlySelected: 'Show only selected ({counter})',
    resultsNotFound: 'No results found.'
  },
  'es-mx': {
    selectAll: 'Seleccionar todo ({counter})',
    showOnlySelected: 'Mostrar solo los seleccionados ({counter})',
    resultsNotFound: 'Ningún resultado encontrado.'
  },
  'es-co': {
    selectAll: 'Seleccionar todo ({counter})',
    showOnlySelected: 'Mostrar solo los seleccionados ({counter})',
    resultsNotFound: 'Ningún resultado encontrado.'
  }
};

function MultiSelectPopover(props) {
  var referenceElement = props.referenceElement,
      getMenuProps = props.getMenuProps,
      isOpen = props.isOpen,
      options = props.options,
      selectedItems = props.selectedItems,
      isUserTyping = props.isUserTyping,
      handleSelectAllOptions = props.handleSelectAllOptions,
      items = props.items,
      highlightedIndex = props.highlightedIndex,
      getItemProps = props.getItemProps,
      getItemIndex = props.getItemIndex,
      onlySelectedVisible = props.onlySelectedVisible,
      setOnlySelectedVisible = props.setOnlySelectedVisible,
      resultsNotFoundMessage = props.resultsNotFoundMessage,
      allowSelectAll = props.allowSelectAll,
      allowShowOnlySelected = props.allowShowOnlySelected;

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var toggleShowOnlySelected = useCallback(function () {
    setOnlySelectedVisible(!onlySelectedVisible);
  }, [setOnlySelectedVisible, onlySelectedVisible]);

  var groupHasSelectedItems = function groupHasSelectedItems(groupOptions) {
    return selectedItems.some(function (selectedItem) {
      return groupOptions.includes(selectedItem);
    });
  };

  var shouldShowGroupLabel = function shouldShowGroupLabel(group) {
    if (!group.label || !group.options) {
      return false;
    }

    var groupHasLabelAndShowOnlySelected = group.label && (!onlySelectedVisible || onlySelectedVisible && groupHasSelectedItems(group.options));

    if (groupHasLabelAndShowOnlySelected) {
      return true;
    }

    return false;
  };

  return React.createElement(Popover, {
    referenceElement: referenceElement,
    visible: isOpen
  }, React.createElement(MultiSelectListbox, Object.assign({}, getMenuProps()), isOpen && options.length ? React.createElement(React.Fragment, null, React.createElement(Checkbox.Group, {
    role: "group"
  }, selectedItems.length && !isUserTyping && allowShowOnlySelected ? React.createElement(MultiSelectListboxOption, {
    key: "show-only-selected",
    onClick: function onClick() {
      return toggleShowOnlySelected();
    },
    borderBottom: true
  }, React.createElement(Checkbox.Button, {
    label: MULTISELECT_POPOVER[locale].showOnlySelected.replace('{counter}', selectedItems.length.toString()),
    checked: onlySelectedVisible,
    readOnly: true
  })) : null, allowSelectAll && React.createElement(MultiSelectListboxOption, {
    key: "select-all",
    onClick: function onClick() {
      return handleSelectAllOptions();
    },
    borderBottom: true
  }, React.createElement(Checkbox.Button, {
    label: MULTISELECT_POPOVER[locale].selectAll.replace('{counter}', getEnabledItems(items).length.toString()),
    checked: getAllOptionsSelected(getEnabledItems(items), selectedItems),
    readOnly: true
  }))), getIsOptionsGroupArray(options) ? options.map(function (group, index) {
    return React.createElement("div", {
      key: group.label
    }, shouldShowGroupLabel(group) ? React.createElement(GroupLabelWrapper, null, React.createElement(Label, {
      id: "group-label-" + index
    }, group.label)) : null, React.createElement(Checkbox.Group, {
      key: index,
      role: "group",
      "aria-labelledby": "group-label-" + index
    }, React.createElement(MultiSelectOptionsList, {
      onlySelectedVisible: onlySelectedVisible,
      selectedItems: selectedItems,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps,
      options: group.options,
      getItemIndex: getItemIndex
    })));
  }) : React.createElement(MultiSelectOptionsList, {
    onlySelectedVisible: onlySelectedVisible,
    selectedItems: selectedItems,
    highlightedIndex: highlightedIndex,
    getItemProps: getItemProps,
    options: options,
    getItemIndex: getItemIndex
  })) : null), isOpen && !options.length ? React.createElement(ListboxNotFoundMessage, null, resultsNotFoundMessage || MULTISELECT_POPOVER[locale].resultsNotFound) : null);
}

var MultiSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var _innerRef$current;

  var _useState = useState(false),
      onlySelectedVisible = _useState[0],
      setOnlySelectedVisible = _useState[1];

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var label = props.label,
      placeholder = props.placeholder,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      value = props.value,
      onSearch = props.onSearch,
      onChange = props.onChange,
      onSelectionChange = props.onSelectionChange,
      _props$allowClear = props.allowClear,
      allowClear = _props$allowClear === void 0 ? true : _props$allowClear,
      _props$allowSelectAll = props.allowSelectAll,
      allowSelectAll = _props$allowSelectAll === void 0 ? true : _props$allowSelectAll,
      _props$allowShowOnlyS = props.allowShowOnlySelected,
      allowShowOnlySelected = _props$allowShowOnlyS === void 0 ? true : _props$allowShowOnlyS,
      error = props.error,
      _props$openMenuOnFocu = props.openMenuOnFocus,
      openMenuOnFocus = _props$openMenuOnFocu === void 0 ? true : _props$openMenuOnFocu,
      clearAriaLabel = props.clearAriaLabel,
      _props$resultsNotFoun = props.resultsNotFoundMessage,
      resultsNotFoundMessage = _props$resultsNotFoun === void 0 ? '' : _props$resultsNotFoun,
      _props$closeAfterSele = props.closeAfterSelection,
      closeAfterSelection = _props$closeAfterSele === void 0 ? true : _props$closeAfterSele,
      otherProps = _objectWithoutPropertiesLoose(props, ["label", "placeholder", "options", "value", "onSearch", "onChange", "onSelectionChange", "allowClear", "allowSelectAll", "allowShowOnlySelected", "error", "openMenuOnFocus", "clearAriaLabel", "resultsNotFoundMessage", "closeAfterSelection"]);

  var innerRef = useShareForwardedRef(ref);
  var isUserTyping = !!(innerRef === null || innerRef === void 0 ? void 0 : (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.value);

  var itemToString = function itemToString(item) {
    return (item === null || item === void 0 ? void 0 : item.name) ? item.name : '';
  };

  var itemToValue = function itemToValue(item) {
    return (item === null || item === void 0 ? void 0 : item.value) ? item.value : '';
  };

  var onSelectedItemChange = useCallback(function (_ref) {
    var selectedItem = _ref.selectedItem;

    if ((innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) && innerRef.current.value !== itemToValue(selectedItem)) {
      innerRef.current.value = selectedItem;
      innerRef.current.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }, [innerRef]);
  var handleSelectionChange = useCallback(function (selectedItems) {
    var newValue = selectedItems ? selectedItems.map(function (item) {
      return item.value;
    }) : [];
    var oldValue = (value || []).map(function (item) {
      return item.value;
    });

    if (value === undefined || !arraysHasSameElements(oldValue, newValue)) {
      onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(newValue);
    }
  }, [value, onSelectionChange]);

  var _useMultipleSelection = useMultipleSelection({
    initialSelectedItems: value || [],
    itemToString: itemToString,
    onStateChange: function onStateChange(_ref2) {
      var type = _ref2.type,
          newSelectedItems = _ref2.selectedItems;

      switch (type) {
        case useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem:
        case useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
        case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
          if (!(newSelectedItems === null || newSelectedItems === void 0 ? void 0 : newSelectedItems.length)) {
            setOnlySelectedVisible(false);
          }

          handleSelectionChange(newSelectedItems);
          break;

        case useMultipleSelection.stateChangeTypes.FunctionAddSelectedItem:
        case useMultipleSelection.stateChangeTypes.FunctionSetSelectedItems:
          handleSelectionChange(newSelectedItems);
          break;
      }
    }
  }),
      getSelectedItemProps = _useMultipleSelection.getSelectedItemProps,
      getDropdownProps = _useMultipleSelection.getDropdownProps,
      addSelectedItem = _useMultipleSelection.addSelectedItem,
      selectedItems = _useMultipleSelection.selectedItems,
      setSelectedItems = _useMultipleSelection.setSelectedItems,
      removeSelectedItem = _useMultipleSelection.removeSelectedItem;

  var flatMapItems = useCallback(function (optionsGroups) {
    if (getIsOptionsGroupArray(optionsGroups)) {
      return optionsGroups.flatMap(function (group) {
        return group.options;
      });
    }

    return optionsGroups;
  }, []);
  var items = getIsOptionsGroupArray(options) ? flatMapItems(options) : options;

  if (onlySelectedVisible) {
    items = items.filter(function (item) {
      return isItemSelected(item, selectedItems);
    });
  }

  var getItemIndex = function getItemIndex(item) {
    return items.findIndex(function (indexedItem) {
      return indexedItem.value === item.value;
    });
  };

  var isPlaceholderVisible = !selectedItems.length;

  var _useCombobox = useCombobox({
    items: items,
    onSelectedItemChange: onSelectedItemChange,
    itemToString: itemToString,
    stateReducer: function stateReducer(_state, actionAndChanges) {
      var changes = actionAndChanges.changes,
          type = actionAndChanges.type;

      switch (type) {
        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          return _extends({}, changes, {
            isOpen: !closeAfterSelection
          });
      }

      return changes;
    },
    onStateChange: function onStateChange(_ref3) {
      var inputValue = _ref3.inputValue,
          type = _ref3.type,
          selectedOption = _ref3.selectedItem;

      switch (type) {
        case useCombobox.stateChangeTypes.InputChange:
          onSearch === null || onSearch === void 0 ? void 0 : onSearch(inputValue || '');
          break;

        case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
        case useCombobox.stateChangeTypes.InputBlur:
          if (!selectedOption) {
            return;
          }

          var selectedItem = getItemSelected(selectedOption, selectedItems);
          onSearch === null || onSearch === void 0 ? void 0 : onSearch('');

          if (selectedItem) {
            removeSelectedItem(selectedItem);
          } else {
            addSelectedItem(selectedOption);
          }

          selectItem(null);
          break;
      }
    }
  }),
      isMultiSelectOpen = _useCombobox.isOpen,
      reset = _useCombobox.reset,
      getInputProps = _useCombobox.getInputProps,
      getLabelProps = _useCombobox.getLabelProps,
      getMenuProps = _useCombobox.getMenuProps,
      getComboboxProps = _useCombobox.getComboboxProps,
      highlightedIndex = _useCombobox.highlightedIndex,
      getItemProps = _useCombobox.getItemProps,
      selectItem = _useCombobox.selectItem,
      openMenu = _useCombobox.openMenu,
      closeMenu = _useCombobox.closeMenu;

  var clearSelectedItems = useCallback(function () {
    setSelectedItems([]);
    setOnlySelectedVisible(false);
  }, [setSelectedItems, setOnlySelectedVisible]);
  var handleSelectAllOptions = useCallback(function () {
    var eneblaedItems = getEnabledItems(items);

    if (getAllOptionsSelected(eneblaedItems, selectedItems)) {
      clearSelectedItems();
    } else {
      setSelectedItems(eneblaedItems);
    }

    onSearch === null || onSearch === void 0 ? void 0 : onSearch('');
    selectItem(null);
  }, [setSelectedItems, selectItem, onSearch, items, selectedItems, clearSelectedItems]);

  var handleInputClear = function handleInputClear() {
    if (innerRef.current) {
      innerRef.current.value = '';
      innerRef.current.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }

    onSearch === null || onSearch === void 0 ? void 0 : onSearch('');
    clearSelectedItems();
    selectItem(null);
  };

  var _useState2 = useState(value),
      oldValue = _useState2[0],
      setOldValue = _useState2[1];

  useEffect(function () {
    setOldValue(value);

    if (value !== undefined) {
      var newValues = value.map(function (option) {
        return option.value;
      });
      var oldValues = (oldValue || []).map(function (option) {
        return option.value;
      });
      var selectedValues = selectedItems.map(function (option) {
        return option.value;
      });

      if (!arraysHasSameElements(oldValues, newValues) && !arraysHasSameElements(newValues, selectedValues)) {
        setSelectedItems(value);
      }
    }
  }, [options, setSelectedItems, value, selectedItems, oldValue]);
  var handleOnInput = useCallback(function (e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e);

    if (!e.target.value) {
      reset();
    }
  }, [onChange, reset]);

  var _useState3 = useState(null),
      referenceElement = _useState3[0],
      setReferenceElement = _useState3[1];

  var htmlProps = pickHTMLProps(otherProps);
  var styledSystemProps = pick(otherProps);
  var isOpen = isMultiSelectOpen && !otherProps.disabled;
  return React.createElement(FormElement, Object.assign({}, styledSystemProps, {
    error: error
  }), label && React.createElement(Label, Object.assign({}, getLabelProps()), label), React.createElement("div", {
    ref: setReferenceElement
  }, React.createElement(InputContainer, Object.assign({}, getComboboxProps()), React.createElement(Input$2, Object.assign({}, getDropdownProps(getInputProps(_extends({}, htmlProps, {
    ref: innerRef,
    onClick: function onClick() {
      return openMenuOnFocus && openMenu();
    }
  }))), {
    placeholder: isPlaceholderVisible ? placeholder : '',
    onInput: handleOnInput,
    prefixComponent: React.createElement(React.Fragment, null, React.createElement(RedIcon$1, {
      component: SearchOutlined,
      size: "xs",
      svgProps: {
        'aria-label': props.searchIconLabel || MULTISELECT[locale].search
      }
    }), selectedItems.length ? React.createElement(SelectionList, {
      isUserTyping: isUserTyping
    }, selectedItems.map(function (selectedItem, index) {
      return React.createElement(SelectionListItem, Object.assign({
        key: "selected-item-" + index
      }, getSelectedItemProps({
        selectedItem: selectedItem,
        index: index
      }), {
        "aria-label": selectedItem.name
      }), selectedItem.name);
    })) : null),
    suffixComponent: React.createElement(FormElementIcons, null, React.createElement(DropdownIcon$1, {
      isOpen: isOpen
    }, React.createElement(Icon$1, {
      role: "button",
      onClick: function onClick() {
        return isOpen ? closeMenu() : openMenu();
      },
      component: ChevronDown,
      size: "s"
    })), allowClear && (isUserTyping || selectedItems.length) && !otherProps.disabled ? React.createElement(ClearButton$1, {
      type: "button",
      "aria-label": clearAriaLabel || MULTISELECT[locale].clear,
      onClick: handleInputClear
    }, React.createElement(Icon$1, {
      component: ClearFieldFilled,
      size: "s"
    })) : null)
  }))), React.createElement(MultiSelectPopover, {
    referenceElement: referenceElement,
    getMenuProps: getMenuProps,
    isOpen: isOpen,
    options: options,
    selectedItems: selectedItems,
    isUserTyping: isUserTyping,
    handleSelectAllOptions: handleSelectAllOptions,
    items: items,
    highlightedIndex: highlightedIndex,
    getItemProps: getItemProps,
    getItemIndex: getItemIndex,
    onlySelectedVisible: onlySelectedVisible,
    setOnlySelectedVisible: setOnlySelectedVisible,
    resultsNotFoundMessage: resultsNotFoundMessage,
    allowSelectAll: allowSelectAll,
    allowShowOnlySelected: allowShowOnlySelected
  })));
});
MultiSelect.propTypes = {
  className: PropTypes__default.string,
  allowClear: PropTypes__default.bool,
  allowSelectAll: PropTypes__default.bool,
  allowShowOnlySelected: PropTypes__default.bool,
  clearAriaLabel: PropTypes__default.string,
  options: PropTypes__default.array,
  onSearch: PropTypes__default.func,
  error: PropTypes__default.string,
  name: PropTypes__default.string,
  label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  disabled: PropTypes__default.bool,
  showCounter: PropTypes__default.bool,
  searchIconLabel: PropTypes__default.string
};

function _templateObject7$d() {
  var data = _taggedTemplateLiteralLoose(["\n    ", "\n    ", "\n  "]);

  _templateObject7$d = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$h() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n\n  ", "\n"]);

  _templateObject6$h = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$m() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-weight: 300;\n  margin: 20px 0px;\n"]);

  _templateObject5$m = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$r() {
  var data = _taggedTemplateLiteralLoose(["\n    flex-direction: row;\n\n    ", " {\n      img,\n      svg {\n        flex: 0 1 auto;\n        justify-content: flex-start;\n        width: ", ";\n        height: 40px;\n        margin-right: ", ";\n      }\n    }\n\n    ", " {\n      flex: 2;\n      justify-content: flex-start;\n      margin-right: ", ";\n    }\n\n    button {\n      flex: 0 1 auto;\n      justify-content: flex-end;\n      white-space: nowrap;\n    }\n  "]);

  _templateObject4$r = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$F() {
  var data = _taggedTemplateLiteralLoose(["\n    flex-direction: column;\n\n    ", " {\n      margin-top: ", ";\n      text-align: center;\n    }\n\n    button {\n      margin-top: ", ";\n    }\n  "]);

  _templateObject3$F = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$X() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2$X = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1B() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject$1B = function _templateObject() {
    return data;
  };

  return data;
}
var UploadImageWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1B());
var DescriptionWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$X());
var stylesModifiers = {
  large: function large() {
    return css(_templateObject3$F(), DescriptionWrapper, function (_ref) {
      var theme = _ref.theme;
      return theme.space.looser;
    }, function (_ref2) {
      var theme = _ref2.theme;
      return theme.space.looser;
    });
  },
  small: function small() {
    return css(_templateObject4$r(), UploadImageWrapper, function (_ref3) {
      var theme = _ref3.theme;
      return theme.space.looser;
    }, function (_ref4) {
      var theme = _ref4.theme;
      return theme.space.large;
    }, DescriptionWrapper, function (_ref5) {
      var theme = _ref5.theme;
      return theme.space.large;
    });
  }
};
var Description$3 = /*#__PURE__*/styled(Text)( /*#__PURE__*/_templateObject5$m());
var BaseDescriptionContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject6$h(), function (_ref6) {
  var variant = _ref6.variant;
  return css(_templateObject7$d(), variant.includes('large') && stylesModifiers.large(), variant.includes('small') && stylesModifiers.small());
});

var UploadIcon = function UploadIcon(props) {
  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  return React.createElement("svg", Object.assign({}, props, {
    width: "180",
    height: "128",
    fill: "none",
    viewBox: "0 0 180 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    clipPath: "url(#clip0)"
  }, React.createElement("g", {
    opacity: ".4",
    filter: "url(#filter0_d)"
  }, React.createElement("path", {
    d: "M4 71.92l28.263-10.287 14.015 6.848 13.167 36.177-38.437 13.99L4 71.92z",
    fill: colors.white
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.992 69.638l-12.821-6.264-26.115 9.505 15.91 43.713 35.423-12.893-12.397-34.06zm-12.73-8.005l14.016 6.848 13.167 36.177-38.437 13.99L4 71.92l28.263-10.287z",
    fill: colors.primary
  }), React.createElement("path", {
    fill: colors.primaryLightest,
    d: "M12.598 82.172l22.02-8.015 1.173 3.222-22.02 8.015zm1.955 5.371l29.003-10.557 1.173 3.223-29.003 10.556zm1.954 5.371L45.51 82.358l1.172 3.222L17.68 96.136zm1.955 5.371L47.465 87.73l1.173 3.222-29.003 10.556zm1.955 5.371L49.421 93.1l1.172 3.222-29.003 10.556z"
  }), React.createElement("path", {
    d: "M54.807 91.914l4.153-5.004 2.993 8.222-4.154 5.004-2.992-8.222z",
    fill: colors.primaryDark
  }), React.createElement("path", {
    fill: colors.primary,
    d: "M21.138 95.555l36.176-13.167 4.39 12.059-36.177 13.167z"
  }), React.createElement("path", {
    d: "M33.266 101.267a.588.588 0 01-.037-.217.612.612 0 01.047-.205.567.567 0 01.313-.288.554.554 0 01.712.333.544.544 0 01-.333.708.53.53 0 01-.218.032.495.495 0 01-.205-.047.647.647 0 01-.167-.122.613.613 0 01-.112-.194zm4.775-3.719L36.23 95.47a5.235 5.235 0 01-.376-.492c.023.245.032.454.025.625l-.055 2.752 2.218-.807zm2.477 1.595l-.621.227a.285.285 0 01-.194.01.353.353 0 01-.15-.101l-1.077-1.233-2.665.97-.034 1.637a.307.307 0 01-.047.167.281.281 0 01-.153.122l-.621.226.213-6.805.812-.295 4.537 5.075zm1.312-3.946a2.22 2.22 0 00.584-.306c.158-.124.278-.258.36-.404.083-.15.13-.307.138-.472a1.288 1.288 0 00-.082-.51c-.13-.354-.342-.579-.64-.674-.297-.095-.678-.058-1.142.111l-.88.32.817 2.242.846-.307zm3.86 2.064l-.713.26c-.147.053-.275.036-.385-.053l-2.315-1.56a.456.456 0 00-.205-.086.55.55 0 00-.265.045l-.61.222.903 2.479-.8.291-2.162-5.94 1.679-.611a3.837 3.837 0 011.016-.239c.3-.025.566.002.795.082.232.078.428.204.588.377.159.17.284.382.376.633.076.21.115.419.115.625 0 .207-.037.406-.111.6a1.79 1.79 0 01-.326.535 2.38 2.38 0 01-.529.456c.123.02.243.073.358.156l2.59 1.728zm.127-3.407c.132.365.301.674.506.928.205.251.434.444.69.58.258.131.536.204.835.217.298.01.606-.042.924-.158a2.45 2.45 0 00.813-.474c.22-.203.386-.436.496-.702a2.24 2.24 0 00.155-.887 3.211 3.211 0 00-.208-1.037 3.215 3.215 0 00-.507-.928 2.19 2.19 0 00-.69-.58A1.94 1.94 0 0048 90.59a2.396 2.396 0 00-.929.155 2.384 2.384 0 00-.807.477 1.98 1.98 0 00-.499.708c-.11.265-.162.56-.156.887.006.327.076.672.209 1.037zm6.837 2.262l-.664.242a.837.837 0 01-.28.055.564.564 0 01-.264-.069l-1.454-.757c-.277.22-.6.397-.967.53-.436.16-.86.231-1.273.215a2.87 2.87 0 01-2.098-1.03 3.667 3.667 0 01-.658-1.15 3.631 3.631 0 01-.234-1.3 2.98 2.98 0 01.247-1.178 2.84 2.84 0 01.695-.967c.305-.28.676-.5 1.112-.658a3.28 3.28 0 011.276-.21 2.83 2.83 0 011.158.291c.354.175.67.423.947.745.275.319.494.7.656 1.146.102.279.17.555.203.827a2.994 2.994 0 01-.168 1.526c-.09.233-.209.45-.355.65l2.12 1.092z",
    fill: colors.white
  })), React.createElement("g", {
    opacity: ".5",
    filter: "url(#filter1_d)"
  }, React.createElement("path", {
    d: "M116.85 41l38.075 12.005 9.225 18.536-15.366 48.736-51.782-16.327L116.85 41z",
    fill: colors.white
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.861 71.72l-8.439-16.956L118.24 43.67l-18.567 58.89 47.72 15.046 14.468-45.885zm-6.936-18.715l9.225 18.536-15.366 48.736-51.782-16.327L116.85 41l38.075 12.005z",
    fill: colors.primary
  }), React.createElement("path", {
    fill: colors.primaryLightest,
    d: "M117.62 58.743l29.665 9.354-1.368 4.341-29.667-9.354zm-2.282 7.236l39.073 12.32-1.369 4.34L113.97 70.32zm-2.281 7.236l39.073 12.32-1.369 4.34-39.073-12.319zm-2.282 7.236l39.073 12.32-1.37 4.34-39.072-12.319zm-2.281 7.235l39.073 12.32-1.369 4.34-39.073-12.319z"
  }), React.createElement("path", {
    d: "M154.197 103.109l8.417-1.913-3.493 11.076-8.417 1.913 3.493-11.076z",
    fill: colors.primaryDark
  }), React.createElement("path", {
    fill: colors.primary,
    d: "M115.799 79.738l48.736 15.366-5.122 16.246-48.736-15.366z"
  }), React.createElement("path", {
    d: "M124.037 95.29a.781.781 0 01.137-.257.81.81 0 01.215-.177.758.758 0 01.271-.08.704.704 0 01.291.03.746.746 0 01.513.634c.01.097 0 .194-.031.291a.705.705 0 01-.363.432.675.675 0 01-.269.075.709.709 0 01-.291-.03.703.703 0 01-.256-.143.66.66 0 01-.178-.215.84.84 0 01-.077-.264.801.801 0 01.038-.295zm8.034-.057l-.23-3.652a7.777 7.777 0 01.002-.822 6.393 6.393 0 01-.478.678l-2.281 2.854 2.987.942zm1.32 3.682l-.838-.264a.38.38 0 01-.212-.146.467.467 0 01-.075-.227l-.14-2.168-3.59-1.132-1.358 1.696a.408.408 0 01-.185.138.373.373 0 01-.259.005l-.837-.264 5.723-6.994 1.094.345.677 9.011zm4.571-3.095c.312.098.6.148.861.149a1.82 1.82 0 00.706-.134c.208-.09.384-.219.527-.387.142-.167.251-.369.325-.603.15-.477.107-.885-.129-1.226-.237-.34-.668-.61-1.293-.806l-1.184-.374-.953 3.021 1.14.36zm2.395 5.292l-.96-.303c-.198-.062-.319-.184-.364-.366l-1.176-3.514a.612.612 0 00-.146-.255c-.058-.064-.163-.12-.316-.167l-.821-.26-1.053 3.34-1.078-.34 2.524-8.002 2.261.713c.507.16.928.35 1.263.57.337.217.594.46.771.728.181.27.286.561.315.873.029.308-.009.632-.116.97a2.406 2.406 0 01-.384.751 2.2 2.2 0 01-.601.541 2.385 2.385 0 01-.776.302 3.17 3.17 0 01-.925.052c.113.122.196.273.25.453l1.332 3.914zm2.887-3.486a4.256 4.256 0 00-.216 1.387c.012.43.098.819.258 1.168.165.347.399.648.704.904.305.251.672.445 1.1.58.432.136.845.188 1.239.157a2.603 2.603 0 001.089-.338c.332-.194.625-.464.882-.809.257-.348.463-.768.618-1.26.155-.491.227-.953.216-1.387a2.912 2.912 0 00-.258-1.168 2.576 2.576 0 00-.696-.907 3.178 3.178 0 00-1.104-.587 3.164 3.164 0 00-1.236-.15 2.626 2.626 0 00-1.096.342c-.33.19-.624.46-.881.808a4.249 4.249 0 00-.619 1.26zm5.372 7.907l-.894-.282a1.096 1.096 0 01-.339-.168.75.75 0 01-.224-.285l-.919-1.972a4.568 4.568 0 01-1.446-.223 4.44 4.44 0 01-1.515-.803 3.805 3.805 0 01-.979-1.236 3.964 3.964 0 01-.398-1.543 4.877 4.877 0 01.237-1.743c.189-.6.457-1.119.804-1.558.348-.442.752-.79 1.212-1.042a3.774 3.774 0 011.513-.456 4.36 4.36 0 011.704.206 4.36 4.36 0 011.513.808c.424.355.752.77.983 1.243.232.47.364.987.396 1.55a4.833 4.833 0 01-.235 1.737c-.118.376-.27.721-.455 1.035a4.33 4.33 0 01-.629.845 3.941 3.941 0 01-.78.626 3.765 3.765 0 01-.9.398l1.351 2.863z",
    fill: colors.white
  })), React.createElement("g", {
    filter: "url(#filter2_d)"
  }, React.createElement("path", {
    d: "M45 30h52.621l18.944 19.645V117H45V30z",
    fill: colors.white
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.758 50.778l-17.33-17.971H47.807v81.387h65.951V50.778zM97.621 30l18.944 19.645V117H45V30h52.621z",
    fill: colors.primary
  }), React.createElement("path", {
    fill: colors.primaryLightest,
    d: "M53 52h41v6H53zm0 10h54v6H53zm0 10h54v6H53zm0 10h54v6H53zm0 10h54v6H53z"
  }), React.createElement("path", {
    d: "M116.565 93.273l9.822-5.74v15.307l-9.822 5.741V93.273z",
    fill: colors.primaryDark
  }), React.createElement("path", {
    fill: colors.primary,
    d: "M59.032 79.113h67.355v22.452H59.032z"
  }), React.createElement("path", {
    d: "M75.553 95.264c0-.134.023-.26.07-.378.051-.118.118-.221.2-.309a.991.991 0 01.31-.208.94.94 0 01.377-.077.94.94 0 01.378.077.991.991 0 01.517.517.938.938 0 01.078.378.957.957 0 01-.078.386.973.973 0 01-.208.3.891.891 0 01-.309.201.938.938 0 01-.378.078.938.938 0 01-.378-.078.891.891 0 01-.309-.2 1.101 1.101 0 01-.2-.301 1.05 1.05 0 01-.07-.386zm10.077-3.257l-1.736-4.5a9.221 9.221 0 01-.325-1.034 8.423 8.423 0 01-.332 1.042l-1.736 4.492h4.129zm3.118 4.106H87.59a.498.498 0 01-.324-.1.617.617 0 01-.185-.255l-1.034-2.67h-4.963l-1.034 2.67a.543.543 0 01-.177.247.493.493 0 01-.325.108h-1.157l4.422-11.06h1.513l4.422 11.06zm4.519-5.703c.432 0 .813-.052 1.142-.155.334-.108.612-.257.834-.447.226-.196.396-.428.509-.695a2.26 2.26 0 00.17-.888c0-.658-.216-1.155-.649-1.49-.432-.334-1.08-.5-1.944-.5h-1.637v4.174h1.575zm5.109 5.703h-1.328c-.272 0-.473-.106-.602-.317l-2.87-3.951a.797.797 0 00-.286-.262c-.098-.057-.252-.085-.463-.085h-1.135v4.615h-1.49v-11.06h3.127c.7 0 1.304.072 1.813.216.51.14.929.343 1.258.61.335.268.582.592.741.973.16.375.24.797.24 1.265 0 .391-.062.757-.186 1.096-.123.34-.303.646-.54.919a3.168 3.168 0 01-.857.687c-.334.19-.715.334-1.142.432.19.108.355.265.494.47l3.226 4.392zm2.248-5.526c0 .68.092 1.289.277 1.83.186.534.448.99.788 1.365.344.37.759.656 1.242.857a4.272 4.272 0 001.613.293c.597 0 1.137-.098 1.621-.293a3.44 3.44 0 001.235-.857c.339-.375.602-.83.787-1.366.185-.54.278-1.15.278-1.829 0-.68-.093-1.289-.278-1.83a3.833 3.833 0 00-.787-1.365 3.396 3.396 0 00-1.235-.864 4.193 4.193 0 00-1.621-.302c-.591 0-1.129.1-1.613.302a3.45 3.45 0 00-1.242.864c-.34.37-.602.826-.788 1.366-.185.54-.277 1.15-.277 1.829zm9.886 7.81h-1.235c-.185 0-.35-.025-.494-.077a.981.981 0 01-.393-.27l-1.937-2.115a5.997 5.997 0 01-1.907.294c-.813 0-1.554-.137-2.222-.41a5.029 5.029 0 01-1.722-1.165 5.238 5.238 0 01-1.11-1.782 6.415 6.415 0 01-.394-2.285c0-.828.13-1.587.393-2.277a5.222 5.222 0 011.111-1.79 4.976 4.976 0 011.722-1.173c.668-.278 1.409-.417 2.222-.417s1.554.139 2.223.417c.674.278 1.25.669 1.729 1.173a5.219 5.219 0 011.111 1.79c.262.69.394 1.449.394 2.277 0 .52-.054 1.014-.162 1.482a5.72 5.72 0 01-.456 1.312 5.14 5.14 0 01-.733 1.096 4.91 4.91 0 01-.972.856l2.832 3.064z",
    fill: colors.white
  })), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.631 24L82.816 3 59 24h14.316v20h19V24h14.315z",
    fill: colors.primary
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.816.333L111.924 26H94.316v20h-23V26H53.708L82.816.333zM73.316 24v20h19V24h14.315L82.816 3 59 24h14.316z",
    fill: colors.grayLight
  })), React.createElement("defs", null, React.createElement("filter", {
    id: "filter0_d",
    x: "-1.716",
    y: "53.357",
    width: "69.384",
    height: "72.15",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: "1.143"
  }), React.createElement("feGaussianBlur", {
    stdDeviation: "2.858"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0.25 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), React.createElement("filter", {
    id: "filter1_d",
    x: "89.415",
    y: "34.931",
    width: "82.706",
    height: "94.451",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: "1.517"
  }), React.createElement("feGaussianBlur", {
    stdDeviation: "3.793"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0.25 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), React.createElement("filter", {
    id: "filter2_d",
    x: "35",
    y: "22",
    width: "101.387",
    height: "107",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), React.createElement("feOffset", {
    dy: "2"
  }), React.createElement("feGaussianBlur", {
    stdDeviation: "5"
  }), React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0 0.243137 0 0 0 0.25 0"
  }), React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("path", {
    fill: colors.white,
    d: "M0 0h180v128H0z"
  }))));
};

function hasValidImageProps$1(_ref) {
  var src = _ref.src,
      alt = _ref.alt;
  return !!(src && alt);
}

var DescriptionContainer = function DescriptionContainer(_ref2) {
  var onButtonClick = _ref2.onButtonClick,
      description = _ref2.description,
      buttonText = _ref2.buttonText,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'large' : _ref2$variant,
      className = _ref2.className,
      _ref2$uploadImage = _ref2.uploadImage,
      uploadImage = _ref2$uploadImage === void 0 ? {
    src: '',
    alt: ''
  } : _ref2$uploadImage;
  return React.createElement(BaseDescriptionContainer, {
    "aria-label": "base-description-container",
    variant: variant,
    className: className
  }, React.createElement(UploadImageWrapper, null, hasValidImageProps$1(uploadImage) ? React.createElement("img", {
    src: uploadImage.src,
    alt: uploadImage.alt
  }) : React.createElement(UploadIcon, null)), React.createElement(DescriptionWrapper, null, React.createElement(Description$3, null, description)), React.createElement(Button, {
    variant: variant.includes('large') ? 'secondary' : 'tertiary',
    onClick: onButtonClick,
    type: "button"
  }, buttonText));
};

var UPLOAD = {
  'pt-br': {
    defaultButtonText: 'Selecionar arquivos',
    defaultDescription: 'Arraste e solte o(s) arquivo(s) no formato [INSIRA A EXTENSÃO DO ARQUIVO AQUI ex: .kml] aqui ou selecione arquivo(s) do seu dispositivo'
  },
  'en-us': {
    defaultButtonText: 'Select Files',
    defaultDescription: 'Drag and drop the file(s) in the format [INSERT FILE EXTENSION HERE eg .kml] here or select file(s) from your device'
  },
  'es-mx': {
    defaultButtonText: 'Selecciona Archivos',
    defaultDescription: 'Arrastre y suelte el (los) archivo (s) en el formato [INSERTAR LA EXTENSIÓN DEL ARCHIVO AQUÍ, por ejemplo .kml] aquí o seleccione el (los) archivo (s) de su dispositivo'
  },
  'es-co': {
    defaultButtonText: 'Selecciona Archivos',
    defaultDescription: 'Arrastre y suelte el (los) archivo (s) en el formato [INSERTAR LA EXTENSIÓN DEL ARCHIVO AQUÍ, por ejemplo .kml] aquí o seleccione el (los) archivo (s) de su dispositivo'
  }
};

function _templateObject4$s() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    max-height: ", ";\n\n    border-radius: ", ";\n    border: ", ";\n    padding: ", ";\n\n    ", "\n\n    ", "\n    ", "\n  "]);

  _templateObject4$s = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$G() {
  var data = _taggedTemplateLiteralLoose(["\n  justify-content: 'center';\n  outline: 'none';\n  height: 100%;\n  width: auto;\n\n  ", "\n"]);

  _templateObject3$G = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$Y() {
  var data = _taggedTemplateLiteralLoose(["\n  vertical-align: middle;\n  margin-left: 20px;\n"]);

  _templateObject2$Y = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1C() {
  var data = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    height: auto;\n    padding: 0px;\n  "]);

  _templateObject$1C = function _templateObject() {
    return data;
  };

  return data;
}
var stylesModifier = {
  button: function button() {
    return css(_templateObject$1C());
  }
};
var CenteredIcon = /*#__PURE__*/styled(Icon$1)( /*#__PURE__*/_templateObject2$Y());
var BaseDropzone = /*#__PURE__*/styled(Flex)( /*#__PURE__*/_templateObject3$G(), function (_ref) {
  var variant = _ref.variant,
      theme = _ref.theme;
  return css(_templateObject4$s(), variant.includes('white') || variant === 'button' ? theme.colors.white : theme.colors.grayLight, variant.includes('small') && "" + theme.space.loosest, theme.radii.m, variant.includes('white') && "1px dashed " + theme.colors.primary, variant.includes('small') ? " " + theme.space.smaller + " " + theme.space.large + " " : theme.space.large, variant === 'button' && stylesModifier.button(), space, layout);
});

var Upload = function Upload(_ref) {
  var onUploadChange = _ref.onUploadChange,
      onButtonClick = _ref.onButtonClick,
      uploadImage = _ref.uploadImage,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'large' : _ref$variant,
      uploadConfig = _ref.uploadConfig,
      description = _ref.description,
      buttonText = _ref.buttonText,
      ButtonIcon = _ref.buttonIcon,
      props = _objectWithoutPropertiesLoose(_ref, ["onUploadChange", "onButtonClick", "uploadImage", "variant", "uploadConfig", "description", "buttonText", "buttonIcon"]);

  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);

  var _useContext = useContext(PomodoroContext),
      locale = _useContext.locale;

  var onDrop = useCallback(function (acceptedFiles, rejectedFiles) {
    var mappedAcceptedFiles = acceptedFiles.map(function (acceptedFile) {
      return {
        file: acceptedFile,
        errors: []
      };
    });
    var mappedRejectedFiles = rejectedFiles.map(function (rejectedFile) {
      return _extends({}, rejectedFile);
    });
    onUploadChange === null || onUploadChange === void 0 ? void 0 : onUploadChange(mappedAcceptedFiles, mappedRejectedFiles);
  }, [onUploadChange]);

  var _useDropzone = useDropzone(_extends({
    onDrop: onDrop
  }, uploadConfig)),
      getInputProps = _useDropzone.getInputProps,
      getRootProps = _useDropzone.getRootProps;

  return React.createElement(React.Fragment, null, React.createElement(BaseDropzone, Object.assign({}, htmlProps, styledSystemProps, {
    variant: variant
  }, getRootProps()), variant === 'button' ? React.createElement(Button, {
    "area-aria-label": "button-variant",
    variant: "tertiary",
    type: "button"
  }, React.createElement("span", null, buttonText || UPLOAD[locale].defaultButtonText), ButtonIcon && React.createElement(CenteredIcon, {
    component: ButtonIcon,
    size: "s"
  })) : React.createElement(DescriptionContainer, {
    description: description || UPLOAD[locale].defaultDescription,
    buttonText: buttonText || UPLOAD[locale].defaultButtonText,
    variant: variant,
    uploadImage: uploadImage,
    onButtonClick: onButtonClick
  }), React.createElement("input", Object.assign({}, getInputProps()))));
};

function _templateObject4$t() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  &::-webkit-scrollbar {\n    width: 0.5em;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ", ";\n    border-radius: ", ";\n  }\n\n  padding: 0;\n  overflow: auto;\n  resize: none;\n  cursor: auto;\n"]);

  _templateObject4$t = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$H() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject3$H = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$Z() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2$Z = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1D() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  display: flex;\n  align-items: baseline;\n\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  ", "\n\n  ", ";\n\n  ", "\n  ", "\n"]);

  _templateObject$1D = function _templateObject() {
    return data;
  };

  return data;
}
var VisibleTextArea = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1D(), TextInputStyle, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.theme.space.smaller;
}, function (props) {
  return props.error ? ErrorStyle : css(_templateObject2$Z());
}, function (props) {
  return props.disabled ? DisabledStyle : css(_templateObject3$H());
}, space, layout);
var InvisibleTextArea = /*#__PURE__*/styled.textarea( /*#__PURE__*/_templateObject4$t(), TextInputResetStyle, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.gray;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.smallest;
});
var TextArea = /*#__PURE__*/forwardRef(function (props, ref) {
  var innerRef = useShareForwardedRef(ref);
  var styledSystemProps = pick(props);
  var htmlProps = pickHTMLProps(props);
  var elementId = htmlProps.id ? htmlProps.id : htmlProps.name;
  return React.createElement(FormElement, Object.assign({
    id: elementId,
    error: props.error,
    label: props.label,
    disabled: props.disabled,
    elementRef: innerRef,
    showCounter: props.showCounter
  }, styledSystemProps), React.createElement(VisibleTextArea, {
    error: props.error,
    disabled: props.disabled
  }, React.createElement(InvisibleTextArea, Object.assign({}, htmlProps, {
    id: elementId,
    ref: innerRef,
    "aria-invalid": Boolean(props.error)
  })), props.error ? React.createElement(FormElementIcons, {
    error: props.error
  }) : null));
});
TextArea.propTypes = {
  error: PropTypes__default.string,
  name: PropTypes__default.string,
  label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  disabled: PropTypes__default.bool,
  showCounter: PropTypes__default.bool
};

function _templateObject4$u() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    + ", " {\n      &:before {\n        width: ", ";\n        height: ", ";\n        background-color: ", ";\n        border-color: ", ";\n        top: -1px;\n        left: -1px;\n      }\n    }\n  }\n\n  &:checked {\n    + ", " {\n      border-color: ", ";\n      background-color: ", ";\n\n      &:before {\n        transform: ", ";\n      }\n    }\n  }\n\n  &:disabled {\n    cursor: default;\n\n    + ", " {\n      border-color: ", ";\n      background-color: ", ";\n\n      &:before {\n        background-color: ", ";\n      }\n    }\n  }\n\n  &:focus {\n    + ", " {\n      outline: none;\n      box-shadow: ", ";\n    }\n  }\n"]);

  _templateObject4$u = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$I() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 1px;\n  background-color: ", ";\n  border-radius: ", ";\n  transition: ", ";\n  pointer-events: none;\n\n  &:before {\n    position: absolute;\n    content: '';\n    top: 1px;\n    left: 1px;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n\n    transition: ", ";\n    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 2px 4px rgba(0, 0, 0, 0.06);\n    border: 1px solid rgba(0, 0, 0, 0.04);\n    box-sizing: content-box;\n  }\n"]);

  _templateObject3$I = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$_() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject2$_ = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1E() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: ", ";\n  height: ", ";\n\n  ", ";\n\n  ", "\n  ", "\n"]);

  _templateObject$1E = function _templateObject() {
    return data;
  };

  return data;
}
var Container$o = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1E(), function (props) {
  return props.theme.space.largest;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.disabled ? DisabledStyle : css(_templateObject2$_());
}, space, layout);
var Switch = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject3$I(), function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return "calc(" + props.theme.space.large + "/2)";
}, function (_ref) {
  var _ref$theme = _ref.theme,
      durations = _ref$theme.durations,
      timingFunctions = _ref$theme.timingFunctions;
  return mountTransition([['background-color', durations.slowly, timingFunctions.easeInOut]]);
}, function (props) {
  return "calc(" + props.theme.space.large + " - 4px)";
}, function (props) {
  return "calc(" + props.theme.space.large + " - 4px)";
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.radii.l;
}, function (_ref2) {
  var _ref2$theme = _ref2.theme,
      durations = _ref2$theme.durations,
      timingFunctions = _ref2$theme.timingFunctions;
  return mountTransition([['transform', durations.slowly, timingFunctions.easeInOut]]);
});
var Input$6 = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject4$u(), Switch, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.colors.primaryLightest;
}, function (props) {
  return props.theme.colors.primary;
}, Switch, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return " translateX(" + props.theme.space.largest + ")   translateX(-" + props.theme.space.large + ")";
}, Switch, function (props) {
  return props.theme.colors.grayLight;
}, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.gray;
}, Switch, function (props) {
  return props.theme.shadows.focus;
});
var Toggle = /*#__PURE__*/forwardRef(function (props, ref) {
  var styledSystemProps = pick(props);

  var _pickHTMLProps = pickHTMLProps(props),
      dataTestId = _pickHTMLProps['data-testid'],
      htmlProps = _objectWithoutPropertiesLoose(_pickHTMLProps, ["data-testid"]);

  var forwardedRef = useShareForwardedRef(ref);
  var onClickHandler = useCallback(function () {
    var _forwardedRef$current;

    forwardedRef === null || forwardedRef === void 0 ? void 0 : (_forwardedRef$current = forwardedRef.current) === null || _forwardedRef$current === void 0 ? void 0 : _forwardedRef$current.click();
  }, [forwardedRef]);
  var elementId = htmlProps.id ? htmlProps.id : htmlProps.name;
  return React.createElement(FormElement, Object.assign({}, styledSystemProps, {
    "data-testid": dataTestId,
    id: elementId,
    label: props.label
  }), React.createElement(Container$o, null, React.createElement(Input$6, Object.assign({}, htmlProps, {
    ref: forwardedRef,
    type: "checkbox",
    id: elementId
  })), React.createElement(Switch, {
    onClick: onClickHandler
  })));
});
Toggle.propTypes = {
  name: PropTypes__default.string,
  label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.element]),
  disabled: PropTypes__default.bool
};

function _templateObject$1F() {
  var data = _taggedTemplateLiteralLoose(["\n  display: grid;\n\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject$1F = function _templateObject() {
    return data;
  };

  return data;
}
var Grid = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1F(), grid, layout, space);

export { ActionSheet, ActionSheetButton, Alert, Button, Card, CardSelect, CharCounter, Checkbox, Collapse, ContextualAlert, Counter$1 as Counter, DatePicker, Dialog, DisabledStyle, DisabledText, Divider, Drawer, EmptyState, ErrorLabel, ErrorStyle, Flex, FormElement, FormElementIcons, Grid, Heading, Icon$1 as Icon, Input$2 as Input, Label, LinkText, List, Listbox, ListboxOption, Loading$1 as Loading, MultiSelect, Pagination, PomodoroProvider, Popover, Radio$1 as Radio, RangePicker, Search, Segment, Select, Slider$1 as Slider, StarRating, Stepper, Table, Tabs, Tag, Text, TextArea, TextInputResetStyle, TextInputStyle, Toggle, Tooltip, Upload, filledColor, mountTransition, snackbar, useCharCounter };
//# sourceMappingURL=pomodoro-components.esm.js.map
